/* Fest Flags cart cards: quantity stepper + "Design help quantity" stepper + "Delete entire flag".
   One request changes the flag line AND its add-on lines together (data-ff-keys), then re-renders the drawer (and, on the
   /cart page, the page's own cards + order summary) from Shopify's section HTML, so prices and savings always come from
   Shopify, never from maths done here. Also: opens the drawer after Add to cart when Infinite Options ends its add-on posts
   with a jQuery-triggered form submit (see hookProductForms). Step 4: in-card edit of the design-team note (see noteAction).
   Step 5: keyboard focus survives every redraw, Dawn's drawer focus trap is re-armed, Escape in a note = Cancel, and a status
   region says what changed (see "Keyboard + screen reader"). Step 6: "Delete entire flag" asks first (see deleteAsk), and the
   drawer's card list keeps its scroll position through both redraws (see keepDrawerScroll). Slice C: long notes show 3 lines
   (6 in slice C) with a "Show all" toggle (see markLongNotes). v23 / v24: the "Change or remove" pill opens a drop-down that the
   pill, Escape or any click outside it closes (see crToggle). Slice D: Add to cart shows its wait from the first click (see
   watchSlowAdd) and "Start this flag over" brings the note + Needed-by date to the product page (see carryOver / carryIn).
   F1 fix (go-live prep): the drawer's artwork thumbnails carry data-ff-src and only get their src when the drawer opens (see
   hydrateArt), so the customer's full print files are not downloaded on every page view. Cart edit C1 (2026-10-07): design help
   Edit -> Save / Cancel on each flag card (see "Cart edit, slice C1"). F1c: ONE "Edit this flag" button per flag card
   (see "One Edit button, slice F1c"). Compact cart (2026-10-20, mockup v9): the "Change or remove" pill is ONE "Change" button whose
   panel is a sheet holding the strip, Start over, Delete and the Edit controls (see "Compact cart sheet"); no cart write changed. */
(function () {
  if (window.__ffCartBound) return;
  window.__ffCartBound = true;

  function showError(scope, message) {
    /* after a re-render the old cards are detached; always write to the box that is on the page */
    var box = (scope && scope.isConnected && scope.querySelector('[data-ff-error]'))
      || document.querySelector('#main-cart-items [data-ff-error]')
      || document.querySelector('[data-ff-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
    console.error('[ff-cart] ' + message);
  }

  function sectionHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  /* Next-tier promises ("Add 1 more for 13% off") are only shown for lines on Kaching deal 3ti5,
     the deal the fixed 9/13/15/17 table was read from. Anything else stays hidden. */
  /* Flicker fix (Todd 2026-09-24, "whenever you add a flag, it kind of flickers"): every + / Add 1 more redraws the cards twice
     (ours, then Dawn's re-fetch), each time with the promises hidden, and this check showed them again ~130 ms later, so the
     meter + "Add 1 more" blinked out twice. dealVariants remembers the variants just confirmed on 3ti5 (by variant id, since
     Kaching re-keys the line when its tier changes), and showKnownDeals() shows them again in the same task as the redraw (the
     MutationObserver below runs before paint). The /cart.js check still runs after every redraw and hides anything it no longer
     confirms. In memory only: a fresh page starts hidden, as before. */
  /* Audit corrective pass (2026-09-24): fail CLOSED. dealVariants[variant] = how many flag lines of that variant the last good
     answer had, all on the deal (false if any was not). A card is shown early only if its root (drawer or /cart page) shows exactly
     that many cards of the variant, so a new line of the same variant is never promised before the check has seen it. Answers are
     applied in order (checkSeq); a failed check hides every promise and forgets everything, as before this fix. */
  var dealVariants = {};
  var checkSeq = 0;
  var appliedSeq = 0;
  function lineVariant(key) { return String(key || '').split(':')[0]; }
  function holderKey(holder) { return holder.getAttribute('data-ff-keys').split(',')[0]; }
  function showKnownDeals() {
    var counts = new Map();
    var holders = Array.prototype.slice.call(document.querySelectorAll('[data-ff-keys]'));
    holders.forEach(function (holder) {
      var root = holder.closest('cart-drawer, cart-items') || document.body;
      var id = lineVariant(holderKey(holder));
      if (!counts.has(root)) counts.set(root, {});
      counts.get(root)[id] = (counts.get(root)[id] || 0) + 1;
    });
    holders.forEach(function (holder) {
      var id = lineVariant(holderKey(holder));
      var root = holder.closest('cart-drawer, cart-items') || document.body;
      if (!dealVariants[id] || counts.get(root)[id] !== dealVariants[id]) return;
      holder.querySelectorAll('[data-ff-next][hidden]').forEach(function (node) { node.hidden = false; });
    });
  }

  function revealNextTier() {
    var seq = ++checkSeq;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-ff-next]').forEach(function (node) { node.setAttribute('data-ff-checked', ''); });
        if (seq < appliedSeq) return; /* an older answer arriving after a newer one: ignore it */
        appliedSeq = seq;
        var lineOnDeal = {};
        var known = {};
        cart.items.forEach(function (item) {
          var bundle = (item.properties && item.properties.__kaching_bundles) || '';
          var variant = lineVariant(item.key);
          var on = bundle.indexOf('"deal":"3ti5"') !== -1;
          lineOnDeal[item.key] = on;
          /* early show only when EVERY line of that variant is on the deal; remember how many there are */
          known[variant] = on && known[variant] !== false ? (known[variant] || 0) + 1 : false;
        });
        dealVariants = known;
        /* a card whose line is in this answer shows its promises only if that line is on the deal (so an early show is taken
           back); a card whose key is not in it (redrawn again meanwhile) is left alone: that redraw scheduled a newer check. */
        document.querySelectorAll('[data-ff-keys]').forEach(function (holder) {
          var key = holderKey(holder);
          if (!(key in lineOnDeal)) return;
          holder.querySelectorAll('[data-ff-next]').forEach(function (node) { node.hidden = !lineOnDeal[key]; });
        });
        try { holdAnchor(); } catch (error) { console.error('[ff-cart] scroll anchor failed: ' + error.message); }
      })
      .catch(function (error) {
        /* mark them checked anyway, or every later drawer change would fetch /cart.js again; fail closed: hide every promise */
        document.querySelectorAll('[data-ff-next]').forEach(function (node) { node.setAttribute('data-ff-checked', ''); });
        if (seq >= appliedSeq) {
          appliedSeq = seq;
          dealVariants = {};
          document.querySelectorAll('[data-ff-next]').forEach(function (node) { node.hidden = true; });
          try { holdAnchor(); } catch (error) { console.error('[ff-cart] scroll anchor failed: ' + error.message); }
        }
        console.error('[ff-cart] next-tier check failed: ' + error.message);
      });
  }

  /* The /cart page (sections/main-cart-items.liquid + main-cart-footer.liquid) is present only on /cart; the drawer is on every
     page. Its sections live in templates/cart.json, so the Section Rendering API needs their template ids
     (data-id = "template--<n>__cart-items"), exactly as Dawn's cart.js requests them; the filename alone would render the
     footer with no blocks. */
  function pageSectionIds() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items || !footer || !items.dataset.id || !footer.dataset.id) return null;
    return { items: items.dataset.id, footer: footer.dataset.id };
  }

  function pageSections() {
    var ids = pageSectionIds();
    return ids ? [ids.items, ids.footer] : [];
  }

  function renderDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    var target = document.getElementById('CartDrawer');
    if (!drawer || !target || !state.sections || !state.sections['cart-drawer']) return false;
    var inner = sectionHTML(state.sections['cart-drawer'], '#CartDrawer');
    if (inner === null) return false;
    /* Navidium (Shipping Protection) fills .nvd-mini itself and only rebuilds it after clicks on Dawn's own buttons,
       never ours. Carry its live box across the redraw so it cannot vanish; refreshNavidium() then updates the fee. */
    var keepNvd = state.item_count > 0 ? target.querySelector('.nvd-mini') : null;
    if (keepNvd && !keepNvd.innerHTML.length) keepNvd = null;
    target.innerHTML = inner;
    if (keepNvd) {
      var slot = target.querySelector('.nvd-mini');
      if (slot) slot.replaceWith(keepNvd);
    }
    drawer.classList.toggle('is-empty', state.item_count === 0);
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    return true;
  }

  /* /cart page: swap the .js-contents of both sections (the same nodes Dawn's cart.js swaps), keep Navidium's box and
     the Check out button (both sit outside .js-contents), and toggle the empty state the way Dawn does. */
  function renderPage(state) {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items || !footer) return true;
    var ids = pageSectionIds();
    if (!ids || !state.sections || !state.sections[ids.items] || !state.sections[ids.footer]) return false;
    var itemsHTML = sectionHTML(state.sections[ids.items], '#main-cart-items .js-contents');
    var footerHTML = sectionHTML(state.sections[ids.footer], '#main-cart-footer .js-contents');
    var itemsTarget = items.querySelector('.js-contents');
    var footerTarget = footer.querySelector('.js-contents');
    if (itemsHTML === null || footerHTML === null || !itemsTarget || !footerTarget) return false;
    itemsTarget.innerHTML = itemsHTML;
    footerTarget.innerHTML = footerHTML;
    var empty = state.item_count === 0;
    var cartItems = items.closest('cart-items');
    if (cartItems) cartItems.classList.toggle('is-empty', empty);
    footer.classList.toggle('is-empty', empty);
    var checkout = document.getElementById('checkout');
    if (checkout) checkout.disabled = empty;
    return true;
  }

  /* Returns false when the cards could not be redrawn from Shopify's HTML (the cart itself HAS changed by then). */
  function render(state) {
    edNoteCart(state);
    var drawerDrawn = false;
    try { drawerDrawn = renderDrawer(state); } catch (error) { console.error('[ff-cart] drawer redraw failed: ' + error.message); }
    var pageDrawn = false;
    try { pageDrawn = renderPage(state); } catch (error) { console.error('[ff-cart] page redraw failed: ' + error.message); }
    try { crReopen(); } catch (error) { console.error('[ff-cart] could not reopen the Change sheet: ' + error.message); }
    return drawerDrawn && pageDrawn;
  }

  /* Ask Navidium to recalculate its fee and re-write the subtotal, the way it does 2 s after a Dawn quantity click
     (nvd_init + updateLiveCart are Navidium's globals). Waits for Dawn's own re-fetch of the totals to land first. */
  var nvdTimer = null;
  function refreshNavidium() {
    if (!document.querySelector('.nvd-mini')) return;
    clearTimeout(nvdTimer);
    nvdTimer = setTimeout(function () {
      if (typeof nvd_init !== 'function') {
        console.error('[ff-cart] Navidium nvd_init() not found: Shipping Protection may show an old fee until the page reloads.');
        return;
      }
      Promise.resolve(nvd_init())
        .then(function () { if (typeof updateLiveCart === 'function') return updateLiveCart(); })
        .catch(function (error) { console.error('[ff-cart] Navidium refresh failed: ' + error.message); });
    }, 1500);
  }

  /* Compact cart (2026-10-20, Todd's direction: no "USD" in the cart). Navidium writes its fee as "$1.50 USD" (and may re-write
     the Subtotal the same way when it refreshes): show "$1.50". Display only: a trailing " USD" is cut from the text of
     Navidium's price and the Subtotal value; Navidium's markup, switch and fee are untouched (its switch passes the fee as an
     argument, never this text). Checked once per frame after any page change, only while one of those boxes is on the page. */
  var USD_SEL = '.nvd-mini .shipping-protection-price-ld, .totals__total-value';
  function usdTrim() {
    document.querySelectorAll(USD_SEL).forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent;
      var trimmed = text.replace(/\s*USD\s*$/, '');
      if (trimmed !== text) el.textContent = trimmed;
    });
  }
  (function () {
    if (typeof MutationObserver === 'undefined') return;
    var queued = false;
    function run() {
      if (!queued) return;
      queued = false;
      try { usdTrim(); } catch (error) { console.error('[ff-cart] USD trim failed: ' + error.message); }
    }
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      /* before the next paint; the timer covers a tab that is not drawing (no animation frames) */
      requestAnimationFrame(run);
      setTimeout(run, 150);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  })();

  /* Everything after the cards are redrawn. A failure here must never tell the customer the update failed. */
  function afterRender(state) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && state.sections && state.sections['cart-icon-bubble']) {
      var bubbleHTML = sectionHTML(state.sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
    }
    revealNextTier();
    refreshNavidium();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ff-cart', cartData: state });
    }
  }

  /* Dawn's <cart-drawer-items> re-fetches and replaces the cards after every cartUpdate event (and after Add to cart),
     which drops the revealed text. Watch the drawer for replaced content and reveal again. Only childList is watched,
     so toggling [hidden] here cannot re-trigger it. */
  function watchDrawer() {
    revealNextTier();
    hydrateArt();
    if (typeof MutationObserver === 'undefined') return;
    var timer = null;
    var observer = new MutationObserver(function (records) {
      try { carryArt(records); } catch (error) { console.error('[ff-cart] could not keep the loaded pictures across the redraw: ' + error.message); }
      showKnownDeals();
      try { crReopen(); } catch (error) { console.error('[ff-cart] could not reopen the Change sheet: ' + error.message); }
      hydrateArt();
      /* (d) before the scroll is kept below, so it measures the cards with their controls already on */
      try { edFastScan(); } catch (error) { console.warn('[ff-cart] early card controls skipped: ' + error.message); }
      settleWatch();
      /* Dawn's own re-fetch (after our cartUpdate) replaces the cards a second time: put focus back again (step 5) */
      /* before paint, so the list never shows at the top first */
      if (Date.now() - writeAt < 10000) keepDrawerScroll();
      try { holdAnchor(); } catch (error) { console.error('[ff-cart] scroll anchor failed: ' + error.message); }
      scheduleNoteCheck();
      edScan();
      if (lastFocus && Date.now() - writeAt < 10000) {
        clearTimeout(focusTimer);
        focusTimer = setTimeout(function () { restoreFocus(false); }, 30);
      }
      /* other apps (Navidium) also change the drawer; only look again when new, unchecked cards arrived */
      if (!document.querySelector('[data-ff-next]:not([data-ff-checked])')) return;
      clearTimeout(timer);
      timer = setTimeout(revealNextTier, 150);
    });
    /* the /cart page's <cart-items> is replaced whole by Dawn's cart.js after every cartUpdate, so watch it as well */
    ['cart-drawer', 'cart-items'].forEach(function (tag) {
      var node = document.querySelector(tag);
      if (node) observer.observe(node, { childList: true, subtree: true });
    });
    /* F1 fix: the drawer opens by getting the class "active" (Dawn's open()); that is the moment its thumbnails may load */
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function () {
      hydrateArt();
      edScan();
      if (!drawer.classList.contains('active')) { try { crSheetsDrawerClosed(); } catch (error) { console.error('[ff-cart] could not close the Change sheet with the drawer: ' + error.message); } }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Fix build (d), Todd 2026-10-09: "a lot of weird flickers whenever things get moved up and down in quantity or you change
     graphics ... Is there any way we can smooth out the animation there?" Every cart change redraws the cards from Shopify's
     HTML (ours, then Dawn's re-fetch), so every picture came back as a brand-new, empty <img> and loaded again (measured: 3
     picture nodes replaced per + tap). Before paint (this runs in the redraw's MutationObserver), a new <img> whose link is
     exactly the link of a picture that was just removed AND had finished loading is swapped for that loaded picture, so it never
     blanks. Only exact link matches; the new node's class / alt / sizes / width / height are copied onto the kept one. Anything
     unmatched loads as before (hydrateArt). Display only: no request. */
  var ART_KEEP_ATTRS = ['class', 'alt', 'width', 'height', 'sizes', 'loading', 'style'];
  function artLink(img) {
    return img.getAttribute('data-ff-src') || img.getAttribute('src') || '';
  }
  /* the swap below is itself a DOM change the observer sees once (the new node out, the kept one in): those two nodes are
     marked and skipped on that one pass, else a picture that is already "complete" (cached) swaps back and forth forever
     (crashed the tab in the 2026-10-10 Chromium measure) */
  var artCarried = typeof WeakSet === 'function' ? new WeakSet() : null;
  function carryArt(records) {
    if (!artCarried) return;
    var kept = {};
    var n = 0;
    records.forEach(function (rec) {
      rec.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var imgs = node.tagName === 'IMG' ? [node] : node.querySelectorAll('img');
        for (var k = 0; k < imgs.length; k++) {
          var img = imgs[k], url = img.getAttribute('src') || '';
          if (artCarried.has(img)) { artCarried.delete(img); continue; }
          if (url && img.complete && img.naturalWidth > 0 && !img.isConnected && !kept[url]) { kept[url] = img; n++; }
        }
      });
    });
    /* no early exit when nothing was kept: this pass must still clear the marks of the swap before */
    records.forEach(function (rec) {
      rec.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1 || !node.isConnected) return;
        var imgs = node.tagName === 'IMG' ? [node] : node.querySelectorAll('img');
        for (var k = 0; k < imgs.length; k++) {
          var fresh = imgs[k];
          if (artCarried.has(fresh)) { artCarried.delete(fresh); continue; }
          var old = n ? kept[artLink(fresh)] : null;
          if (!old || old === fresh || old.isConnected) continue;
          if ((fresh.getAttribute('srcset') || '') !== (old.getAttribute('srcset') || '')) continue;
          ART_KEEP_ATTRS.forEach(function (a) {
            if (fresh.hasAttribute(a)) old.setAttribute(a, fresh.getAttribute(a)); else old.removeAttribute(a);
          });
          artCarried.add(fresh);
          artCarried.add(old);
          fresh.replaceWith(old);
          delete kept[artLink(fresh)];
        }
      });
    });
  }

  /* F1 fix (2026-09-23, measured in headless Chrome before go-live): the drawer is on every page, only visibility:hidden and
     translated just off the right edge, which is inside the browser's lazy-loading margin, so loading="lazy" did not stop a
     cart's full print files (30 MB in the measured cart) from downloading on every page view. The drawer's cards therefore
     render their thumbnails with data-ff-src (snippets/ff-cart-drawer.liquid passes deferred_art: true) and this turns it into
     src once the drawer is open: called at start, when the drawer's class changes (open) and after every redraw of its
     contents (the observer above), so a card redrawn while the drawer is open shows its artwork too. The /cart page's own
     cards keep a real src (a visible page, lazy loading works there). An image the browser cannot decode still removes
     itself (onerror) and the file-type tile stays. Idempotent: an <img> loses data-ff-src the moment it gets src. */
  function hydrateArt() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    drawer.querySelectorAll('img[data-ff-src]').forEach(function (img) {
      /* compact cart: a closed Change sheet's thumbnails load when it opens (crSheetOpen calls this again) */
      if (img.closest('.ffc-sheet[hidden]')) return;
      var url = img.getAttribute('data-ff-src') || '';
      img.removeAttribute('data-ff-src');
      if (url.slice(0, 8).toLowerCase() === 'https://') img.setAttribute('src', url);
      else img.remove();
    });
  }

  /* Add to cart -> drawer. Dawn's product-form.js listens for the form's submit EVENT and adds by fetch, then opens the
     drawer. Infinite Options takes the button click first (stopImmediatePropagation), posts each paid add-on line to
     /cart/add.js, then ends with jQuery's trigger('submit') on the form. jQuery's trigger fires no submit event: it calls
     the form's onsubmit PROPERTY handler, then the native form.submit() = a full-page POST to /cart/add, which lands on
     the /cart page (read live 2026-09-22). So: an onsubmit handler that, for that jQuery-triggered call only
     (event.isTrigger), runs Dawn's own add-by-fetch and returns false, which makes jQuery skip the native submit.
     A real submit event (a flag with no paid add-on never enters Infinite Options' add-on flow, or Enter in the form)
     carries no isTrigger flag: this handler returns undefined and Dawn's listener handles it as today, once.
     If anything here is missing (no drawer, no product-form, an exception), the handler returns undefined and the
     page falls back to the full-page POST as before: the /cart page, now with the same cards. */
  function hookProductForms() {
    document.querySelectorAll('product-form form[action$="/cart/add"]').forEach(function (form) {
      if (form.onsubmit) return; /* another script's handler: leave it alone */
      form.onsubmit = function (event) {
        if (!event || !event.isTrigger) return;
        var productForm = form.closest('product-form');
        if (!productForm || typeof productForm.onSubmitHandler !== 'function' || !document.querySelector('cart-drawer')) return;
        var button = productForm.submitButton || form.querySelector('[type="submit"]');
        if (button && button.getAttribute('aria-disabled') === 'true') {
          /* an add is already in flight (Dawn's own guard); a native POST now would add the flag twice */
          console.error('[ff-cart] Add to cart ignored: the previous add is still running.');
          return false;
        }
        try {
          productForm.onSubmitHandler({ preventDefault: function () {} });
        } catch (error) {
          console.error('[ff-cart] drawer add failed, falling back to the cart page: ' + error.message);
          return;
        }
        return false;
      };
    });
  }

  /* After Dawn's own Add-to-cart redraw (renderContents rewrites #CartDrawer, which empties Navidium's box), let Navidium
     rebuild its box and the fee; revealNextTier() runs from the observer above. */
  function watchAddToCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') refreshNavidium();
    });
  }

  /* Slice D (b), Todd 2026-09-22 "faster Add to cart". Measured 2026-09-23 on the preview (Custom Motorcycle Flags, two paid
     add-ons, one real click): NOTHING on screen for 1.5 s while Infinite Options posts each paid add-on to /cart/add.js one
     after the other (~0.75 s each), then Dawn's spinner, then the drawer at 2.3 s. Each extra paid add-on adds ~0.75 s. This
     does not make the add faster; it shows the wait from the first click. Infinite Options posts with its own jQuery
     (Shoppad.$.post), whose global 'ajaxSend' fires synchronously inside the click, so we know the moment it starts an add:
     the button gets Dawn's own spinner and the drawer opens with an "Adding merchandise to your cart…" line (Todd 2026-09-24; was "Adding your flag…") (Dawn's redraw of #CartDrawer
     removes it; Dawn clears its spinner itself). While an add runs, another click on Add to cart is stopped before Infinite
     Options sees it (it would post the add-ons a second time). It ends on Dawn's cartUpdate or cartError from the product
     form, on an add-on Shopify refuses (422: Infinite Options shows its own alert), or after 15 s with no progress; every
     failure logs a console error, clears our spinner (unless Dawn's add is running) and closes the drawer so the product
     page's own message shows. A flag with no paid add-on never enters Infinite Options' flow: Dawn's spinner starts at once,
     as before, and nothing here runs. We never set aria-disabled (Dawn and hookProductForms read it as "add in flight").
     Corrective pass (audit REJECT 2026-09-23): while the line shows, everything in the drawer under it is `inert` (and
     Check out disabled too, for browsers without inert), so nobody can check out or change the old cards halfway through
     an add (add-ons posted, flag not yet); the overlay still closes the drawer. Dawn's redraw brings fresh, live nodes;
     a failure puts the old ones back. After a successful add, focus is put back inside the redrawn drawer (Dawn's second
     open() does not re-trap it). If Dawn's own add ends (aria-disabled removed) with no cartUpdate / cartError, the wait
     ends within 0.3 s instead of the 15 s watchdog; the watchdog also restarts when Dawn's add begins. */
  var adding = null;
  var addClick = { at: 0, button: null };
  function addWatch() {
    if (!adding) return;
    clearTimeout(adding.timer);
    adding.timer = setTimeout(function () { addEnd(false, 'no answer for 15 s'); }, 15000);
  }
  function addStart(button) {
    if (settling) settleEnd();
    adding = { button: button, timer: 0, inert: [], checkout: null, dawn: false, watch: null };
    adding.watch = new MutationObserver(function () {
      if (!adding || adding.button !== button) return;
      if (button.getAttribute('aria-disabled') === 'true') {
        if (!adding.dawn) {
          adding.dawn = true;
          addWatch();
        }
        return;
      }
      if (!adding.dawn) return;
      setTimeout(function () {
        if (adding && adding.button === button && button.getAttribute('aria-disabled') !== 'true') addEnd(false, "Dawn's add ended with no answer (network error or a reply that was not JSON)");
      }, 300);
    });
    adding.watch.observe(button, { attributes: true, attributeFilter: ['aria-disabled'] });
    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    addWatch();
    var drawer = document.querySelector('cart-drawer');
    var inner = drawer && drawer.querySelector('.drawer__inner');
    if (!inner || typeof drawer.open !== 'function') return;
    adding.line = inner.querySelector('.ff-adding');
    if (!adding.line) {
      adding.line = addingLine(false);
      inner.insertBefore(adding.line, inner.firstChild);
    }
    Array.prototype.forEach.call(inner.children, function (node) {
      if (node.classList.contains('ff-adding') || node.hasAttribute('inert')) return;
      node.setAttribute('inert', '');
      adding.inert.push(node);
    });
    var checkout = document.getElementById('CartDrawer-Checkout');
    if (checkout && !checkout.disabled) {
      checkout.disabled = true;
      adding.checkout = checkout;
    }
    drawer.classList.add('ff-is-adding');
    try {
      drawer.open(button);
    } catch (error) {
      console.error('[ff-cart] could not open the drawer early: ' + error.message);
    }
  }
  function addEnd(ok, why) {
    if (!adding) return;
    var button = adding.button;
    var was = adding;
    clearTimeout(adding.timer);
    if (adding.watch) adding.watch.disconnect();
    adding = null;
    /* the old nodes are gone after Dawn's redraw; on a failure they are still here and must come back to life */
    was.inert.forEach(function (node) { node.removeAttribute('inert'); });
    if (was.checkout) was.checkout.disabled = false;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (!ok) {
        drawer.classList.remove('ff-is-adding');
        drawer.querySelectorAll('.ff-adding').forEach(function (node) { node.remove(); });
      }
      /* Focus fix (audit #2, 2026-09-23): Dawn's product form records document.activeElement when it submits, which by
         then is the OLD .drawer__inner (our early open had already trapped focus there). That node is gone after Dawn's
         redraw, so close() sent focus to <body>. Every outcome now ends with close() returning focus to Add to cart. */
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
    }
    if (ok) {
      /* phone fix (slice C): the panel stays "Adding your flag…" until Dawn's two redraws have landed, see settleWatch */
      settleStart(was.line);
      /* Dawn opens the redrawn drawer in a setTimeout (renderContents → open()). That open() arms a once-only transitionend
         listener on the drawer that no transition will ever fire (the drawer was already open), so the first bubbling
         transitionend from a button inside it would use the listener up and yank focus (audit #2). Fire it now ourselves:
         it traps focus on the redrawn drawer, Dawn's own way. If it was already used, fall back to our own re-arm. */
      setTimeout(function () {
        var open = document.querySelector('cart-drawer.active');
        if (!open) return;
        open.dispatchEvent(new Event('transitionend'));
        if (!open.contains(document.activeElement)) rearmDrawerTrap(null);
      }, 60);
      return;
    }
    console.error('[ff-cart] Add to cart did not finish: ' + why);
    if (button.getAttribute('aria-disabled') !== 'true') {
      button.classList.remove('loading');
      var spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
    if (drawer && typeof drawer.close === 'function' && drawer.classList.contains('active')) drawer.close();
  }
  /* Phone fix, slice C (2026-09-23, Todd on his phone: "the drawer flickers when it comes out"). Measured on the copy (phone
     emulation, one real add, scratchpad flicker-before/): 80 ms the drawer opens with the navy line over the OLD contents (or
     the empty-cart panel); 2147 ms Dawn's renderContents swaps in a brand-new .drawer__inner with the card; 2344 ms Dawn's
     own re-fetch replaces the card list a second time; 2453 ms Navidium rewrites the total. Four visible states in 0.3 s.
     Now, while <cart-drawer> carries ff-is-adding, CSS keeps everything in the panel but the line invisible; the line is put
     back (visual only) after each redraw; and the panel is shown once, with a short fade, 250 ms after Dawn's re-fetch has
     landed. If that re-fetch never comes: 1.5 s after Dawn's first redraw. At the latest 5 s after the add finished.
     Invisible is also unclickable, so the fresh Check out cannot be hit before the cart has settled. Failures are unchanged
     (line removed at once, drawer closed). */
  var settling = null;
  function addingLine(visualOnly) {
    var line = document.createElement('p');
    line.className = 'ff-adding';
    if (visualOnly) line.setAttribute('aria-hidden', 'true');
    else line.setAttribute('role', 'status');
    /* phone polish (2026-09-23): the shop's emblem (settings.favicon via data-ff-emblem on <cart-drawer>) on a tile, a mint
       ring turning around it, the text under it; the state fills the panel (CSS .ff-adding). No emblem, or it fails to
       load: the ring alone. The URL comes from Liquid's image_url, never from the cart, so it goes in as an attribute. */
    var drawer = document.querySelector('cart-drawer');
    var emblem = drawer ? (drawer.getAttribute('data-ff-emblem') || '') : '';
    var emblemAlt = drawer ? (drawer.getAttribute('data-ff-emblem-alt') || '') : '';
    var em = document.createElement('span');
    em.className = 'ff-adding-em';
    em.setAttribute('aria-hidden', 'true');
    var urlOk = /^(https:)?\/\//; /* Liquid's file_url / image_url give protocol-relative //festflags.com/cdn/... URLs */
    if (!urlOk.test(emblem)) { emblem = emblemAlt; emblemAlt = ''; }
    if (urlOk.test(emblem)) {
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.onerror = function () {
        /* the 134 px emblem file gone: the theme favicon once, then nothing (the ring stays) */
        if (urlOk.test(emblemAlt)) { img.src = emblemAlt; emblemAlt = ''; return; }
        img.remove();
      };
      img.src = emblem;
      em.appendChild(img);
    }
    var ring = document.createElement('span');
    ring.className = 'ff-adding-sp';
    em.appendChild(ring);
    line.appendChild(em);
    line.appendChild(document.createTextNode('Adding merchandise to your cart…'));
    return line;
  }
  function settleStart(line) {
    if (settling) clearTimeout(settling.timer);
    settling = { line: line, redrawn: 0, items: null, refetched: false, timer: setTimeout(settleEnd, 5000) };
    settleWatch();
  }
  function settleWatch() {
    if (!settling) return;
    var drawer = document.querySelector('cart-drawer');
    var inner = drawer && drawer.querySelector('.drawer__inner');
    if (!drawer || !inner || !drawer.classList.contains('ff-is-adding')) {
      settleEnd();
      return;
    }
    var items = drawer.querySelector('cart-drawer-items');
    if (!settling.redrawn) {
      /* Dawn's first redraw (renderContents) throws the old panel away, and our line with it */
      if (settling.line && settling.line.isConnected) return;
      settling.redrawn = Date.now();
      settling.items = items;
      clearTimeout(settling.timer);
      settling.timer = setTimeout(settleEnd, 1500);
    }
    if (!inner.querySelector('.ff-adding')) inner.insertBefore(addingLine(true), inner.firstChild);
    if (items && items !== settling.items && !settling.refetched) {
      /* Dawn's re-fetch replaced the card list: the cart is settled; a moment for Navidium and the thumbnails */
      settling.refetched = true;
      clearTimeout(settling.timer);
      settling.timer = setTimeout(settleEnd, 250);
    }
  }
  function settleEnd() {
    if (!settling) return;
    clearTimeout(settling.timer);
    settling = null;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.ff-adding').forEach(function (node) { node.remove(); });
    drawer.classList.remove('ff-is-adding');
    drawer.classList.add('ff-added');
    setTimeout(function () { drawer.classList.remove('ff-added'); }, 600);
    hydrateArt();
  }
  function isAddPost(options) {
    return !!(options && /\/cart\/add\.js/.test(options.url || ''));
  }
  function watchSlowAdd() {
    if (!document.querySelector('product-form form[action$="/cart/add"]')) return;
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('product-form [type="submit"]') : null;
      if (!button) return;
      if (adding) {
        event.preventDefault();
        event.stopImmediatePropagation();
        console.warn('[ff-cart] Add to cart click ignored: the previous add is still running.');
        return;
      }
      addClick = { at: Date.now(), button: button };
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') addEnd(true);
      });
      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        if (event && event.source === 'product-form') addEnd(false, 'Shopify refused the flag: ' + (event.message || event.errors || 'no reason given'));
      });
    }
    /* Infinite Options' script can arrive after ours: wait up to 10 s for its jQuery; without it, today's behaviour stays */
    var tries = 0;
    (function bind() {
      var io$ = window.Shoppad && window.Shoppad.$;
      if (typeof io$ !== 'function') {
        if (++tries < 40) setTimeout(bind, 250);
        return;
      }
      bindSlowAdd(io$);
    })();
  }
  function bindSlowAdd(io$) {
    io$(document).on('ajaxSend', function (event, xhr, options) {
      if (!isAddPost(options)) return;
      if (adding) {
        addWatch();
        return;
      }
      /* only an add that starts inside a click on Add to cart; another script's add shows nothing */
      if (addClick.button && Date.now() - addClick.at < 1000) addStart(addClick.button);
      addClick = { at: 0, button: null };
    });
    io$(document).on('ajaxComplete', function (event, xhr, options) {
      if (!adding || !isAddPost(options)) return;
      if (xhr && xhr.status === 422) {
        addEnd(false, 'Shopify refused an add-on (422)');
        return;
      }
      addWatch();
    });
  }

  /* Slice D (c), Todd 2026-09-22: "Start this flag over" loses long notes. The cheap version (Claude's advice 09-22, agreed in
     the step-6 list): clicking it remembers this card's SAVED note (its note box's default text, which round-trips the note
     exactly, step 4a) and its Needed-by date, in this browser only, for 30 minutes. The product page it opens fills ONLY
     empty fields whose property name matches the way the cards read them ("Notes for Design Team", "Date Needed By:"),
     waits up to 10 s for Infinite Options to draw them, says so in one line, and forgets them. Any other page forgets them
     too. Nothing is sent anywhere; the old flag stays in the cart as before (its small print says so). */
  var CARRY_KEY = 'ff-cart-carry';
  function handleOf(url) {
    var match = /\/products\/([^/?#]+)/.exec(url || '');
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (error) { return match[1]; }
  }
  function forgetCarry() {
    try { window.localStorage.removeItem(CARRY_KEY); } catch (error) { /* storage blocked: nothing was kept */ }
  }
  function carryOver(link) {
    var card = link.closest('.ffc-card');
    var box = card && card.querySelector('textarea[data-ff-note]');
    var note = box ? box.defaultValue : '';
    var date = link.getAttribute('data-ff-carry-date') || '';
    var handle = handleOf(link.getAttribute('href'));
    if (!handle || (!note.trim() && !date.trim())) {
      forgetCarry();
      return;
    }
    try {
      window.localStorage.setItem(CARRY_KEY, JSON.stringify({ handle: handle, note: note, date: date, at: Date.now() }));
    } catch (error) {
      console.warn('[ff-cart] Start over: could not keep the note / date for the product page: ' + error.message);
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-ff-restart]') : null;
    if (link) carryOver(link);
  }, true);
  function carryField(name) {
    var found = null;
    document.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (found) return;
      var key = field.name.slice(11, -1).replace(/:/g, '').trim().toUpperCase();
      if (key === name && (field.tagName === 'TEXTAREA' || field.type === 'text')) found = field;
    });
    return found;
  }
  function carryIn() {
    var saved = null;
    try { saved = JSON.parse(window.localStorage.getItem(CARRY_KEY) || 'null'); } catch (error) { saved = null; }
    if (!saved || typeof saved !== 'object') return;
    if (!saved.at || Date.now() - saved.at > 30 * 60 * 1000 || saved.handle !== handleOf(window.location.pathname)) {
      forgetCarry();
      return;
    }
    var note = typeof saved.note === 'string' ? saved.note : '';
    var date = typeof saved.date === 'string' ? saved.date : '';
    var tries = 0;
    (function fill() {
      var noteBox = carryField('NOTES FOR DESIGN TEAM');
      var dateBox = carryField('DATE NEEDED BY');
      if (((note.trim() && !noteBox) || (date.trim() && !dateBox)) && ++tries < 40) {
        setTimeout(fill, 250);
        return;
      }
      forgetCarry();
      var filled = [];
      [[noteBox, note, 'note'], [dateBox, date, 'date']].forEach(function (set) {
        var box = set[0];
        if (!set[1].trim()) return;
        if (!box) {
          console.warn('[ff-cart] Start over: this product page has no empty ' + set[2] + ' field to fill; the ' + set[2] + ' was not brought over.');
          return;
        }
        if (box.value.trim()) return; /* the customer (or the browser) already filled it: theirs wins */
        box.value = set[1];
        box.dispatchEvent(new Event('input', { bubbles: true }));
        box.dispatchEvent(new Event('change', { bubbles: true }));
        filled.push(set[2]);
      });
      if (!filled.length) return;
      var first = filled[0] === 'note' ? noteBox : dateBox;
      var message = document.createElement('p');
      message.className = 'ff-carried';
      message.setAttribute('role', 'status');
      message.textContent = filled.length === 2 ? 'We brought your note and date over from your cart.'
        : filled[0] === 'note' ? 'We brought your note over from your cart.' : 'We brought your Needed-by date over from your cart.';
      first.parentNode.insertBefore(message, first);
    })();
  }

  function start() {
    watchDrawer();
    hookProductForms();
    watchAddToCart();
    watchSlowAdd();
    carryIn();
    markLongNotes();
    artReturn();
    edScan();
    window.addEventListener('resize', scheduleNoteCheck);
    /* Inter / Bebas can arrive after the first measure and change how many lines a note takes */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markLongNotes).catch(function () {});
  }

  /* Notes "Show all" (slice C, Todd 2026-09-22: notes can be long). The note text is cut at 3 lines by CSS (.ffc-note-txt; 6 in slice C, 3 since v23); the
     toggle is rendered hidden and shown only where the text really is cut, measured here (a line count in Liquid cannot know the
     card's width). Measured at start, after every redraw (the observer above), after a resize and once the fonts are in. The
     closed drawer is only visibility:hidden, so its notes still have a size to measure. An opened note stays open until the
     next redraw. Without this script the 6 lines and Edit (which shows the whole note) still work. */
  var noteCheck = 0;
  function scheduleNoteCheck() {
    if (noteCheck) return;
    noteCheck = window.requestAnimationFrame(function () {
      noteCheck = 0;
      markLongNotes();
      /* "Show all" comes back a frame after each redraw and makes a card with long notes taller: hold the anchor again */
      try { holdAnchor(); } catch (error) { console.error('[ff-cart] scroll anchor failed: ' + error.message); }
    });
  }

  function markLongNotes() {
    document.querySelectorAll('[data-ff-notefold]').forEach(function (fold) {
      var text = fold.querySelector('.ffc-note-txt');
      var more = fold.querySelector('[data-ff-act="note-more"]');
      if (!text || !more) return;
      if (fold.classList.contains('ffc-note-open')) { more.hidden = false; return; }
      more.hidden = !(text.scrollHeight > text.clientHeight + 1);
    });
  }

  function toggleNote(button) {
    var fold = button.closest('[data-ff-notefold]');
    if (!fold) return;
    var open = fold.classList.toggle('ffc-note-open');
    var from = open ? 'Show all' : 'Show less';
    var to = open ? 'Show less' : 'Show all';
    button.textContent = to;
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', (button.getAttribute('aria-label') || from).replace(from, to));
  }

  /* Keyboard + screen reader (step 5, 2026-09-22). Every write redraws the cards from Shopify's HTML (ours at once, then Dawn's
     own re-fetch 1-4 s later), which drops keyboard focus to <body>: a keyboard or screen-reader user would land at the top of
     the page after every click. So the last card control that had focus is remembered (data-ff-act + the card's position on
     its surface), and after each redraw focus goes back to the same control on the same card. Only within 10 s of one of OUR
     writes and only when focus really was lost, so focus the customer moved themselves is never taken back. */
  var lastFocus = null;
  var writeAt = 0;
  var focusTimer = null;

  function controlIntent(node) {
    var holder = node && node.closest && node.closest('[data-ff-keys]');
    var root = holder && holder.closest('[data-ff-cart]');
    if (!root) return null;
    var act = node.getAttribute('data-ff-act') || (node.hasAttribute('data-ff-note') ? 'note-edit' : '');
    return {
      page: !!root.closest('#main-cart-items'),
      index: Array.prototype.indexOf.call(root.querySelectorAll('[data-ff-keys]'), holder),
      act: act
    };
  }

  document.addEventListener('focusin', function (event) {
    lastFocus = controlIntent(event.target);
  });

  function usable(node) {
    if (!node || node.disabled || node.hidden || !node.getClientRects().length) return false;
    /* the closed drawer is only visibility:hidden, so it still has boxes: never send focus into it */
    var drawer = node.closest('cart-drawer');
    return !drawer || drawer.classList.contains('active');
  }

  function firstUsable(nodes) {
    return Array.prototype.filter.call(nodes, usable)[0] || null;
  }

  /* Same control on the same card; a control that is now disabled (minus at 1, design help at its floor or ceiling) -> the
     other button of the same stepper; after Delete -> the name of the card that took its place (never another Delete
     button: a second Enter must not delete a second flag); nothing left -> the drawer's close button / "Continue shopping". */
  function focusTarget(intent) {
    var root = document.querySelector(intent.page ? '#main-cart-items [data-ff-cart]' : '#CartDrawer [data-ff-cart]');
    var holders = root ? root.querySelectorAll('[data-ff-keys]') : [];
    if (holders.length && intent.index > -1) {
      var holder = holders[Math.min(intent.index, holders.length - 1)];
      if (intent.act === 'delete') {
        var name = holder.querySelector('[data-ff-name]');
        if (usable(name)) return name;
      } else {
        var act = /^note-/.test(intent.act) ? 'note-edit' : /^date-/.test(intent.act) ? 'date-edit' : intent.act;
        var same = act ? holder.querySelector('[data-ff-act="' + act + '"]') : null;
        if (usable(same)) return same;
        var sibling = same ? firstUsable(same.parentNode.querySelectorAll('[data-ff-act]')) : null;
        if (sibling) return sibling;
      }
      var first = firstUsable(holder.querySelectorAll('[data-ff-name], button, a[href]'));
      if (first) return first;
    }
    if (intent.page) return firstUsable(document.querySelectorAll('#main-cart-items .cart__warnings a, #main-cart-items a[href]'));
    return firstUsable(document.querySelectorAll('#CartDrawer .drawer__close'));
  }

  /* Dawn's trapFocus() keeps the first and last focusable nodes it saw when the drawer opened (the close button and "Keep
     shopping"); our redraw replaces both, after which Tab walks out of the open drawer. Re-arm it on the new nodes, the way
     Dawn's open() does (same container choice). Dawn's own re-fetch replaces neither node, so only our redraw needs this. */
  function rearmDrawerTrap(target) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return false;
    var container = drawer.classList.contains('is-empty') ? drawer.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
    if (!container) return false;
    /* focus first WITHOUT scrolling; trapFocus's own focus() then finds it already focused and does not scroll either */
    if (target) target.focus({ preventScroll: true });
    trapFocus(container, target || drawer.querySelector('.drawer__inner') || container);
    return true;
  }

  function restoreFocus(redrawnByUs) {
    if (redrawnByUs) writeAt = Date.now();
    var intent = lastFocus;
    if (!intent || Date.now() - writeAt > 10000) return;
    var active = document.activeElement;
    var lost = !active || active === document.body || !active.isConnected;
    var target = lost ? focusTarget(intent) : null;
    if (redrawnByUs && !intent.page && rearmDrawerTrap(target)) return;
    /* preventScroll (audit 2026-09-22): this can run after Dawn's re-fetch, when the customer may already have scrolled on
       toward Check out; a plain focus() scrolled them back up to the stepper. Focus comes back, the page stays put. */
    if (target) target.focus({ preventScroll: true });
  }

  /* Drawer scroll position (step 6, 2026-09-22; step-5 audit finding 1). The drawer's card list is <cart-drawer-items>, which
     scrolls on its own. Every write replaces it twice (our redraw of #CartDrawer, then Dawn's re-fetch replaceWith after our
     cartUpdate) and each new node starts at the top: a customer who scrolled down to flag 4 and pressed + was thrown back to
     flag 1. So the last scroll position seen on the list is remembered (scroll does not bubble: capture phase), and each NEW
     list node that appears within 10 s of one of our writes is put back there. Only new nodes, so a customer scrolling the
     current list is never moved. */
  var drawerScroll = 0;
  var drawerScrollNode = null;
  document.addEventListener('scroll', function (event) {
    var node = event.target;
    if (node && node.nodeType === 1 && node.matches('cart-drawer cart-drawer-items')) {
      drawerScroll = node.scrollTop;
      drawerScrollNode = node;
    }
  }, true);

  function keepDrawerScroll() {
    var node = document.querySelector('cart-drawer cart-drawer-items');
    if (!node || node === drawerScrollNode) return;
    drawerScrollNode = node;
    if (drawerScroll > 0) node.scrollTop = drawerScroll;
  }

  /* Scroll anchor (2026-09-24, Todd on his phone: after + the card "dips down under the subtotal / Navidium box"). A quantity
     click makes the card taller ABOVE its stepper (Each column, design-help stepper, savings pill), and keepDrawerScroll() only
     puts the list back at its old scrollTop, so the pressed + slid down behind the pinned footer (measured 2026-09-24 at 390 px:
     +56 px, and the next tap landed on the footer). So the pressed control's place on screen is remembered at the click, and
     after each redraw (ours, Dawn's re-fetch, the deal check) the list is scrolled by the difference: the same control on the
     same card stays under the finger. Drawer only, quantity controls only. If that control is not showing (the "Add 1 more"
     button waits for the deal check) the card's navy footer is held instead; if neither is found the old scrollTop stands, as
     before. The customer's next touch, drag, wheel or key press ends it (a press on a quantity control re-arms it), as do 10 s,
     so the list never moves under someone who is scrolling. */
  var drawerAnchor = null;
  var QTY_ACTS = /^(plus|minus|dh-plus|dh-minus)$/;
  function armAnchor(button, act) {
    drawerAnchor = null;
    var list = button.closest('cart-drawer cart-drawer-items');
    var holder = button.closest('[data-ff-keys]');
    var root = holder && holder.closest('[data-ff-cart]');
    var foot = holder && holder.querySelector('.ffc-foot');
    if (!list || !root || !foot) return;
    drawerAnchor = {
      at: Date.now(),
      index: Array.prototype.indexOf.call(root.querySelectorAll('[data-ff-keys]'), holder),
      act: act,
      nth: Array.prototype.indexOf.call(holder.querySelectorAll('[data-ff-act="' + act + '"]'), button),
      top: button.getBoundingClientRect().top,
      footTop: foot.getBoundingClientRect().top
    };
  }

  function holdAnchor() {
    var anchor = drawerAnchor;
    if (!anchor) return;
    if (Date.now() - anchor.at > 10000) {
      drawerAnchor = null;
      return;
    }
    var list = document.querySelector('cart-drawer cart-drawer-items');
    var root = list && list.querySelector('[data-ff-cart]');
    var holder = root && root.querySelectorAll('[data-ff-keys]')[anchor.index];
    if (!holder) return;
    var same = holder.querySelectorAll('[data-ff-act="' + anchor.act + '"]')[anchor.nth];
    var foot = holder.querySelector('.ffc-foot');
    var shift;
    if (same && same.getClientRects().length) shift = same.getBoundingClientRect().top - anchor.top;
    else if (foot && foot.getClientRects().length) shift = foot.getBoundingClientRect().top - anchor.footTop;
    else return;
    if (Math.abs(shift) >= 1) list.scrollTop += shift;
  }

  function dropAnchor(event) {
    if (!drawerAnchor) return;
    if (event.type !== 'wheel' && event.type !== 'touchmove' && (event.type !== 'keydown' || event.key === 'Enter' || event.key === ' ')) {
      var control = event.target && event.target.closest ? event.target.closest('[data-ff-act]') : null;
      if (control && QTY_ACTS.test(control.getAttribute('data-ff-act'))) return;
      /* audit 2026-09-24: while the cards are busy they take no taps (pointer-events:none), so a quick second tap on + falls
         through to the list behind them; that is not the customer scrolling, so the anchor stays. Todd 2026-10-03: without
         this, a quick second tap dropped the anchor and the redraw left the discount dots + "Add 1 more" under the pinned
         Subtotal / Check out panel. Only a primary tap / click INSIDE the list's content area counts: a press on the list's
         own scrollbar (right of clientWidth) is the customer scrolling and still drops the anchor (audit 2 fix). */
      if (event.type !== 'keydown' && document.querySelector('cart-drawer [data-ff-cart].ffc-busy')) {
        var busyList = event.target && event.target.closest ? event.target.closest('cart-drawer cart-drawer-items') : null;
        var point = event.touches ? event.touches[0] : event;
        if (busyList && point && (event.type === 'touchstart' || event.button === 0)
            && point.clientX < busyList.getBoundingClientRect().left + busyList.clientLeft + busyList.clientWidth) return;
      }
    }
    drawerAnchor = null;
  }
  ['pointerdown', 'touchstart', 'touchmove', 'wheel', 'keydown'].forEach(function (type) {
    document.addEventListener(type, dropAnchor, { capture: true, passive: true });
  });

  /* The count spans on the cards are replaced wholesale on every redraw, so an aria-live on them never speaks. One status
     region that lives across redraws (inside the open drawer's dialog, else the page body) says what changed. */
  function announce(message) {
    if (!message) return;
    var drawer = document.querySelector('cart-drawer');
    var host = (drawer && drawer.classList.contains('active') && drawer.querySelector('.drawer__inner')) || document.body;
    var region = document.getElementById('FFCart-Status');
    if (!region) {
      region = document.createElement('p');
      region.id = 'FFCart-Status';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
    }
    if (region.parentNode !== host) host.appendChild(region);
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 150);
  }

  function describeWrite(intent) {
    if (!intent) return '';
    if (intent.act === 'delete') return 'Removed from your cart.';
    var root = document.querySelector(intent.page ? '#main-cart-items [data-ff-cart]' : '#CartDrawer [data-ff-cart]');
    var holder = root && root.querySelectorAll('[data-ff-keys]')[intent.index];
    if (!holder) return 'Cart updated.';
    var flag = holder.querySelector('.ffc-num');
    var label = flag ? flag.textContent.trim().replace(/^FLAG/i, 'Flag') : 'Your flag';
    if (intent.act === 'plus' || intent.act === 'minus') return label + ' quantity ' + holder.getAttribute('data-ff-qty') + '.';
    var dh = holder.querySelector('.ffc-dh > span');
    if (/^dh-/.test(intent.act) && dh) return label + ' design help quantity ' + dh.textContent.trim() + '.';
    if (/^note-/.test(intent.act)) return 'Note saved for ' + label.toLowerCase() + '.';
    return 'Cart updated.';
  }

  /* One cart write (update.js or change.js) with the section HTML asked for, then the redraw. The cart HAS changed once the
     request succeeds, so from then on nothing here says "could not update"; a redraw failure reloads the page instead.
     Cart follow-ups (b)/(c): onRefused (optional) runs only when Shopify answered and refused the write (not on a network
     failure); it resolves true when it handled the refusal itself, else the usual "could not update" message is shown. */
  function commit(root, url, body, intent, onRefused) {
    root.classList.add('ffc-busy');
    body.sections = ['cart-drawer', 'cart-icon-bubble'].concat(pageSections());
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          var refused = new Error(result.json.description || result.json.message || 'Cart update was refused.');
          refused.ffRefused = true;
          throw refused;
        }
        return result.json;
      })
      .then(
        function (state) {
          /* the cart HAS changed from here on; never report "could not update" */
          var drawn = false;
          try { drawn = render(state); } catch (error) { console.error('[ff-cart] redraw failed: ' + error.message); }
          if (!drawn) {
            /* stale cards would send wrong quantities on the next click: say so and reload */
            root.classList.remove('ffc-busy');
            showError(root, 'Your cart was updated. Reloading the page to show it...');
            window.setTimeout(function () { window.location.reload(); }, 1200);
            return;
          }
          writeAt = Date.now();
          try { keepDrawerScroll(); } catch (error) { console.error('[ff-cart] drawer scroll restore failed: ' + error.message); }
          try { afterRender(state); } catch (error) { console.error('[ff-cart] after-render step failed: ' + error.message); }
          try {
            restoreFocus(true);
            announce(describeWrite(intent));
          } catch (error) { console.error('[ff-cart] focus restore failed: ' + error.message); }
        },
        function (error) {
          var fail = function () {
            root.classList.remove('ffc-busy');
            showError(root, 'Sorry, we could not update your cart (' + error.message + '). Please refresh and try again.');
          };
          if (!error.ffRefused || typeof onRefused !== 'function') return fail();
          return Promise.resolve()
            .then(function () { return onRefused(error); })
            .then(function (handled) { if (!handled) fail(); }, function (recoverError) {
              console.warn('[ff-cart] refused write: recovery failed (' + recoverError.message + ')');
              fail();
            });
        }
      );
  }

  /* Notes edit (step 4). The note is the line-item property "Notes for Design Team" on the FLAG line, the property the
     Order Brief Flow and the Tina pull read, so it is written back under that exact key (matched on the line the way the
     cards match it: colon, spaces and case ignored; created under the exact name if the line has none).
     Shopify's /cart/change.js replaces the WHOLE properties object (docs + proven on the preview 2026-09-22), so the line is
     re-read from /cart.js first and every property goes back with it: _io_order_group, __kaching_bundles, "STITCHING  " with
     its two trailing spaces, the date, everything. The line KEY changes after the write (Shopify re-keys on a property change);
     the cards are redrawn from Shopify's HTML, so nothing here keeps the old key. Only the note changes: never the quantity
     (sent back as read), never an option, never an add-on line. */
  var NOTE_KEY = 'Notes for Design Team';
  function noteAction(act, button, holder, root) {
    var fold = button.closest('[data-ff-notefold]');
    var editor = fold && fold.querySelector('.ffc-note-ed');
    var area = fold && fold.querySelector('[data-ff-note]');
    var editButton = fold && fold.querySelector('[data-ff-act="note-edit"]');
    if (!editor || !area || !editButton) return;
    function close() {
      editor.hidden = true;
      editButton.hidden = false;
      editButton.focus();
      /* v23: the cut note + Show all are hidden while editing (ff-cart.css), so measure again once they are back */
      scheduleNoteCheck();
    }
    if (act === 'note-edit') {
      editor.hidden = false;
      editButton.hidden = true;
      area.focus();
      return;
    }
    if (act === 'note-cancel') {
      area.value = area.defaultValue;
      close();
      return;
    }
    var note = area.value.trim();
    if (note === area.defaultValue.trim()) { close(); return; }
    var flagKey = holder.getAttribute('data-ff-keys').split(',')[0];
    if (!flagKey) return;
    root.classList.add('ffc-busy');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var line = null;
        (cart.items || []).forEach(function (item) { if (item.key === flagKey) line = item; });
        if (!line) throw new Error('this flag has changed since the page was shown');
        var properties = {};
        var noteKey = NOTE_KEY;
        Object.keys(line.properties || {}).forEach(function (key) {
          properties[key] = line.properties[key];
          if (key.replace(/:/g, '').trim().toUpperCase() === NOTE_KEY.toUpperCase()) noteKey = key;
        });
        properties[noteKey] = note;
        return commit(root, '/cart/change.js', { id: line.key, quantity: line.quantity, properties: properties }, controlIntent(button));
      })
      .catch(function (error) {
        root.classList.remove('ffc-busy');
        showError(root, 'Sorry, we could not save your note (' + error.message + '). Please refresh and try again.');
      });
  }

  /* Cart K2 (Todd 2026-10-21: "There's still no edit button for the date needed by. There's nothing, no functionality there."):
     the Needed-by date gets the SAME edit as the note. On the product page "Date Needed By:" is a plain TEXT field (Infinite
     Options option set, type "text": customers type it however they like), so it is edited as text and written back exactly like
     the note: the line re-read from /cart.js, every property sent back unchanged, only the date's own key changed (matched like the
     cards read it: colon, spaces and case ignored; created as "Date Needed By:" only when there is a date to save), quantity as read,
     through the same commit() (/cart/change.js). Empty + no date on the line = nothing written. */
  var DATE_KEY = 'Date Needed By:';
  function dateAction(act, button, holder, root) {
    var fold = button.closest('[data-ff-datefold]');
    var editor = fold && fold.querySelector('[data-ff-dateed]');
    var box = fold && fold.querySelector('[data-ff-date]');
    var editButton = fold && fold.querySelector('[data-ff-act="date-edit"]');
    if (!editor || !box || !editButton) return;
    function close() {
      editor.hidden = true;
      editButton.hidden = false;
      editButton.focus();
    }
    if (act === 'date-edit') {
      editor.hidden = false;
      editButton.hidden = true;
      box.focus();
      return;
    }
    if (act === 'date-cancel') {
      box.value = box.defaultValue;
      close();
      return;
    }
    var date = box.value.trim();
    if (date === box.defaultValue.trim()) { close(); return; }
    var flagKey = holder.getAttribute('data-ff-keys').split(',')[0];
    if (!flagKey) return;
    root.classList.add('ffc-busy');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var line = null;
        (cart.items || []).forEach(function (item) { if (item.key === flagKey) line = item; });
        if (!line) throw new Error('this flag has changed since the page was shown');
        var properties = {};
        var dateKey = null;
        Object.keys(line.properties || {}).forEach(function (key) {
          properties[key] = line.properties[key];
          if (key.replace(/:/g, '').trim().toUpperCase() === 'DATE NEEDED BY') dateKey = key;
        });
        if (!dateKey && !date) { root.classList.remove('ffc-busy'); close(); return null; }
        properties[dateKey || DATE_KEY] = date;
        return commit(root, '/cart/change.js', { id: line.key, quantity: line.quantity, properties: properties }, controlIntent(button));
      })
      .catch(function (error) {
        root.classList.remove('ffc-busy');
        showError(root, 'Sorry, we could not save your date (' + error.message + '). Please refresh and try again.');
      });
  }

  /* Two-step delete (step 6, 2026-09-22; Todd: no easy deletes). "Delete entire flag" (delete-ask) only opens the inline
     "Delete flag N? Yes, delete · Keep it" (snippets/ff-cart-cards.liquid) and puts focus on Keep it, so a second Enter or a
     double click cancels. Keep it (or Escape) closes it again. The real delete runs only from a visible confirm that has been
     open for 400 ms (see the click handler); anything else fails loud in the console and writes nothing. */
  var ASK_DELAY = 400;
  function deleteAsk(act, button) {
    var wrap = button.closest('.ffc-del');
    var ask = wrap && wrap.querySelector('.ffc-delask');
    var first = wrap && wrap.querySelector('[data-ff-act="delete-ask"]');
    var keep = ask && ask.querySelector('[data-ff-act="delete-keep"]');
    if (!ask || !first || !keep) {
      console.error('[ff-cart] delete confirm markup missing; nothing was deleted.');
      return;
    }
    if (act === 'delete-ask') {
      first.hidden = true;
      ask.hidden = false;
      ask.setAttribute('data-ff-asked', String(Date.now()));
      keep.focus({ preventScroll: true });
      crRefit(wrap.closest('.ffc-crp'));
      return;
    }
    ask.hidden = true;
    ask.removeAttribute('data-ff-asked');
    first.hidden = false;
    first.focus({ preventScroll: true });
  }

  function deleteConfirmed(button) {
    var ask = button.closest('.ffc-delask');
    var asked = ask ? parseInt(ask.getAttribute('data-ff-asked'), 10) : NaN;
    if (!ask || ask.hidden || isNaN(asked)) {
      console.error('[ff-cart] flag delete refused: it did not come from an open "Delete flag?" confirm.');
      return false;
    }
    if (Date.now() - asked < ASK_DELAY) {
      console.warn('[ff-cart] "Yes, delete" pressed within ' + ASK_DELAY + ' ms of the confirm opening; ignored as a double click. Nothing was deleted.');
      return false;
    }
    return true;
  }

  /* "Change or remove" (v23; v24 drop-down): the quiet pill under the details strip opens / closes its panel (Start this flag
     over + Delete this flag). Only one panel is open at a time. Closing it also closes a "Delete flag N?" confirm left open
     inside, so reopening never shows a stale confirm. A missing panel fails loud and opens nothing. The pill and Escape close it
     with focus back on the pill; a click / tap anywhere outside the panel (the outside-click listener below) closes it without
     moving focus. */
  function crPanel(button) {
    var card = button.closest('.ffc-card');
    return card ? card.querySelector('.ffc-crp') : null;
  }

  function crClose(pill, panel, refocus) {
    panel.hidden = true;
    pill.setAttribute('aria-expanded', 'false');
    if (panel.classList.contains('ffc-sheet')) {
      var bg = panel.parentNode && panel.parentNode.querySelector('.ffc-sheet-bg');
      if (bg) bg.hidden = true;
      crOpen = null;
      crListRestore();
    }
    var ask = panel.querySelector('.ffc-delask');
    var first = panel.querySelector('[data-ff-act="delete-ask"]');
    if (ask && !ask.hidden) {
      ask.hidden = true;
      ask.removeAttribute('data-ff-asked');
      if (first) first.hidden = false;
    }
    if (refocus) pill.focus({ preventScroll: true });
  }

  function crCloseAll(except) {
    document.querySelectorAll('.ffc-crp:not([hidden])').forEach(function (panel) {
      if (panel === except) return;
      var wrap = panel.closest('.ffc-cr');
      var pill = wrap && wrap.querySelector('[data-ff-act="cr-toggle"]');
      if (pill) crClose(pill, panel, false);
      else panel.hidden = true;
    });
  }

  function crToggle(button) {
    var panel = crPanel(button);
    if (!panel) {
      console.error('[ff-cart] "Change or remove" panel missing; nothing opened.');
      return;
    }
    if (!panel.hidden) {
      crClose(button, panel, true);
      if (panel.classList.contains('ffc-sheet')) crSheetHold(panel, false);
      return;
    }
    crCloseAll(panel);
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    if (panel.classList.contains('ffc-sheet')) { crSheetOpen(button, panel, true); crSheetHold(panel, true); return; }
    crPlace(button, panel);
  }

  /* Compact cart sheet (2026-10-20, Todd: "Build it. Start the compact cart build from mockup v9 in a hidden theme copy, keeping
     every cart function."). The card's ONE "Change" button (data-ff-act="cr-toggle", the old pill's act) opens its panel as a
     sheet: phones (frame under 750 px) = full width at the bottom of the drawer (the screen on the /cart page), up to 85% of
     its height; wider = 520 px wide, centred, 24 px above the bottom. Its backdrop (.ffc-sheet-bg) dims the drawer / page and
     takes taps (cr-close); the X (cr-close), the button again and Escape close it too. Same positioning method as crSheet:
     fixed, measured after setting it and corrected once (the drawer's transform makes it the containing block), placed again
     on resize / the drawer's own scroll / the phone keyboard (visualViewport) while open. Display only: no cart request.
     crOpen remembers which card's sheet is open (surface, position, card count, the flag's variant) so a redraw from one of the sheet's own
     writes (Save note) shows the same sheet again; a customer close, a Delete or an "Edit this flag" Save forgets it (the
     rebuilt flag moves to the top of the cart, so its position no longer names it). */
  var crOpen = null;
  function crRemember(button) {
    var holder = button.closest('[data-ff-keys]');
    var root = holder && holder.closest('[data-ff-cart]');
    if (!root) return null;
    var holders = root.querySelectorAll('[data-ff-keys]');
    return { page: !!root.closest('#main-cart-items'), index: Array.prototype.indexOf.call(holders, holder), count: holders.length,
      variant: lineVariant(holderKey(holder)) };
  }
  function crFrame(panel) {
    var inner = panel.closest('.drawer__inner');
    var r = inner ? inner.getBoundingClientRect() : { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth };
    var top = Math.max(0, r.top), bottom = Math.min(window.innerHeight, r.bottom);
    var vv = window.visualViewport;
    /* the phone keyboard: keep the sheet above it; Cart K2 (Todd's phone 2026-10-20, "Edit notes button gets pushed down when
       clicked"): iOS also slides the page up under the keyboard (visualViewport.offsetTop > 0), so the sheet's top follows what is
       visible too, instead of sliding its header off the top */
    /* (2026-10-21, Todd's phone: following visualViewport.offsetTop with the top dropped the sheet below a grey gap: undone; with
       one thing at a time the note box sits at the top of the sheet, above the keyboard, so nothing has to move) */
    if (vv && vv.height > 0) bottom = Math.min(bottom, vv.offsetTop + vv.height);
    /* Cart K2 (k2-see-check 2026-10-21: on the /cart page the site's pinned header covered the sheet's back arrow): outside the
       drawer the sheet starts under the pinned header (revHeadBottom: 0 when no header is pinned at the top) */
    if (!inner) {
      try { top = Math.max(top, Math.min(revHeadBottom(), bottom - 160)); } catch (e) { console.warn('[ff-cart] header height not read: ' + e.message); }
    }
    return { top: top, bottom: bottom, left: Math.max(0, r.left), right: Math.min(window.innerWidth, r.right) };
  }
  function crFix(node, wantLeft, wantTop, wantBottom) {
    var got = node.getBoundingClientRect();
    if (Math.abs(got.left - wantLeft) > 1) node.style.left = (parseFloat(node.style.left) + wantLeft - got.left) + 'px';
    if (wantTop != null && Math.abs(got.top - wantTop) > 1) node.style.top = (parseFloat(node.style.top) + wantTop - got.top) + 'px';
    if (wantBottom != null && Math.abs(got.bottom - wantBottom) > 1) node.style.bottom = (parseFloat(node.style.bottom) - (wantBottom - got.bottom)) + 'px';
  }
  function crSheetPlace(panel) {
    if (panel.hidden || !panel.isConnected) return;
    var f = crFrame(panel);
    var fw = f.right - f.left, fh = f.bottom - f.top;
    var bg = panel.parentNode && panel.parentNode.querySelector('.ffc-sheet-bg');
    if (bg && !bg.hidden) {
      bg.style.left = f.left + 'px';
      bg.style.top = f.top + 'px';
      bg.style.width = fw + 'px';
      bg.style.height = fh + 'px';
      crFix(bg, f.left, f.top, null);
    }
    var phone = fw < 750;
    /* Cart K2 (2026-10-20, Todd: "one button that says "Edit", and then it takes them into a whole new screen"): a phone gets
       the whole frame (the drawer, or the screen on the /cart page, above the keyboard); wider = a 560 px panel, 24 px from the
       top and bottom of the frame. Was: 85% of the height at the bottom (phone), 520 px wide (wider). */
    /* Todd 2026-10-21 (desktop): "it opens up this small little area for editing. Why is it so skinny?" and "so much space down
       there before the Done button": wider (up to 680 px) and only as tall as what is in it (at most the frame less 24 px top and
       bottom), from the top */
    var w = phone ? fw : Math.min(680, fw - 48);
    var left = f.left + (fw - w) / 2;
    var h = Math.max(160, phone ? Math.round(fh) : fh - 48);
    panel.classList.toggle('ffc-sheet--phone', phone);
    panel.style.width = w + 'px';
    panel.style.left = left + 'px';
    if (phone) {
      var bottom = f.bottom;
      panel.style.top = '';
      panel.style.bottom = (window.innerHeight - bottom) + 'px';
      panel.style.height = h + 'px';
      panel.style.maxHeight = h + 'px';
      crFix(panel, left, null, bottom);
    } else {
      var top = f.top + 24;
      panel.style.bottom = 'auto';
      panel.style.top = top + 'px';
      panel.style.height = 'auto';
      panel.style.maxHeight = h + 'px';
      crFix(panel, left, top, null);
    }
  }
  /* one set of listeners for every open sheet: the drawer's own scroll (phone sideways), the page, the phone keyboard */
  var crWatching = false;
  function crWatch() {
    if (crWatching) return;
    crWatching = true;
    var queued = false;
    var again = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        document.querySelectorAll('.ffc-sheet:not([hidden])').forEach(function (panel) {
          try { crSheetPlace(panel); } catch (e) { console.error('[ff-cart] could not keep the Change sheet in place.', e); }
        });
      });
    };
    document.addEventListener('scroll', again, { capture: true, passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', again);
      window.visualViewport.addEventListener('scroll', again);
    }
  }
  function crSheetOpen(button, panel, focus) {
    var bg = panel.parentNode && panel.parentNode.querySelector('.ffc-sheet-bg');
    if (bg) bg.hidden = false;
    crOpen = crRemember(button);
    try { crSheetPlace(panel); } catch (e) { console.error('[ff-cart] could not place the Change sheet.', e); }
    /* the notes can only be measured ("Show all") and the thumbnails loaded once the sheet has a size */
    scheduleNoteCheck();
    try { hydrateArt(); } catch (e) { console.error('[ff-cart] sheet thumbnails not loaded.', e); }
    crWatch();
    /* Cart K2: placed again once the drawer has finished sliding in / Safari's toolbar has settled (a sheet placed mid-slide
       could sit too narrow or shifted) */
    [350, 800].forEach(function (ms) { window.setTimeout(function () { try { crSheetPlace(panel); } catch (e) { /* placed on the next scroll */ } }, ms); });
    if (focus) {
      /* round 6 hides the back arrow (Done closes), so focus goes to the first control a person can see; otherwise focus
         would stay outside the sheet and Tab would walk the page behind it (batch 14 k2-check). Buttons / links only: focusing a
         text box would pop the phone keyboard */
      var x = panel.querySelector('.ffc-sh-x');
      var to = x && x.getClientRects().length ? x : null;
      if (!to) {
        to = Array.prototype.filter.call(panel.querySelectorAll('button, a[href]'), function (node) {
          return !node.disabled && !node.hidden && node.getAttribute('tabindex') !== '-1' && node.getClientRects().length > 0;
        })[0] || null;
      }
      if (to) to.focus({ preventScroll: true });
    }
  }
  /* after a redraw: the same card's sheet again (its X / Edit / note controls are new nodes); nothing if the cards changed */
  function crReopen() {
    var want = crOpen;
    if (!want) return;
    /* Todd's phone 2026-10-21 ("Save changes goes back to cart not edit page"): while an "Edit this flag" Save is rebuilding the
       lines, the redraws in between are neither reopened nor allowed to forget the screen; the final redraw does it */
    if (edSaving) return;
    var root = document.querySelector(want.page ? '#main-cart-items [data-ff-cart]' : '#CartDrawer [data-ff-cart]');
    var holders = root ? root.querySelectorAll('[data-ff-keys]') : [];
    var holder = null;
    if (want.keys) {
      /* after a Save the rebuilt flag sits at the TOP of the cart (Shopify adds new lines first): find it by its new line keys,
         then remember it by position again for later redraws */
      Array.prototype.forEach.call(holders, function (h) {
        if (holder) return;
        var keys = (h.getAttribute('data-ff-keys') || '').split(',');
        if (want.keys.some(function (k) { return keys.indexOf(k) !== -1; })) holder = h;
      });
      /* Todd's phone 2026-10-21 (still "back to cart" with ONE flag x 4, stitching -> "No - Double is fine"; reproduced in Chrome and
         WebKit): another app can re-key the rebuilt line right after the Save (the bundle app's __kaching_bundles), so the new key
         is gone by the redraw. Then the flag is the FIRST card of the same flag variant: Shopify puts the rebuilt / changed line at
         the top of the cart. */
      if (!holder) {
        var wantVariant = want.variant || lineVariant(want.keys[0]);
        Array.prototype.forEach.call(holders, function (h) {
          if (!holder && lineVariant(holderKey(h)) === wantVariant) holder = h;
        });
      }
      if (holder) want = crOpen = { page: want.page, index: Array.prototype.indexOf.call(holders, holder), count: holders.length, variant: lineVariant(holderKey(holder)) };
    } else {
      holder = holders.length === want.count ? holders[want.index] : null;
    }
    /* the same flag (its variant; a Save note re-keys the line but keeps the variant), never whatever card took its place */
    if (holder && lineVariant(holderKey(holder)) !== want.variant) holder = null;
    var pill = holder && holder.querySelector('[data-ff-act="cr-toggle"]');
    var panel = pill && crPanel(pill);
    if (!panel || !panel.classList.contains('ffc-sheet')) { crOpen = null; return; }
    if (!panel.hidden) return;
    crCloseAll(panel);
    panel.hidden = false;
    pill.setAttribute('aria-expanded', 'true');
    crSheetOpen(pill, panel, false);
  }
  /* Todd's iPhone 2026-10-21: while a drawer Edit screen is open the card list stops being a scroll box (assets/ff-cart.css), which
     resets its scroll; the place is kept from the tap on Edit (before the screen shows) and put back when the screen closes */
  var crListTop = null;
  document.addEventListener('click', function (event) {
    var b = event.target && event.target.closest ? event.target.closest('[data-ff-act="cr-toggle"]') : null;
    var list = b && b.closest('cart-drawer-items');
    if (list && !list.querySelector('.ffc-sheet:not([hidden])')) crListTop = list.scrollTop;
  }, true);
  function crListRestore() {
    if (crListTop == null) return;
    var list = document.querySelector('cart-drawer-items');
    if (!list || list.querySelector('.ffc-sheet:not([hidden])')) return;
    var top = crListTop;
    crListTop = null;
    requestAnimationFrame(function () { list.scrollTop = top; });
  }
  function crCloseSheet(button) {
    var wrap = button.closest('.ffc-cr');
    var pill = wrap && wrap.querySelector('[data-ff-act="cr-toggle"]');
    var panel = wrap && wrap.querySelector('.ffc-crp');
    if (pill && panel && !panel.hidden) {
      crClose(pill, panel, true);
      crSheetHold(panel, false);
    }
  }
  /* Audit 1 corrective pass (2026-10-20, auditor's finding 1: a 150 ms double tap on the backdrop closed the sheet and the second
     tap landed on the card's + underneath: cart 10 -> 13 items). Same guard as crHoldTaps on the old panel: for ASK_DELAY after
     the sheet opens or closes by a tap / key, every click and dblclick is swallowed on window capture, so a quick second tap can
     neither change the cart nor follow a link that slid under the finger; while it opens, only its own X still works. */
  function crSheetHold(panel, allowX) {
    var until = Date.now() + ASK_DELAY;
    var kinds = ['click', 'dblclick'];
    function off() { kinds.forEach(function (k) { window.removeEventListener(k, eat, true); }); }
    function eat(event) {
      if (Date.now() > until) { off(); return; }
      if (allowX && !panel.hidden) {
        var x = event.target && event.target.closest ? event.target.closest('.ffc-sh-x') : null;
        if (x && panel.contains(x)) return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      console.info('[ff-cart] a tap within ' + ASK_DELAY + ' ms of the Change sheet opening / closing was ignored (it would have landed on what is under the finger).');
    }
    kinds.forEach(function (k) { window.addEventListener(k, eat, true); });
    setTimeout(off, ASK_DELAY + 50);
  }
  /* audit 1 finding 3: the drawer closing (Escape outside the sheet, its X, the overlay) closes an open sheet inside it too */
  function crSheetsDrawerClosed() {
    document.querySelectorAll('cart-drawer .ffc-sheet:not([hidden])').forEach(function (panel) {
      var wrap = panel.closest('.ffc-cr');
      var pill = wrap && wrap.querySelector('[data-ff-act="cr-toggle"]');
      if (pill) crClose(pill, panel, false);
    });
  }
  /* audit 1 finding 2: the sheet is a dialog, so Tab / Shift+Tab stay inside it while it is open */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var panel = event.target && event.target.closest ? event.target.closest('.ffc-sheet') : null;
    if (!panel || panel.hidden) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll('button, a[href], textarea, input, select'), function (node) {
      return !node.disabled && !node.hidden && node.getAttribute('tabindex') !== '-1' && node.getClientRects().length > 0;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && event.target === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && event.target === last) { event.preventDefault(); first.focus(); }
  }, true);

  /* Fix build (a), Todd 2026-10-09: "shouldn't the Change and Remove button on mobile expand upwards and not downwards? If it
     expands downwards, then it's below the subtotal banner, and sometimes you can't see it." Phones (under 750 px): the panel
     opens UP when it fits between the pill and the top of what the customer can see (the drawer's scrolling list, or under the
     pinned header on the /cart page); else down, as before. Wider screens: down, and up only when down would run past the
     bottom of what is visible and up fits. Then the panel is scrolled into view if any of it is still out of sight. Display
     only: no cart request. Any measuring error leaves the panel opening down (the old behaviour). */
  function crScrollBox(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;
  }

  /* Fix build (a2): a phone held sideways leaves the drawer's list only ~40 px tall, so the panel fits neither up nor down.
     Then it opens as a small sheet over the bottom of the drawer (position fixed, bottom-anchored so the Delete question grows
     upward, scrolls inside itself if taller than the drawer). The containing block may be a transformed drawer, so the
     position is measured after setting it and corrected once. */
  function crUnsheet(panel) {
    panel.classList.remove('ffc-crp--up', 'ffc-crp--sheet');
    ['left', 'bottom', 'width', 'max-height'].forEach(function (p) { panel.style.removeProperty(p); });
  }

  function crSheet(panel) {
    var frame = panel.closest('.drawer__inner');
    var fr = frame ? frame.getBoundingClientRect() : { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth };
    var vt = Math.max(0, fr.top), vb = Math.min(window.innerHeight, fr.bottom);
    var vl = Math.max(0, fr.left), vr = Math.min(window.innerWidth, fr.right);
    var w = Math.max(160, Math.min(300, vr - vl - 16));
    var wantLeft = vr - 8 - w, wantBottom = vb - 8;
    panel.classList.add('ffc-crp--sheet');
    panel.style.width = w + 'px';
    panel.style.maxHeight = Math.max(80, vb - vt - 16) + 'px';
    panel.style.left = wantLeft + 'px';
    panel.style.bottom = (window.innerHeight - wantBottom) + 'px';
    var got = panel.getBoundingClientRect();
    if (Math.abs(got.left - wantLeft) > 1) panel.style.left = (2 * wantLeft - got.left) + 'px';
    if (Math.abs(got.bottom - wantBottom) > 1) panel.style.bottom = (window.innerHeight - wantBottom + (got.bottom - wantBottom)) + 'px';
    /* (a2 fix, audit F2) the transformed drawer can itself scroll (phone sideways), which carries the sheet with it: place it
       again on that scroll, once per frame, while it is still an open sheet. */
    if (frame && !panel._ffSheetScroll) {
      var queued = false;
      panel._ffSheetScroll = true;
      frame.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          if (panel.hidden || !panel.isConnected || !panel.classList.contains('ffc-crp--sheet')) return;
          try { crSheet(panel); } catch (e) { console.error('[ff-cart] could not keep the "Change or remove" sheet in place.', e); }
        });
      }, { passive: true });
    }
  }

  /* (a2 fix, audit F1) "Delete this flag" makes the open panel taller (136 -> 162 px). On an iPhone 15 / 16 held sideways
     (726-734 px, list ~144 px) the grown panel ran under the SUBTOTAL bar and cut "Keep it" / "Yes, delete" in half. After
     the question opens: if any of the panel is out of sight, scroll it into view, or open it as the sheet when it is now
     taller than what the customer can see. Display only; any error leaves the panel where it is. */
  /* (a2 fix 2, audit A2fix F1) Moving the panel moves the card under the finger: a quick second tap on "Delete this flag"
     landed on the card's + and added a flag (measured: 1 flag -> 2 on an iPhone 16e held sideways, 150 ms double tap). For
     ASK_DELAY after a move, a tap / click anywhere except the open Delete question is swallowed on window capture (scripts that
     registered click listeners on window earlier still see it; none of them act on cart cards), so it can neither change the
     cart, close the panel nor follow "Start this flag over". "Keep it" / "Yes, delete" work as usual ("Yes, delete" keeps its
     own 400 ms guard). Also used when the pill's own tap moves the panel (crPlace: sheet or scroll). Removes itself after
     ASK_DELAY. Clicks only: nothing in the drawer acts on pointer / touch events today (audit A2fix2 F5). */
  function crHoldTaps(panel) {
    var until = Date.now() + ASK_DELAY;
    var kinds = ['click', 'dblclick'];
    function off() { kinds.forEach(function (k) { window.removeEventListener(k, eat, true); }); }
    function eat(event) {
      if (Date.now() > until) { off(); return; }
      /* (a2 fix 3, audit A2fix2 F1) only the open Delete question takes taps: "Start this flag over" can slide under the finger
         too and would leave the cart */
      var ask = panel.querySelector('.ffc-delask');
      if (ask && !ask.hidden && ask.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      console.info('[ff-cart] a tap within ' + ASK_DELAY + ' ms of the "Change or remove" panel moving was ignored (it would have landed on what slid under the finger).');
    }
    kinds.forEach(function (k) { window.addEventListener(k, eat, true); });
    setTimeout(off, ASK_DELAY + 50);
  }

  function crRefit(panel) {
    if (panel && !panel.hidden && panel.classList.contains('ffc-sheet')) {
      var ask = panel.querySelector('.ffc-delask:not([hidden])');
      if (ask) {
        var pr = panel.getBoundingClientRect(), ar = ask.getBoundingClientRect();
        /* Cart K2 (Todd's phone 2026-10-20, "The delete this flag is covered"): the pinned Done bar covers the sheet's bottom */
        var limit = pr.bottom, doneBar = panel.querySelector('.ffc-sh-done');
        if (doneBar && doneBar.getClientRects().length) limit = Math.min(limit, doneBar.getBoundingClientRect().top);
        if (ar.bottom > limit) panel.scrollTop += ar.bottom - limit + 8;
      }
      return;
    }
    if (!panel || panel.hidden || panel.classList.contains('ffc-crp--sheet')) return;
    try {
      var box = crScrollBox(panel);
      var top = 0, bottom = window.innerHeight;
      if (box) {
        var b = box.getBoundingClientRect();
        top = Math.max(top, b.top);
        bottom = Math.min(bottom, b.bottom);
      }
      var r = panel.getBoundingClientRect();
      if (r.top >= top && r.bottom <= bottom) return;
      crHoldTaps(panel);
      if (box && r.height > bottom - top) { panel.classList.remove('ffc-crp--up'); crSheet(panel); return; }
      panel.scrollIntoView({ block: 'nearest' });
    } catch (e) {
      console.error('[ff-cart] could not re-fit the "Change or remove" panel after the Delete question opened.', e);
    }
  }

  function crPlace(button, panel) {
    crUnsheet(panel);
    try {
      var phone = window.matchMedia && window.matchMedia('(max-width:749px)').matches;
      var box = crScrollBox(panel);
      var top = 0, bottom = window.innerHeight;
      if (box) {
        var br = box.getBoundingClientRect();
        top = Math.max(top, br.top);
        bottom = Math.min(bottom, br.bottom);
      } else {
        var head = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
        var hr = head && head.getBoundingClientRect();
        if (hr && hr.bottom > 0 && hr.top <= 0 + 1) top = Math.max(top, hr.bottom);
      }
      var h = panel.offsetHeight;
      var pr = button.getBoundingClientRect();
      var upFits = pr.top - 6 - h >= top;
      var downFits = pr.bottom + 6 + h <= bottom;
      if (box && !upFits && !downFits && h > bottom - top) { crHoldTaps(panel); crSheet(panel); return; }
      if (upFits && (phone || !downFits)) panel.classList.add('ffc-crp--up');
      var r = panel.getBoundingClientRect();
      if (r.top < top || r.bottom > bottom) { crHoldTaps(panel); panel.scrollIntoView({ block: 'nearest' }); }
    } catch (e) {
      crUnsheet(panel);
      console.error('[ff-cart] could not place the "Change or remove" panel; it opens down.', e);
    }
  }

  /* Turning the phone with a panel open: place it again (width changes only; iOS changes the height while scrolling). */
  var crLastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === crLastW) return;
    crLastW = window.innerWidth;
    document.querySelectorAll('.ffc-crp:not([hidden])').forEach(function (panel) {
      if (panel.classList.contains('ffc-sheet')) { crSheetPlace(panel); return; }
      var wrap = panel.closest('.ffc-cr');
      var pill = wrap && wrap.querySelector('[data-ff-act="cr-toggle"]');
      if (pill) crPlace(pill, panel);
    });
  });

  /* Fix build (a), Todd 2026-10-09: "that weird teal box came back when I went all the way to checkout and then went backwards".
     The teal box is the header's keyboard focus ring (.ffhd a:focus-visible) drawn on the cart icon when the drawer hands focus
     back to it, or when the page comes back from checkout. Keep it for keyboard users only: a key press (Tab, arrows, Enter,
     Space, Escape) turns keyboard mode on (html.ff-kb), a tap / click turns it off, and a page restored from the back button
     starts with it off. Without ff-kb, ff-cart.css hides the ring on the cart icon only. */
  document.addEventListener('keydown', function (event) {
    if (/^(Tab|Arrow|Enter$| $|Escape$|Home$|End$|Page)/.test(event.key)) document.documentElement.classList.add('ff-kb');
  }, true);
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function () { document.documentElement.classList.remove('ff-kb'); }, { capture: true, passive: true });
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) document.documentElement.classList.remove('ff-kb');
  });

  /* Fix build (b), Todd 2026-10-09: "When you go into the motorcycle flag and with custom flags product and music festival
     flags and you click the reviews on mobile, it shoots down to the other suggestions. It doesn't shoot all the way down to
     the reviews." The stars link (<a href="#rapid_reviews_items">) jumps to where the reviews are at tap time; the "related
     products" block above them fills in afterwards and pushes them down (reproduced in Chrome on 15 of 65 taps, same on the
     theme before). After the browser's own jump, keep the reviews' top just under the pinned header (or the top of the
     screen) for up to 6 s while the page settles. Stops at once when the shopper touches, scrolls, clicks or presses a key.
     Only that one link; no request; nothing runs until it is tapped. */
  var REV_ID = 'rapid_reviews_items';

  function revTarget() {
    var all = document.querySelectorAll('[id="' + REV_ID + '"]');
    for (var k = 0; k < all.length; k++) if (all[k].getClientRects().length) return all[k];
    return null;
  }

  function revHeadBottom() {
    /* the pinned header = the first sticky / fixed box from the header up (today: the header-group section, sticky) */
    var head = document.querySelector('.ffhd, sticky-header, .section-header');
    for (var n = head; n && n !== document.body; n = n.parentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var r = n.getBoundingClientRect();
        return r.top <= 1 && r.bottom > 0 ? r.bottom : 0;
      }
    }
    return 0;
  }

  function revScrollBy(d) {
    var top = window.scrollY + d;
    try { window.scrollTo({ top: top, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, top); }
  }

  function revAim() {
    var stop = false, t0 = Date.now();
    var kinds = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    function cancel() { stop = true; }
    function done() { kinds.forEach(function (k) { window.removeEventListener(k, cancel, true); }); }
    setTimeout(function () { kinds.forEach(function (k) { window.addEventListener(k, cancel, { capture: true, passive: true }); }); }, 0);
    /* (a2) 6 s, or until 2 s after the page has finished loading (slow phones), at most 15 s. The reviews block also gets a
       scroll margin = the header's height, so a late jump by the browser or the reviews app to the bare anchor lands under
       the header instead of behind it. */
    var until = t0 + 6000;
    (function tick() {
      var now = Date.now();
      if (document.readyState !== 'complete' && now - t0 < 13000) until = Math.max(until, now + 2000);
      if (stop || now > until) { done(); return; }
      try {
        var el = revTarget();
        if (el) {
          var hb = revHeadBottom();
          el.style.scrollMarginTop = (hb + 8) + 'px';
          var d = el.getBoundingClientRect().top - (hb + 8);
          if (Math.abs(d) > 40) revScrollBy(d);
        }
      } catch (e) {
        console.error('[ff-cart] reviews jump re-aim stopped.', e);
        done();
        return;
      }
      setTimeout(tick, 200);
    })();
  }

  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!a || event.defaultPrevented) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0 || href.slice(i + 1) !== REV_ID) return;
    if (i > 0 && (a.pathname !== window.location.pathname || a.host !== window.location.host)) return;
    revAim();
  });

  /* Outside click: any click / tap that is not inside a card's pill-and-panel wrapper closes every open drop-down. */
  document.addEventListener('click', function (event) {
    var wrap = event.target && event.target.closest ? event.target.closest('.ffc-cr') : null;
    crCloseAll(wrap ? wrap.querySelector('.ffc-crp') : null);
  });

  /* The note textarea sits inside Dawn's <cart-items> / <cart-drawer-items>, whose 'change' listener treats EVERY change
     event as a quantity input (cart.js onChange -> validateQuantity -> resetQuantityInput: a TypeError on our textarea, and
     a note that is just a number would have been passed on as a quantity). Seen live 2026-09-22 on the first typed save.
     Stop the textarea's change event in the capture phase, so it never reaches them; nothing else listens for it. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.hasAttribute && (target.hasAttribute('data-ff-note') || target.hasAttribute('data-ff-date'))) event.stopPropagation();
  }, true);

  /* Escape inside the note box = Cancel (text back to the saved note, editor closed, focus on Edit), chosen 2026-09-22 so the
     customer never loses the whole drawer and the typed text in one key. Dawn's <cart-drawer> closes on the Escape KEYUP, and
     by then focus is on the Edit button, so that one keyup is swallowed; a second Escape closes the drawer as before. */
  var swallowEscapeUp = false;
  /* audit G3 (step 6B): the preview's 1 s reset must only clear a swallow the preview itself set; every setter bumps this */
  var swallowToken = 0;
  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (event.key !== 'Escape' || !target || !target.closest) return;
    var cancel = null;
    if (target.hasAttribute('data-ff-note')) {
      var fold = target.closest('[data-ff-notefold]');
      cancel = fold && fold.querySelector('[data-ff-act="note-cancel"]');
    } else if (target.hasAttribute('data-ff-date')) {
      var dfold = target.closest('[data-ff-datefold]');
      cancel = dfold && dfold.querySelector('[data-ff-act="date-cancel"]');
    } else {
      /* step 6: Escape inside an open "Delete flag?" confirm = Keep it (the drawer stays open, same as the note box) */
      var ask = target.closest('.ffc-delask');
      cancel = ask && !ask.hidden ? ask.querySelector('[data-ff-act="delete-keep"]') : null;
      /* v23: Escape in the open "Change or remove" panel (or on its pill) closes the panel; the drawer stays open */
      if (!cancel) {
        /* compact cart: Escape inside the open "Edit this flag" / golf Edit choices is their own Cancel (below); the sheet stays */
        if (target.closest('.ffc-one-p:not([hidden]), .ffc-ed-p:not([hidden])')) return;
        var card = target.closest('.ffc-card');
        var pill = card && card.querySelector('[data-ff-act="cr-toggle"][aria-expanded="true"]');
        if (pill && (target === pill || target.closest('.ffc-crp'))) cancel = pill;
      }
    }
    if (!cancel) return;
    event.preventDefault();
    event.stopPropagation();
    swallowToken++;
    swallowEscapeUp = true;
    cancel.click();
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' || !swallowEscapeUp) return;
    swallowEscapeUp = false;
    event.stopPropagation();
  }, true);

  /* Artwork preview (step 6B, 2026-09-22; Todd: "View" downloaded the file instead of showing it). Uploadery serves every upload
     as binary/octet-stream, so following the link downloads it, but an <img> still draws it (the thumbnails prove it). A plain
     click / tap on an image's thumbnail or View ([data-ff-preview], images on https:// only, set by snippets/ff-cart-cards.liquid)
     opens it large in a modal <dialog>: top layer, so above the drawer; X, Escape or a tap outside the picture closes it and focus
     goes back to that file's View link. The dialog is made once on <body>, outside the drawer and the /cart sections, so no
     redraw can remove it while it is open. Ctrl / Cmd / Shift / middle clicks and a browser without <dialog> keep the plain link. */
  var preview = null;
  var previewFrom = null;

  function previewDialog() {
    if (preview) return preview;
    var dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return null;
    dialog.className = 'ff-art-dlg';
    dialog.setAttribute('aria-label', 'Artwork preview');
    dialog.innerHTML =
      '<div class="ff-art-dlg__box">' +
        '<img class="ff-art-dlg__img" alt="">' +
        '<p class="ff-art-dlg__err" hidden>This file cannot be shown here. Use Download to open it.</p>' +
        '<div class="ff-art-dlg__bar">' +
          '<span class="ff-art-dlg__name"></span>' +
          '<a class="ff-art-dlg__dl" target="_blank" rel="noopener" download>Download</a>' +
          '<button type="button" class="ff-art-dlg__close" aria-label="Close preview">Close ✕</button>' +
        '</div>' +
      '</div>';
    var image = dialog.querySelector('.ff-art-dlg__img');
    image.addEventListener('error', function () {
      if (!image.getAttribute('src')) return;
      image.hidden = true;
      dialog.querySelector('.ff-art-dlg__err').hidden = false;
    });
    dialog.querySelector('.ff-art-dlg__close').addEventListener('click', function () { dialog.close(); });
    /* a tap on the dark backdrop lands on the <dialog> itself; taps on the picture or its bar land on their own nodes */
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    /* Escape: the browser closes the dialog on KEYDOWN; focus is then back on the View link inside <cart-drawer>, which closes
       the whole drawer on the Escape KEYUP. Swallow that one keyup (same as the note box). */
    function swallowNextEscapeUp() {
      /* a phone's back gesture also cancels, with no keyup after it: forget the swallow after a second */
      var mine = ++swallowToken;
      swallowEscapeUp = true;
      window.setTimeout(function () { if (swallowToken === mine) swallowEscapeUp = false; }, 1000);
    }
    /* Escape is handled here, not left to the browser's own dialog cancel: a real Escape keydown reached the page in the
       2026-09-22 test and nothing prevented it, yet the dialog's cancel never fired, so the preview would not close. */
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      swallowNextEscapeUp();
      dialog.close();
    });
    dialog.addEventListener('cancel', swallowNextEscapeUp);
    dialog.addEventListener('close', function () {
      image.removeAttribute('src');
      /* audit G1 (step 6B): a second queued close (tab not drawing) finds previewFrom already cleared: nothing to do */
      var from = previewFrom;
      previewFrom = null;
      if (!from) return;
      var back = from.node;
      if (!back || !back.isConnected) back = previewBack(from);
      if (back) back.focus({ preventScroll: true });
    });
    document.body.appendChild(dialog);
    preview = dialog;
    return dialog;
  }

  /* A redraw replaced the card while the preview was open. Audit G2 (step 6B): first the same file's View link on the SAME card
     (same surface, same position), so one file on two flags cannot send focus to the other flag; then any card on that surface. */
  function previewBack(from) {
    var root = document.querySelector(from.inDrawer ? '#CartDrawer [data-ff-cart]' : '#main-cart-items [data-ff-cart]');
    var holder = root && from.index > -1 ? root.querySelectorAll('[data-ff-keys]')[from.index] : null;
    var back = null;
    [holder, root].forEach(function (scope) {
      if (back || !scope) return;
      scope.querySelectorAll('.ffc-art-v[data-ff-preview]').forEach(function (link) {
        if (!back && link.getAttribute('href') === from.url && usable(link)) back = link;
      });
    });
    return back;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-ff-preview]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url = link.getAttribute('href') || '';
    if (url.slice(0, 8).toLowerCase() !== 'https://') return;
    var dialog = previewDialog();
    if (!dialog) return;
    event.preventDefault();
    var image = dialog.querySelector('.ff-art-dlg__img');
    var name = link.getAttribute('data-ff-file') || '';
    image.hidden = false;
    dialog.querySelector('.ff-art-dlg__err').hidden = true;
    image.setAttribute('alt', name ? 'Artwork: ' + name : 'Artwork');
    image.setAttribute('src', url);
    dialog.querySelector('.ff-art-dlg__name').textContent = name;
    dialog.querySelector('.ff-art-dlg__dl').setAttribute('href', url);
    /* the thumbnail is a mouse shortcut with no tab stop: focus goes back to that file's View link */
    var row = link.closest('li');
    var view = row && row.querySelector('.ffc-art-v');
    var intent = controlIntent(link);
    previewFrom = { node: view || link, url: url, inDrawer: !!link.closest('cart-drawer'), index: intent ? intent.index : -1 };
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('.ff-art-dlg__close').focus({ preventScroll: true });
  });

  /* Cart edit, slice C1 (Todd 2026-10-07: "the ability to edit that particular flag ... especially people being able to take
     away the design fee"; "Yes, they can always drop it down"). DESIGN HELP on a flag card: Edit -> the choices with Shopify's
     live add-on prices -> Save / Cancel. Nothing changes until Save; Cancel and closing the drawer change nothing.
     Save REBUILDS the flag the way a real Add to cart of the same choices does (handoff "Cart edit" rules 1-5):
       - every property of the flag line is copied byte for byte from a fresh /cart.js read; only the edited field changes, and
         _io_order_group gets a NEW value when a paid add-on remains (none when everything is free, as a real add);
       - add-ons are posted first, in reverse of the flag's own field order, then the flag, one /cart/add.js each, so Shopify
         (newest line first) shows the flag directly followed by ALL its own add-ons, as Infinite Options' own add does;
         untouched add-ons (FINISHING, STITCHING) are re-created from their OLD line (variant, own quantity, field name); a new
         paid design help gets the flag's quantity; a paid -> paid change keeps the old add-on's own quantity;
       - the adds go to /cart/add.js?kaching_bundles=true, a URL Kaching's own interceptor leaves alone (C0 read), so Kaching
         cannot rewrite the re-added flag; the flag keeps its __kaching_bundles property;
       - VERIFY BEFORE REMOVING: a fresh /cart.js must show every line that existed before untouched and exactly the expected new
         lines; only then are the old lines removed, by KEY. Anything else (a merge, an app rewriting an add, a lost answer) is a
         failed add: this Save's own new lines are removed, a changed old line gets its quantity back, and the message says only
         what a fresh /cart.js read proves.
     Edit shows only where every check passes (fail closed): Infinite Options' option-sets matched to the product exactly as its
     own customizery.js does (whole tag, case ignored; ANY rule in a list, ALL lists), only tag rules with no / is / isnot
     operator store-wide, exactly one DESIGN field, no conditional rules, 2+ values, the line's value in the list, one add-on
     line per paid field whose variant equals the list's, and the flag not sharing its group / bundle with another flag line.
     The option-sets file and the product's tags load in the background after the cart is shown (never before Check out is
     usable); the add-on prices load only when Edit is tapped. While a Save runs, Check out, express checkout, every card
     control and every other Edit are blocked, leaving the page asks first, and a marker in browser storage makes the next cart
     render say "Please check this flag in your cart. It may appear twice." if the page was left halfway.
     Slice C2: the same Edit, checks and Save for STITCHING (each product's own list and exact field name, e.g. the
     motorcycle's "STITCHING  "); a list with fewer than 2 values gets no Edit (the ready-to-ship skull). One Edit row per
     field, design help first; every add-on that is not being edited (design help, FINISHING) is re-created from its old line.
     Slice F1 (Todd 2026-10-07: "why can't you edit the finishing?"; handoff "Cart finishing edit" rules 1-6): the same Edit,
     checks and Save for FINISHING (grommets / sleeves), on top of every check above. Extra fail-closed rules for FINISHING
     only: the field must be a single-choice select or radio (a checkbox, e.g. utahoffroadcustom, gets no Edit), and golf gets
     no Edit (the GOLF FLAGS set, or any finishing value naming a "Pack": the 18-pack tube inserts' quantity rule is unknown).
     A flag with no finishing on its line (the motorcycle's finishing is optional) gets no Edit: the line must already carry a
     value from the list. The new finishing add-on lands directly below its own flag, exactly where a real Add to cart puts it,
     because Tina's sheet builder gives a sleeve / grommet add-on to the flag ABOVE it. */
  var ED_FIELDS = [
    { key: 'DESIGN', label: 'Design help', done: 'Design help changed.' },
    { key: 'STITCHING', label: 'Stitching', done: 'Stitching changed.' },
    { key: 'FINISHING', label: 'Finishing', done: 'Finishing changed.' }
  ];
  var ED_GOLF_SET = '6a0f0e7e6fdbd745100ed12d';
  function edField(key) { return ED_FIELDS.filter(function (one) { return one.key === key; })[0] || null; }
  var ED_SETS_URL = 'https://d1liekpayvooaz.cloudfront.net/apps/customizery/option-sets.json?uuid=festflags';
  var ED_ADD_URL = '/cart/add.js?kaching_bundles=true';
  var ED_MARK = 'ff-cart-edit-saving';
  var ED_MSG_NOTHING = "Couldn't save that change. Nothing was changed.";
  var ED_MSG_CHECK = "Couldn't save that change. Please check this flag in your cart.";
  var ED_MSG_TWICE = 'Please check this flag in your cart. It may appear twice.';
  var ED_MSG_FINAL = 'Please check this flag in your cart.';
  var edSets = null;
  var edSetsLoading = null;
  var edTags = {};
  var edSaving = false;
  var edScanTimer = 0;
  /* (d) the last cart we were handed (a write's answer, a redraw's state or a /cart.js read): lets a redraw put "Change",
     "Add artwork" and "Edit this flag" back on the new cards before the screen paints, instead of ~0.5 s later after a fresh
     read (measured 2026-10-10: both vanished for ~28 frames on every + / - tap and the list jumped 10-20 px when they came back).
     Display only: the Change artwork screen and the Edit panel each re-read the cart before doing anything, and edScanNow's
     fresh read removes these controls again and redraws them if that cart differs. */
  var edKnown = null;
  /* a Save's message survives Dawn's own re-fetch (which redraws the drawer, error box included, 1-4 s later): shown again after
     every redraw for 15 s */
  var edNotice = null;
  function edNotify(text) {
    edNotice = { text: text, until: Date.now() + 15000 };
    showError(null, text);
    announce(text);
  }
  function edNoticeAgain() {
    if (!edNotice) return;
    if (Date.now() > edNotice.until) { edNotice = null; return; }
    var box = document.querySelector('cart-drawer.active [data-ff-error]') || document.querySelector('#main-cart-items [data-ff-error]') || document.querySelector('[data-ff-error]');
    if (box && (box.hidden || box.textContent !== edNotice.text)) showError(null, edNotice.text);
  }

  function edNorm(name) { return String(name == null ? '' : name).trim().toUpperCase().replace(/:$/, '').trim(); }
  function edShort(text) {
    return String(text || '').split('{')[0].split('(+')[0].trim().replace(/\+$/, '').trim();
  }
  /* S1d (Todd 2026-10-08: "Don't you think these should be defined more, like what we have in the actual product? Maybe just
     make it a smaller font so they understand what they're getting"): the words AFTER the price part of IO's own value text,
     shown as a small second line under the option (e.g. "Add, multiple images, effects, patterns, color, resizing, 3 edit
     max."). Display only; the cart line, the order and every saved value keep IO's full text byte for byte. */
  function edDetail(text) {
    var full = String(text || '');
    var price = /(\{[^}]*\}|\(\+[^)]*\))/.exec(full);
    if (!price) return '';
    return full.slice(price.index + price[0].length).replace(/^[\s\-–—:+]+/, '').replace(/\s{2,}/g, ' ').trim();
  }
  function edLabel(span, label) {
    span.textContent = edShort(label);
    var detail = edDetail(label);
    if (!detail) return;
    var small = document.createElement('small');
    small.className = 'ffc-ed-sub';
    small.textContent = detail;
    span.appendChild(small);
  }
  function edJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + url.split('?')[0]);
      return response.json();
    });
  }
  function edCart() { return edJSON('/cart.js').then(function (cart) { edNoteCart(cart); return cart; }); }
  function edNoteCart(cart) {
    if (cart && Array.isArray(cart.items)) edKnown = { cart: cart, at: Date.now() };
  }
  function edCartSig(cart) {
    return JSON.stringify(((cart && cart.items) || []).map(function (item) { return [item.key, item.quantity, item.handle, item.product_id, item.properties]; }));
  }
  /* what artScan / artAddSlot / oneSlot / edSlot add to a card (artNotice's message stays) */
  function edStripFast(card) {
    Array.prototype.forEach.call(card.querySelectorAll('.ffc-art-x, .ffc-art-add, .ffc-one-btn, .ffc-one-p, .ffc-ed'), function (node) { node.remove(); });
    Array.prototype.forEach.call(card.querySelectorAll('.ffc-art-has-chg'), function (node) { node.classList.remove('ffc-art-has-chg'); });
  }
  /* (d) called from the drawer / cart-page observer, in the same task as the redraw: same code as edScanNow, on the known cart */
  function edFastScan() {
    if (!edKnown || Date.now() - edKnown.at > 15000 || edSaving || !edVisibleSurface()) return;
    var cards = edCards().filter(function (card) { return !card.hasAttribute('data-ff-edseen') && !card._ffFast; });
    if (!cards.length) return;
    var cart = edKnown.cart;
    var sig = edCartSig(cart);
    cards.forEach(function (card) { card._ffFast = sig; card._ffTok = {}; });
    try { artScan(cards, cart); } catch (error) { console.warn('[ff-cart] Change artwork not shown yet (fail closed): ' + error.message); }
    if (edSets) {
      try { edSlots(cards, cart); } catch (error) { console.warn('[ff-cart] cart Edit not shown yet (fail closed): ' + error.message); }
    }
  }

  /* Infinite Options' matcher, same semantics as customizery.js configAppliesToProduct (read 2026-10-07). Only tag rules reach
     it: edSetsUsable() refuses the whole file when any other rule type or operator exists. */
  function edRuleOk(rule, tags) {
    var hit = tags.join(',').toLowerCase().split(',').indexOf(String(rule.selector).toLowerCase()) >= 0;
    return rule.operator === 'isnot' ? !hit : hit;
  }
  function edSetApplies(set, tags) {
    if (!set || !set.ruleSets || !set.ruleSets.length) return false;
    return set.ruleSets.every(function (list) {
      return (list || []).some(function (rule) { return rule && rule.type && rule.selector && edRuleOk(rule, tags); });
    });
  }
  function edSetsUsable(sets) {
    if (!Array.isArray(sets) || !sets.length) return false;
    return sets.every(function (set) {
      return (set.ruleSets || []).every(function (list) {
        return (list || []).every(function (rule) {
          var op = rule && rule.operator;
          return rule && rule.type === 'tag' && (op === undefined || op === null || op === '' || op === 'is' || op === 'isnot');
        });
      });
    });
  }
  function edHasConditional(input) {
    return !!(input && input.conditional && Array.isArray(input.conditional.rules) && input.conditional.rules.length);
  }

  function edLoadSets() {
    if (edSets) return Promise.resolve(edSets);
    if (!edSetsLoading) {
      edSetsLoading = edJSON(ED_SETS_URL).then(function (sets) {
        edSets = sets;
        return sets;
      }, function (error) {
        edSetsLoading = null;
        throw error;
      });
    }
    return edSetsLoading;
  }
  /* (c) one read per product even when the Edit scan and the Add artwork scan ask at the same time */
  var edTagsLoading = {};
  function edLoadTags(handle) {
    if (edTags[handle]) return Promise.resolve(edTags[handle]);
    if (!edTagsLoading[handle]) {
      edTagsLoading[handle] = edJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (product) {
        edTags[handle] = { id: product.id, tags: product.tags || [] };
        return edTags[handle];
      }, function (error) {
        delete edTagsLoading[handle];
        throw error;
      });
    }
    return edTagsLoading[handle];
  }

  /* Every Edit check, on ONE /cart.js read. Returns null (no Edit) or what Save needs. */
  function edCheck(cart, flagKey, want) {
    if (!edField(want) || !edSets || !edSetsUsable(edSets)) return null;
    var items = cart.items || [];
    var flag = null;
    items.forEach(function (item) { if (item.key === flagKey) flag = item; });
    if (!flag || !flag.properties || flag.properties._io_parent_order_group) return null;
    var product = edTags[flag.handle];
    if (!product || product.id !== flag.product_id) return null;
    var matched = edSets.filter(function (set) { return edSetApplies(set, product.tags); });
    var inputs = [];
    var owners = [];
    var conditional = false;
    matched.forEach(function (set) {
      (set.inputs || []).forEach(function (input) {
        inputs.push(input);
        owners.push(set);
        if (edHasConditional(input)) conditional = true;
      });
    });
    if (conditional) return null;
    var named = inputs.filter(function (input) { return edNorm(input.name) === want; });
    if (named.length !== 1) return null;
    var field = named[0];
    var values = (field.values || []).filter(function (value) { return value && typeof value.label === 'string'; });
    if (values.length < 2 || values.length !== (field.values || []).length) return null;
    if (want === 'FINISHING') {
      var owner = owners[inputs.indexOf(field)];
      if ((field.type !== 'select' && field.type !== 'radio') || field.multi) return null;
      if (!owner || owner._id === ED_GOLF_SET || field.optionset_id === ED_GOLF_SET) return null;
      if (values.some(function (value) { return /pack/i.test(value.label); })) return null;
    }
    var props = flag.properties;
    var fieldKeys = Object.keys(props).filter(function (key) { return edNorm(key) === want; });
    if (fieldKeys.length !== 1 || fieldKeys[0] !== field.name) return null;
    var current = props[field.name];
    var currentValue = values.filter(function (value) { return value.label === current; });
    if (currentValue.length !== 1) return null;
    /* shared lines: no Edit when another flag line carries the same group, or (no group) the same product + bundle string */
    var group = props._io_order_group || '';
    var others = items.filter(function (item) {
      if (item.key === flag.key || !item.properties || item.properties._io_parent_order_group) return false;
      if (group) return item.properties._io_order_group === group;
      return item.product_id === flag.product_id && !!props.__kaching_bundles && item.properties.__kaching_bundles === props.__kaching_bundles;
    });
    if (others.length) return null;
    /* runtime add-on check: ONE add-on line per paid field, each with the variant the list gives for the flag's value */
    var addons = group ? items.filter(function (item) { return item.properties && item.properties._io_parent_order_group === group; }) : [];
    var seen = {};
    var ok = true;
    addons.forEach(function (line) {
      var name = edNorm(line.properties._io_field_name);
      if (!name || seen[name]) { ok = false; return; }
      seen[name] = line;
      var input = inputs.filter(function (one) { return edNorm(one.name) === name; });
      if (input.length !== 1) { ok = false; return; }
      var flagKeys = Object.keys(props).filter(function (key) { return edNorm(key) === name; });
      if (flagKeys.length !== 1) { ok = false; return; }
      var chosen = (input[0].values || []).filter(function (value) { return value && value.label === props[flagKeys[0]]; });
      var variant = chosen.length === 1 && chosen[0].variant && chosen[0].variant.variantId;
      if (!variant || Number(variant) !== Number(line.variant_id)) ok = false;
    });
    if (!ok) return null;
    /* and no paid choice on the flag without its add-on line */
    Object.keys(props).forEach(function (key) {
      var input = inputs.filter(function (one) { return one.name === key; });
      if (input.length !== 1) return;
      var chosen = (input[0].values || []).filter(function (value) { return value && value.label === props[key]; });
      if (chosen.length === 1 && chosen[0].variant && chosen[0].variant.variantId && !seen[edNorm(key)]) ok = false;
    });
    if (!ok) return null;
    return { cart: cart, flag: flag, want: want, field: field, values: values, current: current, addons: addons, group: group };
  }

  /* ---------- the Edit control on each card ---------- */
  function edCards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ff-cart] article.ffc-card[data-ff-keys]'));
  }
  function edVisibleSurface() {
    var drawer = document.querySelector('cart-drawer');
    return !!document.getElementById('main-cart-items') || !!(drawer && drawer.classList.contains('active'));
  }
  function edScan() {
    clearTimeout(edScanTimer);
    edScanTimer = setTimeout(edScanNow, 120);
  }
  function edScanNow() {
    edMarkerCheck();
    edNoticeAgain();
    if (edSaving || !edVisibleSurface()) return;
    var cards = edCards().filter(function (card) { return !card.hasAttribute('data-ff-edseen'); });
    if (!cards.length) return;
    cards.forEach(function (card) { card.setAttribute('data-ff-edseen', ''); });
    /* timeout: a hidden tab may never be idle (audit C1 #2) */
    var idle = window.requestIdleCallback ? function (fn) { return window.requestIdleCallback(fn, { timeout: 2000 }); } : function (fn) { return setTimeout(fn, 1); };
    idle(function () {
      var cart;
      edCart()
        .then(function (read) {
          cart = read;
          /* (d) controls drawn early from another cart than this fresh read: take them off and draw them again from this one */
          var sig = edCartSig(cart);
          cards.forEach(function (card) {
            if (card._ffFast && card._ffFast !== sig) edStripFast(card);
            card._ffFast = null;
            card._ffTok = {};
          });
          try { artScan(cards, cart); } catch (error) { console.warn('[ff-cart] Change artwork not shown (fail closed): ' + error.message); }
          return edLoadSets();
        })
        .then(function () {
          var handles = {};
          (cart.items || []).forEach(function (item) {
            if (item.properties && !item.properties._io_parent_order_group && Object.keys(item.properties).some(function (k) { return !!edField(edNorm(k)); })) handles[item.handle] = true;
          });
          return Promise.all(Object.keys(handles).map(function (handle) { return edLoadTags(handle).catch(function () { return null; }); }));
        })
        .then(function () {
          if (edSaving) return;
          edSlots(cards, cart);
        })
        .catch(function (error) {
          /* (d) no fresh read = no controls, as before (early ones came from an unconfirmed cart) */
          cards.forEach(function (card) { if (card._ffFast) { edStripFast(card); card._ffFast = null; } });
          console.warn('[ff-cart] cart Edit not shown (fail closed): ' + error.message);
        });
    });
  }
  function edSlots(cards, cart) {
    cards.forEach(function (card) {
      if (!card.isConnected) return;
      var flagKey = card.getAttribute('data-ff-keys').split(',')[0];
      if (card.hasAttribute('data-ff-one')) {
        try { oneSlot(card, cart); } catch (error) { console.warn('[ff-cart] Edit this flag not shown (fail closed): ' + error.message); }
        return;
      }
      ED_FIELDS.forEach(function (one) {
        if (card.querySelector('.ffc-ed[data-ff-edfield="' + one.key + '"]')) return;
        var check = edCheck(cart, flagKey, one.key);
        if (check) edSlot(card, check);
      });
    });
  }
  function edRef(card) {
    var num = card.querySelector('.ffc-num');
    return num ? num.textContent.trim().toLowerCase() : 'this flag';
  }
  function edSlot(card, check) {
    var led = card.querySelector('.ffc-led');
    if (!led) return;
    var ref = edRef(card);
    var info = edField(check.want);
    var slot = document.createElement('div');
    slot.className = 'ffc-ed';
    slot.setAttribute('data-ff-edkey', check.flag.key);
    slot.setAttribute('data-ff-edfield', check.want);
    var head = document.createElement('div');
    head.className = 'ffc-ed-h';
    var label = document.createElement('span');
    label.className = 'ffc-ed-now';
    var small = document.createElement('small');
    small.textContent = info.label;
    var now = document.createElement('span');
    now.textContent = edShort(check.current);
    label.appendChild(small);
    label.appendChild(now);
    var open = document.createElement('button');
    open.type = 'button';
    open.className = 'ffc-link ffc-ed-open';
    open.setAttribute('data-ff-ed', 'open');
    open.setAttribute('aria-expanded', 'false');
    open.setAttribute('aria-label', 'Edit ' + info.label.toLowerCase() + ' for ' + ref);
    open.textContent = 'Edit';
    head.appendChild(label);
    head.appendChild(open);
    var panel = document.createElement('div');
    panel.className = 'ffc-ed-p';
    panel.hidden = true;
    var status = document.createElement('p');
    status.className = 'ffc-ed-msg';
    status.setAttribute('role', 'status');
    status.hidden = true;
    slot.appendChild(head);
    slot.appendChild(panel);
    slot.appendChild(status);
    /* one row per field, in ED_FIELDS order (design help, then stitching), directly after the card's price rows; compact cart:
       at the top of the Change sheet ([data-ff-oneslot]) when the card has one */
    var host = card.querySelector('[data-ff-oneslot]');
    var rows = Array.prototype.slice.call(card.querySelectorAll('.ffc-ed'));
    var after = host ? null : led;
    rows.forEach(function (row) {
      if (ED_FIELDS.indexOf(edField(row.getAttribute('data-ff-edfield'))) < ED_FIELDS.indexOf(info)) after = row;
    });
    if (after) after.parentNode.insertBefore(slot, after.nextSibling);
    else host.insertBefore(slot, host.firstChild);
  }
  function edSay(slot, text) {
    var box = slot && slot.isConnected && slot.querySelector('.ffc-ed-msg');
    if (box) {
      box.textContent = text;
      box.hidden = false;
    } else {
      showError(null, text);
    }
    announce(text);
  }
  function edMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function edOpen(slot, button) {
    var panel = slot.querySelector('.ffc-ed-p');
    if (!panel) return;
    if (!panel.hidden) { edClose(slot); return; }
    var card = slot.closest('.ffc-card');
    var ref = edRef(card);
    var key = slot.getAttribute('data-ff-edkey');
    var want = slot.getAttribute('data-ff-edfield');
    var info = edField(want);
    if (!info) return;
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    panel.textContent = 'Loading the choices…';
    var check;
    edCart()
      .then(function (cart) {
        check = edCheck(cart, key, want);
        if (!check) throw new Error('this flag cannot be changed here');
        /* live Shopify prices for every paid choice (never Infinite Options' stored price or its text) */
        var handles = {};
        check.values.forEach(function (value) { if (value.variant && value.variant.variantId) handles[value.variant.handle] = true; });
        return Promise.all(Object.keys(handles).map(function (handle) {
          return edJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (product) { return [handle, product]; });
        })).then(function (pairs) {
          var byHandle = {};
          pairs.forEach(function (pair) { byHandle[pair[0]] = pair[1]; });
          return { currency: check.cart.currency, byHandle: byHandle };
        });
      })
      .then(function (live) {
        if (panel.hidden) return;
        panel.textContent = '';
        var set = document.createElement('fieldset');
        var legend = document.createElement('legend');
        legend.textContent = info.label + ' for ' + ref;
        set.appendChild(legend);
        var name = 'ffed-' + Math.random().toString(36).slice(2);
        var usable = 0;
        check.values.forEach(function (value, index) {
          var row = document.createElement('label');
          row.className = 'ffc-ed-o';
          var radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = name;
          radio.value = String(index);
          radio.checked = value.label === check.current;
          var text = document.createElement('span');
          edLabel(text, value.label);
          var price = document.createElement('b');
          if (value.variant && value.variant.variantId) {
            var product = live.byHandle[value.variant.handle];
            var variant = product && (product.variants || []).filter(function (one) { return Number(one.id) === Number(value.variant.variantId); })[0];
            if (!variant) {
              radio.disabled = true;
              price.textContent = 'Not available';
            } else if (!variant.available) {
              radio.disabled = true;
              price.textContent = 'Sold out';
            } else {
              price.textContent = '+' + edMoney(variant.price, live.currency);
              usable++;
            }
          } else {
            price.textContent = 'Included';
            usable++;
          }
          if (radio.checked) radio.disabled = false;
          row.appendChild(radio);
          row.appendChild(text);
          row.appendChild(price);
          set.appendChild(row);
        });
        panel.appendChild(set);
        var bar = document.createElement('div');
        bar.className = 'ffc-ed-bar';
        var save = document.createElement('button');
        save.type = 'button';
        save.className = 'ffc-ghost ffc-save';
        save.setAttribute('data-ff-ed', 'save');
        save.setAttribute('aria-label', 'Save ' + info.label.toLowerCase() + ' for ' + ref);
        save.textContent = 'Save';
        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'ffc-link';
        cancel.setAttribute('data-ff-ed', 'cancel');
        cancel.setAttribute('aria-label', 'Cancel ' + info.label.toLowerCase() + ' edit for ' + ref);
        cancel.textContent = 'Cancel';
        bar.appendChild(save);
        bar.appendChild(cancel);
        panel.appendChild(bar);
        var first = panel.querySelector('input:checked') || panel.querySelector('input');
        if (first) first.focus({ preventScroll: true });
        if (usable < 2) save.disabled = true;
      })
      .catch(function (error) {
        console.warn('[ff-cart] ' + info.label.toLowerCase() + ' choices not loaded: ' + error.message);
        panel.textContent = "Couldn't load the choices. Please try again.";
      });
  }
  function edClose(slot) {
    var panel = slot.querySelector('.ffc-ed-p');
    var button = slot.querySelector('[data-ff-ed="open"]');
    if (panel) {
      panel.hidden = true;
      panel.textContent = '';
    }
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      button.focus({ preventScroll: true });
    }
  }

  /* ---------- Save ---------- */
  /* A line's identity = variant + its properties byte for byte. NOT its key: when the re-added flag lands, Kaching's
     Multi-Pack tier for the product changes and Shopify RE-KEYS the old flag line (same variant, same properties, new key;
     measured in the first C1 test run 2026-10-07). Keys are read fresh right before every remove / restore. */
  function edId(item) { return Number(item.variant_id) + '|' + JSON.stringify(item.properties || {}); }
  function edSnapshot(cart) {
    return (cart.items || []).map(function (item) { return { id: edId(item), quantity: item.quantity }; });
  }
  /* match every snapshot line to one cart line with the same identity and quantity; returns the cart lines left over, or null */
  function edLeftover(cart, snap) {
    var left = (cart.items || []).slice();
    for (var i = 0; i < snap.length; i++) {
      var found = -1;
      for (var j = 0; j < left.length; j++) {
        if (edId(left[j]) === snap[i].id && left[j].quantity === snap[i].quantity) { found = j; break; }
      }
      if (found < 0) return null;
      left.splice(found, 1);
    }
    return left;
  }
  function edSameCart(cart, snap) {
    var left = edLeftover(cart, snap);
    return !!left && !left.length;
  }
  function edPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw new Error(json.description || json.message || 'HTTP ' + response.status);
        return json;
      }, function () { throw new Error('HTTP ' + response.status + ' (no JSON)'); });
    });
  }
  /* The lines a real Add to cart of the new choices would create, in the order to post them (add-ons, then the flag). */
  function edPlan(check, chosen) { return edPlanMulti([{ check: check, chosen: chosen }]); }
  /* F1c: one Save may change several fields of ONE flag (changes = [{check, chosen}], each check from the same /cart.js read);
     with one change this is exactly the C1/C2/F1 plan. */
  function edPlanMulti(changes) {
    var check = changes[0].check;
    var flag = check.flag;
    var props = flag.properties;
    var wants = changes.map(function (one) { return one.check.want; });
    var olds = {};
    changes.forEach(function (one) {
      olds[one.check.want] = check.addons.filter(function (line) { return edNorm(line.properties._io_field_name) === one.check.want; })[0] || null;
    });
    var keep = check.addons.filter(function (line) { return wants.indexOf(edNorm(line.properties._io_field_name)) < 0; });
    var paid = changes.filter(function (one) { return !!(one.chosen.variant && one.chosen.variant.variantId); });
    var group = '';
    if (keep.length || paid.length) {
      group = String(Date.now());
      if (group === check.group) group = String(Date.now() + 1);
    }
    var newLabel = {};
    changes.forEach(function (one) { newLabel[one.check.field.name] = one.chosen.label; });
    var flagProps = {};
    Object.keys(props).forEach(function (key) {
      if (key === '_io_order_group') {
        if (group) flagProps[key] = group;
        return;
      }
      flagProps[key] = Object.prototype.hasOwnProperty.call(newLabel, key) ? newLabel[key] : props[key];
    });
    if (group && !('_io_order_group' in flagProps)) flagProps._io_order_group = group;
    function addonProps(old, fieldName) {
      var out = {};
      var src = old ? old.properties : { _io_parent_order_group: '', _io_field_name: fieldName };
      Object.keys(src).forEach(function (key) { out[key] = key === '_io_parent_order_group' ? group : src[key]; });
      if (!('_io_parent_order_group' in out)) out._io_parent_order_group = group;
      return out;
    }
    var addons = keep.map(function (line) {
      return { field: edNorm(line.properties._io_field_name), id: line.variant_id, quantity: line.quantity, properties: addonProps(line, null) };
    });
    paid.forEach(function (one) {
      var oldLine = olds[one.check.want];
      addons.push({
        field: one.check.want,
        id: Number(one.chosen.variant.variantId),
        quantity: oldLine ? oldLine.quantity : flag.quantity,
        properties: addonProps(oldLine, one.check.field.name)
      });
    });
    /* below the flag in the flag's own field order (STITCHING, FINISHING:, DESIGN: as Infinite Options adds them) */
    var order = Object.keys(props).map(edNorm);
    addons.sort(function (a, b) {
      var ia = order.indexOf(a.field), ib = order.indexOf(b.field);
      return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
    });
    var expected = [{ id: flag.variant_id, quantity: flag.quantity, properties: flagProps }].concat(addons);
    var posts = addons.slice().reverse().concat([expected[0]]);
    return { group: group, expected: expected, posts: posts, oldIds: [edId(flag)].concat(check.addons.map(edId)), oldKeys: [flag.key].concat(check.addons.map(function (line) { return line.key; })) };
  }
  /* Tina gives a sleeve/grommet add-on to the flag ABOVE it, so position matters (audit F1 1): every line carrying
     _io_parent_order_group must sit in an unbroken run directly below the flag whose _io_order_group is the same,
     and no group may have two runs. */
  function edRunsOk(cart) {
    var items = cart.items || [];
    var runGroup = null;
    var closed = {};
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties || {};
      if ('_io_parent_order_group' in p) {
        var parent = String(p._io_parent_order_group);
        if (!parent || runGroup !== parent) return false;
      } else {
        if (runGroup !== null) closed[runGroup] = true;
        runGroup = ('_io_order_group' in p) ? String(p._io_order_group) : null;
        if (runGroup !== null && closed[runGroup]) return false;
      }
    }
    return true;
  }
  function edVerify(cart, snap, plan) {
    /* every line that existed before is still there, unchanged (identity + quantity) ... */
    var fresh = edLeftover(cart, snap);
    if (!fresh || fresh.length !== plan.expected.length) return false;
    /* ... the new lines are EXACTLY the expected ones (variant, quantity, every property byte for byte) ... */
    var items = cart.items || [];
    var at = [];
    var all = plan.expected.every(function (want) {
      var wantId = Number(want.id) + '|' + JSON.stringify(want.properties);
      for (var i = 0; i < fresh.length; i++) {
        if (edId(fresh[i]) === wantId && fresh[i].quantity === want.quantity) {
          at.push(items.indexOf(fresh[i]));
          fresh.splice(i, 1);
          return true;
        }
      }
      return false;
    });
    if (!all) return false;
    /* ... sitting together in plan order (the flag, then its add-ons) ... */
    for (var k = 0; k < at.length; k++) {
      if (at[k] < 0 || at[k] !== at[0] + k) return false;
    }
    /* ... and every add-on in the whole cart still directly below its own flag */
    return edRunsOk(cart);
  }
  /* the snapshot minus the edited flag's old lines = what must remain once they are removed */
  function edRest(snap, plan) {
    var rest = snap.slice();
    plan.oldIds.forEach(function (id) {
      for (var i = 0; i < rest.length; i++) {
        if (rest[i].id === id) { rest.splice(i, 1); return; }
      }
    });
    return rest;
  }
  /* A failed add: remove only lines this Save created (never a line that existed before), put back any old line's quantity.
     If a line of the edited flag is gone, keep the new lines and say "check this flag" (audit 6 note 2). */
  function edCleanup(snap, plan) {
    return edCart().then(function (cart) {
      var items = (cart.items || []).slice();
      var updates = {};
      var any = false;
      var used = {};
      snap.forEach(function (old) {
        var line = null;
        items.forEach(function (item) { if (!line && !used[item.key] && edId(item) === old.id && item.quantity === old.quantity) line = item; });
        if (!line) items.forEach(function (item) { if (!line && !used[item.key] && edId(item) === old.id) line = item; });
        if (!line) return;
        used[line.key] = true;
        if (line.quantity !== old.quantity) { updates[line.key] = old.quantity; any = true; }
      });
      var expectedIds = plan.expected.map(function (want) { return Number(want.id) + '|' + JSON.stringify(want.properties); });
      items.forEach(function (item) {
        if (used[item.key]) return;
        var p = item.properties || {};
        var mine = (plan.group && (p._io_order_group === plan.group || p._io_parent_order_group === plan.group)) || expectedIds.indexOf(edId(item)) >= 0;
        if (mine) { updates[item.key] = 0; any = true; }
      });
      var oldMissing = plan.oldIds.some(function (id) { return !(cart.items || []).some(function (item) { return edId(item) === id; }); });
      if (oldMissing) return 'check';
      if (!any) return 'done';
      return edPost('/cart/update.js', { updates: updates }).then(function () { return 'done'; });
    });
  }
  function edRemoveOld(plan) {
    function gone(cart) {
      return !plan.oldIds.some(function (id) { return (cart.items || []).some(function (item) { return edId(item) === id; }); });
    }
    function once() {
      return edCart().then(function (cart) {
        var updates = {};
        var found = 0;
        (cart.items || []).forEach(function (item) {
          if (plan.oldIds.indexOf(edId(item)) >= 0) { updates[item.key] = 0; found++; }
        });
        if (found !== plan.oldIds.length) throw new Error('found ' + found + ' of ' + plan.oldIds.length + ' old lines');
        return edPost('/cart/update.js', { updates: updates });
      }).then(edCart).then(function (cart) {
        if (!gone(cart)) throw new Error('old lines still in the cart');
        return cart;
      });
    }
    return once().catch(function (error) {
      console.warn('[ff-cart] remove of the old flag lines failed once (' + error.message + '); trying again');
      return once();
    });
  }
  function edRedraw(cart) {
    var ids = ['cart-drawer', 'cart-icon-bubble'].concat(pageSections());
    /* no Accept: application/json here: on a product URL Shopify then answers with the product JSON, not the sections */
    return fetch(window.location.pathname + '?sections=' + ids.map(encodeURIComponent).join(','), { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status + ' for the cart sections');
      return response.json();
    }).then(function (sections) {
      if (!sections || typeof sections['cart-drawer'] !== 'string') throw new Error('the cart sections did not come back');
      var state = { sections: sections, item_count: cart.item_count, items: cart.items };
      if (!render(state)) throw new Error('redraw failed');
      writeAt = Date.now();
      try { keepDrawerScroll(); } catch (error) { console.error('[ff-cart] drawer scroll restore failed: ' + error.message); }
      try { afterRender(state); } catch (error) { console.error('[ff-cart] after-render step failed: ' + error.message); }
    });
  }

  /* lock / unlock everything a customer could press while a Save runs */
  var ED_BLOCK = '[data-ff-cart], #CartDrawer-Checkout, #checkout, [name="checkout"], a[href*="/checkout"], .cart__dynamic-checkout-buttons, '
    + '.additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .cart__ctas, .drawer__footer';
  var edLocked = [];
  var edInert = [];
  var ED_EXPRESS = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .dynamic-checkout__content';
  function edLock(on) {
    edSaving = on;
    document.documentElement.classList.toggle('ff-ed-saving', on);
    if (on) {
      document.querySelectorAll('#CartDrawer-Checkout, #checkout, [name="checkout"]').forEach(function (node) {
        if (!node.disabled) { node.disabled = true; edLocked.push(node); }
      });
      document.querySelectorAll('[data-ff-cart]').forEach(function (node) { node.classList.add('ffc-busy'); });
      /* express checkout (PayPal is a cross-origin iframe: its clicks never reach this window's listeners) = inert + CSS
         pointer-events:none (audit C1 #1) */
      document.querySelectorAll(ED_EXPRESS).forEach(function (node) {
        if (!node.hasAttribute('inert')) { node.setAttribute('inert', ''); edInert.push(node); }
      });
    } else {
      edInert.forEach(function (node) { node.removeAttribute('inert'); });
      edInert = [];
      edLocked.forEach(function (node) { node.disabled = false; });
      edLocked = [];
      document.querySelectorAll('[data-ff-cart]').forEach(function (node) { node.classList.remove('ffc-busy'); });
      var checkout = document.getElementById('checkout');
      var main = document.getElementById('main-cart-items');
      if (checkout && main && main.closest('cart-items') && main.closest('cart-items').classList.contains('is-empty')) checkout.disabled = true;
    }
  }
  ['click', 'submit', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function (event) {
      if (!edSaving) return;
      if (type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (type === 'submit') {
        var action = (target && target.getAttribute && target.getAttribute('action')) || '';
        if (/\/cart|\/checkout/.test(action) || (target && target.querySelector && target.querySelector('[name="checkout"]'))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        return;
      }
      if (target && target.closest && target.closest(ED_BLOCK)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true, passive: false });
  });
  window.addEventListener('beforeunload', function (event) {
    if (!edSaving) return;
    event.preventDefault();
    event.returnValue = '';
  });
  function edMarkSet(plan) {
    try { window.localStorage.setItem(ED_MARK, JSON.stringify({ old: plan.oldKeys, group: plan.group, at: Date.now() })); } catch (error) { /* storage blocked: marker skipped */ }
  }
  function edMarkClear() {
    try { window.localStorage.removeItem(ED_MARK); } catch (error) { /* nothing kept */ }
  }
  function edMarkerCheck() {
    if (edSaving) return;
    var mark = null;
    try { mark = window.localStorage.getItem(ED_MARK); } catch (error) { mark = null; }
    if (!mark) return;
    if (!document.querySelector('[data-ff-error]')) return;
    edMarkClear();
    edNotify(ED_MSG_TWICE);
  }

  function edSave(slot) {
    if (edSaving) return;
    var panel = slot.querySelector('.ffc-ed-p');
    var picked = panel && panel.querySelector('input[type="radio"]:checked');
    var key = slot.getAttribute('data-ff-edkey');
    var want = slot.getAttribute('data-ff-edfield');
    var info = edField(want);
    if (!picked || !key || !info) return;
    var saveButton = panel.querySelector('[data-ff-ed="save"]');
    edSaveCore(key, [{ want: want, index: parseInt(picked.value, 10) }], {
      label: info.label.toLowerCase(),
      done: info.done,
      busy: function () { if (saveButton) saveButton.textContent = 'Saving…'; },
      say: function (text) { edSay(slot, text); },
      close: function () { edClose(slot); }
    });
  }
  /* ONE Save = ONE rebuild (C1-C3 method, unchanged): picks = [{want, index}] for one flag; every check again on a fresh
     /cart.js, then the adds, verify-before-removing, remove by key, verify the final order. F1c's panel sends every changed
     field in one call; golf's per-field rows send one. */
  function edSaveCore(key, picks, ui) {
    if (edSaving || !key || !picks.length) return;
    var snap = null;
    var plan = null;
    var created = [];
    /* Todd's phone 2026-10-21 ("It goes back to cart after u save an edit ... You're not to change any of the functionality of the
       current cart"): on the live cart a Save leaves the customer where they were, so the Edit screen is NOT forgotten here any
       more; crReopen (render / watchDrawer) opens the same flag's Edit screen again after the redraw, exactly as after Save note
       and the design help ticker. crReopen still checks the same position, card count and flag variant, so it never opens
       another flag's screen. After the Save the rebuilt flag moves to the top of the cart, so on success the screen is found
       by the new line keys instead (crReopen, want.keys). */
    var sheetWas = crOpen;
    /* belt and braces: if the memory was lost before the Save, take it from the Edit screen that is open right now */
    if (!sheetWas) {
      var openSheet = document.querySelector('.ffc-sheet:not([hidden])');
      var openWrap = openSheet && openSheet.closest('.ffc-cr');
      var openPill = openWrap && openWrap.querySelector('[data-ff-act="cr-toggle"]');
      if (openPill) sheetWas = crRemember(openPill);
    }
    edLock(true);
    ui.busy();
    edCart()
      .then(function (cart) {
        /* every check again, on the cart as it is NOW (never the card as drawn) */
        var changes = [];
        picks.forEach(function (pick) {
          var check = edCheck(cart, key, pick.want);
          if (!check) throw { stage: 'check', message: 'this flag changed or cannot be edited here (' + pick.want + ')' };
          var chosen = check.values[pick.index];
          if (!chosen) throw { stage: 'check', message: 'choice not found' };
          if (chosen.label !== check.current) changes.push({ check: check, chosen: chosen });
        });
        if (!changes.length) return 'unchanged';
        /* a cart whose add-ons are already out of place is never edited (the order checks below would fail after the add) */
        if (!edRunsOk(cart)) throw { stage: 'check', message: 'an add-on is not directly below its own flag' };
        snap = edSnapshot(cart);
        plan = edPlanMulti(changes);
        edMarkSet(plan);
        var chain = Promise.resolve();
        plan.posts.forEach(function (line) {
          chain = chain.then(function () {
            return edPost(ED_ADD_URL, { items: [{ id: line.id, quantity: line.quantity, properties: line.properties }] }).then(function (json) {
              (json.items || [json]).forEach(function (item) { if (item && item.key) created.push(item.key); });
            });
          });
        });
        return chain.then(function () { return 'added'; }, function (error) { throw { stage: 'add', message: error.message }; });
      })
      .then(function (step) {
        if (step === 'unchanged') return { done: 'unchanged' };
        return edCart().then(function (cart) {
          if (!edVerify(cart, snap, plan)) throw { stage: 'add', message: 'the cart did not come out exactly as expected' };
          return edRemoveOld(plan).then(function (finalCart) {
            /* the final cart: the old lines gone, the new run intact and in order, every add-on below its own flag */
            if (!edVerify(finalCart, edRest(snap, plan), plan)) throw { stage: 'order', message: 'the cart lines are not in the expected order after the save' };
            return { done: 'saved', cart: finalCart };
          }, function (error) {
            throw { stage: 'remove', message: error.message };
          });
        }, function (error) { throw { stage: 'add', message: 'cart not readable after the add: ' + error.message }; });
      })
      .then(function (result) {
        if (result.done === 'unchanged') {
          edLock(false);
          ui.close();
          return;
        }
        if (sheetWas && created.length) crOpen = { page: sheetWas.page, keys: created.slice(), variant: sheetWas.variant };
        return edFinish(null, null, ui.done);
      })
      .catch(function (error) {
        var stage = error && error.stage;
        console.error('[ff-cart] ' + ui.label + ' save failed at ' + (stage || 'start') + ': ' + (error && error.message));
        if (stage === 'check' || !snap) {
          edMarkClear();
          edLock(false);
          ui.say(ED_MSG_NOTHING);
          edNotice = { text: ED_MSG_NOTHING, until: 0 };
          return;
        }
        if (stage === 'remove') return edFinish(null, ED_MSG_TWICE);
        /* the old lines are already gone: nothing to undo safely, so never a silent success */
        if (stage === 'order') return edFinish(null, ED_MSG_FINAL);
        return edCleanup(snap, plan).then(function (how) {
          return edCart().then(function (cart) {
            return edFinish(null, how === 'done' && edSameCart(cart, snap) ? ED_MSG_NOTHING : ED_MSG_CHECK);
          });
        }).catch(function (cleanError) {
          console.error('[ff-cart] clean-up after a failed save failed: ' + cleanError.message);
          return edFinish(null, ED_MSG_CHECK);
        });
      });
  }
  /* final /cart.js read (retried once), redraw, unlock; the cart is never left locked */
  function edFinish(slot, message, doneText) {
    function read() { return edCart(); }
    return read().catch(function () { return read(); }).then(function (cart) {
      edMarkClear();
      edLock(false);
      return edRedraw(cart).then(function () {
        if (message) edNotify(message);
        else announce(doneText || 'Your cart was updated.');
      }, function () {
        if (message) edNotify(message);
        else showError(null, 'Your cart was updated. Reloading the page to show it...');
        if (!message) window.setTimeout(function () { window.location.reload(); }, 1200);
      });
    }, function (error) {
      console.error('[ff-cart] final cart read failed twice: ' + error.message);
      edMarkClear();
      edLock(false);
      edNotify(message || ED_MSG_FINAL);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-ff-ed]');
    if (!button) return;
    event.preventDefault();
    var slot = button.closest('.ffc-ed');
    if (!slot || edSaving) return;
    var act = button.getAttribute('data-ff-ed');
    if (act === 'open') edOpen(slot, button);
    else if (act === 'cancel') edClose(slot);
    else if (act === 'save') edSave(slot);
  });
  /* Escape inside the open choices = Cancel; the drawer stays open (same as the note box) */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || edSaving) return;
    var panel = event.target && event.target.closest && event.target.closest('.ffc-ed-p');
    if (!panel || panel.hidden) return;
    event.preventDefault();
    event.stopPropagation();
    swallowToken++;
    swallowEscapeUp = true;
    edClose(panel.closest('.ffc-ed'));
  }, true);
  /* the choices' radio 'change' must not reach Dawn's cart quantity listener (same reason as the note box) */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.ffc-ed')) event.stopPropagation();
  }, true);

  /* One Edit button, slice F1c (Todd 2026-10-07, mockup B: "b is fine as long as it's surgical and the bundles still work";
     "yes, fix the layout" 2026-10-08; handoff "Cart finishing edit" rules L1-L7). On a card marked data-ff-one by
     snippets/ff-cart-cards.liquid (flag cards with DESIGN / STITCHING / FINISHING, never golf, teardrop, hardware or ready to
     ship) the per-field Edit rows and the strip's Change artwork links are replaced by ONE "Edit this flag" button, added
     inline in the card's existing "Change or remove" row (same height, nothing above or below moves). It shows only when at
     least one field passes its own Edit checks (edCheck, unchanged) or a Change artwork control applies, and never on a flag
     that shares its group / bundle with another flag line (a mixed-size bundle: no field editing and no button). The panel
     loads its choices only when tapped: design help and stitching as radio lists, finishing as one dropdown, a field that
     fails its checks read-only, the Change artwork link(s), the card's price change ("Change: +$X.XX", list prices x the
     quantity each add-on will have), "Save changes" (disabled until something differs) and "Cancel". ONE Save sends every
     changed field to edSaveCore = ONE rebuild, the same method as before (golf keeps its own design-help row: edSlot). */
  var ONE_ORDER = ['DESIGN', 'STITCHING', 'FINISHING'];
  function oneFlag(cart, key) {
    var flag = null;
    (cart.items || []).forEach(function (item) { if (item.key === key) flag = item; });
    return flag;
  }
  function oneShared(cart, flag) {
    var props = flag.properties || {};
    var group = props._io_order_group || '';
    return (cart.items || []).some(function (item) {
      if (item.key === flag.key || !item.properties || item.properties._io_parent_order_group) return false;
      if (group) return item.properties._io_order_group === group;
      return item.product_id === flag.product_id && !!props.__kaching_bundles && item.properties.__kaching_bundles === props.__kaching_bundles;
    });
  }
  function oneGolf(flag) {
    var product = edTags[flag.handle];
    if (!product || !edSets) return false;
    return edSets.some(function (set) { return set && set._id === ED_GOLF_SET && edSetApplies(set, product.tags); });
  }
  /* the fields the flag line carries, in the panel's order, with their exact property name and value */
  function oneFields(flag) {
    var props = flag.properties || {};
    var out = [];
    ONE_ORDER.forEach(function (want) {
      var keys = Object.keys(props).filter(function (key) { return edNorm(key) === want || (want === 'STITCHING' && edNorm(key) === 'STICHING'); });
      if (keys.length === 1 && String(props[keys[0]]).trim() !== '') out.push({ want: want, name: keys[0], value: String(props[keys[0]]) });
    });
    return out;
  }
  function oneSlot(card, cart) {
    if (card.querySelector('.ffc-one-btn')) return;
    var row = card.querySelector('.ffc-cr');
    var pill = row && row.querySelector('.ffc-cr-btn');
    if (!row || !pill) return;
    var key = card.getAttribute('data-ff-keys').split(',')[0];
    var flag = oneFlag(cart, key);
    if (!flag || !flag.properties || flag.properties._io_parent_order_group) return;
    if (oneShared(cart, flag) || oneGolf(flag)) return;
    var editable = ONE_ORDER.filter(function (want) { return !!edCheck(cart, key, want); });
    var art = card._ffArt || [];
    if (!editable.length && !art.length) return;
    var ref = edRef(card);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ffc-cr-btn ffc-one-btn';
    button.setAttribute('data-ff-one-act', 'open');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Edit ' + ref + ': design help, stitching and finishing');
    button.textContent = 'Edit this flag';
    var panel = document.createElement('div');
    panel.className = 'ffc-one-p';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Edit ' + ref);
    panel.setAttribute('data-ff-onekey', key);
    panel.hidden = true;
    panel.id = 'FFOne-' + (card.id || Math.random().toString(36).slice(2));
    button.setAttribute('aria-controls', panel.id);
    /* compact cart: at the top of the card's Change sheet; else beside the pill, as before */
    var host = card.querySelector('[data-ff-oneslot]');
    if (host) {
      host.insertBefore(panel, host.firstChild);
      host.insertBefore(button, panel);
    } else {
      row.insertBefore(button, row.firstChild);
      row.parentNode.insertBefore(panel, row.nextSibling);
    }
  }
  function oneCard(node) { return node && node.closest ? node.closest('article.ffc-card[data-ff-one]') : null; }
  function oneClose(card, refocus) {
    var panel = card.querySelector('.ffc-one-p');
    var button = card.querySelector('.ffc-one-btn');
    if (panel) {
      panel.hidden = true;
      panel.textContent = '';
    }
    card._ffOne = null;
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      if (refocus) button.focus({ preventScroll: true });
    }
  }
  function onePrice(live, value) {
    if (!value || !value.variant || !value.variant.variantId) return { ok: true, cents: 0, paid: false };
    var product = live.byHandle[value.variant.handle];
    var variant = product && (product.variants || []).filter(function (one) { return Number(one.id) === Number(value.variant.variantId); })[0];
    if (!variant) return { ok: false, text: 'Not available' };
    if (!variant.available) return { ok: false, text: 'Sold out' };
    return { ok: true, cents: variant.price, paid: true };
  }
  function oneOpen(card) {
    var panel = card.querySelector('.ffc-one-p');
    var button = card.querySelector('.ffc-one-btn');
    if (!panel || !button) return;
    if (!panel.hidden) { oneClose(card, true); return; }
    var key = panel.getAttribute('data-ff-onekey');
    var ref = edRef(card);
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    panel.textContent = 'Loading the choices…';
    var checks = {};
    var flag;
    edCart()
      .then(function (cart) {
        flag = oneFlag(cart, key);
        if (!flag || oneShared(cart, flag)) throw new Error('this flag cannot be changed here');
        ONE_ORDER.forEach(function (want) {
          var check = edCheck(cart, key, want);
          if (check) checks[want] = check;
        });
        var handles = {};
        Object.keys(checks).forEach(function (want) {
          checks[want].values.forEach(function (value) { if (value.variant && value.variant.variantId) handles[value.variant.handle] = true; });
        });
        return Promise.all(Object.keys(handles).map(function (handle) {
          return edJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (product) { return [handle, product]; });
        })).then(function (pairs) {
          var byHandle = {};
          pairs.forEach(function (pair) { byHandle[pair[0]] = pair[1]; });
          return { currency: cart.currency, byHandle: byHandle };
        });
      })
      .then(function (live) {
        if (panel.hidden) return;
        panel.textContent = '';
        var state = { key: key, flag: flag, checks: checks, live: live, start: {}, inputs: {} };
        oneFields(flag).forEach(function (one) {
          var info = edField(one.want);
          var check = checks[one.want];
          var set = document.createElement('fieldset');
          set.className = 'ffc-one-f';
          var legend = document.createElement('legend');
          legend.textContent = info.label;
          set.appendChild(legend);
          if (!check) {
            var fixed = document.createElement('p');
            fixed.className = 'ffc-one-ro';
            fixed.textContent = edShort(one.value);
            set.appendChild(fixed);
            panel.appendChild(set);
            return;
          }
          var startIndex = -1;
          check.values.forEach(function (value, index) { if (value.label === check.current) startIndex = index; });
          state.start[one.want] = startIndex;
          if (one.want === 'FINISHING') {
            var select = document.createElement('select');
            select.className = 'ffc-one-sel';
            select.setAttribute('aria-label', info.label + ' for ' + ref);
            check.values.forEach(function (value, index) {
              var option = document.createElement('option');
              option.value = String(index);
              var price = onePrice(live, value);
              option.textContent = edShort(value.label) + ' — ' + (price.ok ? (price.paid ? '+' + edMoney(price.cents, live.currency) : 'Included') : price.text);
              option.selected = index === startIndex;
              if (!price.ok && index !== startIndex) option.disabled = true;
              select.appendChild(option);
            });
            set.appendChild(select);
            state.inputs[one.want] = select;
          } else {
            var name = 'ffone-' + Math.random().toString(36).slice(2);
            check.values.forEach(function (value, index) {
              var row = document.createElement('label');
              row.className = 'ffc-ed-o';
              var radio = document.createElement('input');
              radio.type = 'radio';
              radio.name = name;
              radio.value = String(index);
              radio.checked = index === startIndex;
              var text = document.createElement('span');
              edLabel(text, value.label);
              var tag = document.createElement('b');
              var price = onePrice(live, value);
              tag.textContent = price.ok ? (price.paid ? '+' + edMoney(price.cents, live.currency) : 'Included') : price.text;
              if (!price.ok && index !== startIndex) radio.disabled = true;
              row.appendChild(radio);
              row.appendChild(text);
              row.appendChild(tag);
              set.appendChild(row);
            });
            state.inputs[one.want] = set;
          }
          panel.appendChild(set);
        });
        var art = card._ffArt || [];
        if (art.length) {
          var artBox = document.createElement('div');
          artBox.className = 'ffc-one-art';
          art.forEach(function (one) {
            var link = document.createElement('a');
            link.className = 'ffc-link ffc-art-chg';
            link.href = one.href;
            link.textContent = one.label;
            link.setAttribute('aria-label', one.label + ' for ' + ref);
            artBox.appendChild(link);
          });
          var artNote = document.createElement('p');
          artNote.className = 'ffc-one-artnote';
          artNote.textContent = 'Save or cancel your changes first';
          artNote.hidden = true;
          artBox.appendChild(artNote);
          panel.appendChild(artBox);
        }
        var change = document.createElement('p');
        change.className = 'ffc-one-chg';
        change.setAttribute('aria-live', 'polite');
        panel.appendChild(change);
        var bar = document.createElement('div');
        bar.className = 'ffc-ed-bar';
        var save = document.createElement('button');
        save.type = 'button';
        save.className = 'ffc-ghost ffc-save';
        save.setAttribute('data-ff-one-act', 'save');
        save.setAttribute('aria-label', 'Save changes to ' + ref);
        save.textContent = 'Save changes';
        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'ffc-link';
        cancel.setAttribute('data-ff-one-act', 'cancel');
        cancel.setAttribute('aria-label', 'Cancel changes to ' + ref);
        cancel.textContent = 'Cancel';
        bar.appendChild(save);
        bar.appendChild(cancel);
        panel.appendChild(bar);
        var status = document.createElement('p');
        status.className = 'ffc-ed-msg';
        status.setAttribute('role', 'status');
        status.hidden = true;
        panel.appendChild(status);
        card._ffOne = state;
        oneUpdate(card);
        var first = panel.querySelector('input:checked, select, a.ffc-art-chg');
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function (error) {
        console.warn('[ff-cart] Edit this flag: choices not loaded: ' + error.message);
        panel.textContent = "Couldn't load the choices. Please try again.";
      });
  }
  /* the picks that differ from the line as it is: [{want, index}] */
  function onePicks(state) {
    var picks = [];
    Object.keys(state.inputs).forEach(function (want) {
      var input = state.inputs[want];
      var node = input.tagName === 'SELECT' ? input : input.querySelector('input[type="radio"]:checked');
      if (!node) return;
      var index = parseInt(node.value, 10);
      if (index !== state.start[want]) picks.push({ want: want, index: index });
    });
    return picks;
  }
  /* L3: the card's price change = sum over changed add-ons of (new list price x the quantity it will have) - (old list price x
     its current quantity); the quantity rule is edPlan's (an existing add-on keeps its own quantity, a new one gets the flag's) */
  function oneDelta(state, picks) {
    var total = 0;
    picks.forEach(function (pick) {
      var check = state.checks[pick.want];
      var oldLine = check.addons.filter(function (line) { return edNorm(line.properties._io_field_name) === pick.want; })[0] || null;
      var oldValue = check.values[state.start[pick.want]];
      var newValue = check.values[pick.index];
      var oldPrice = onePrice(state.live, oldValue);
      var newPrice = onePrice(state.live, newValue);
      var oldCents = oldLine ? (oldPrice.ok && oldPrice.paid ? oldPrice.cents : oldLine.original_price) : 0;
      if (oldLine) total -= oldCents * oldLine.quantity;
      if (newPrice.ok && newPrice.paid) total += newPrice.cents * (oldLine ? oldLine.quantity : state.flag.quantity);
    });
    return total;
  }
  function oneUpdate(card) {
    var state = card._ffOne;
    var panel = card.querySelector('.ffc-one-p');
    if (!state || !panel) return;
    var picks = onePicks(state);
    var save = panel.querySelector('[data-ff-one-act="save"]');
    var change = panel.querySelector('.ffc-one-chg');
    var dirty = picks.length > 0;
    if (save) save.disabled = !dirty;
    if (change) {
      var delta = dirty ? oneDelta(state, picks) : 0;
      change.textContent = delta > 0 ? 'Change: +' + edMoney(delta, state.live.currency)
        : delta < 0 ? 'Change: −' + edMoney(-delta, state.live.currency) : 'No price change';
    }
    panel.querySelectorAll('.ffc-one-art a.ffc-art-chg').forEach(function (link) {
      if (dirty) link.setAttribute('aria-disabled', 'true');
      else link.removeAttribute('aria-disabled');
    });
    var note = panel.querySelector('.ffc-one-artnote');
    if (note) note.hidden = !dirty;
  }
  function oneSave(card) {
    var state = card._ffOne;
    var panel = card.querySelector('.ffc-one-p');
    if (!state || !panel || edSaving) return;
    var picks = onePicks(state);
    if (!picks.length) return;
    var save = panel.querySelector('[data-ff-one-act="save"]');
    var labels = picks.map(function (pick) { return edField(pick.want).label.toLowerCase(); });
    edSaveCore(state.key, picks, {
      label: labels.join(' + '),
      done: picks.length === 1 ? edField(picks[0].want).done : 'Your changes were saved.',
      busy: function () { if (save) save.textContent = 'Saving…'; },
      say: function (text) {
        var box = panel.isConnected && panel.querySelector('.ffc-ed-msg');
        if (box) { box.textContent = text; box.hidden = false; } else showError(null, text);
        announce(text);
        if (save && save.isConnected) save.textContent = 'Save changes';
      },
      close: function () { oneClose(card, true); }
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    /* S1c: "Change" under the artwork while this flag's "Edit this flag" panel holds unsaved choices = one plain question
       (OK leaves without saving, nothing in the cart changes; Cancel stays); while a Save is running = nothing happens */
    var artLink = target && target.closest && target.closest('a.ffc-art-chg');
    if (artLink) {
      if (edSaving) { event.preventDefault(); return; }
      var artCard = artLink.closest('article.ffc-card');
      var openPanel = artCard && artCard.querySelector('.ffc-one-p:not([hidden])');
      var openSave = openPanel && openPanel.querySelector('[data-ff-one-act="save"]');
      if (openSave && !openSave.disabled && !window.confirm("Your changes to this flag aren't saved. Leave without saving?")) event.preventDefault();
      return;
    }
    var button = target && target.closest && target.closest('[data-ff-one-act]');
    if (!button) return;
    event.preventDefault();
    var card = oneCard(button);
    if (!card || edSaving) return;
    var act = button.getAttribute('data-ff-one-act');
    if (act === 'open') oneOpen(card);
    else if (act === 'cancel') oneClose(card, true);
    else if (act === 'save') oneSave(card);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || edSaving) return;
    var panel = event.target && event.target.closest && event.target.closest('.ffc-one-p');
    if (!panel || panel.hidden) return;
    event.preventDefault();
    event.stopPropagation();
    swallowToken++;
    swallowEscapeUp = true;
    oneClose(oneCard(panel), true);
  }, true);
  /* the panel's radio / select 'change' must not reach Dawn's cart quantity listener; it updates Save and the price line */
  document.addEventListener('change', function (event) {
    var target = event.target;
    var panel = target && target.closest && target.closest('.ffc-one-p');
    if (!panel) return;
    event.stopPropagation();
    oneUpdate(oneCard(panel));
  }, true);

  /* Change artwork, slice F1b (Todd 2026-10-07 ~23:05 PT: "yes, build the change artwork button as long as this can be fluid,
     not slow down the site, and be very surgical"; handoff "Cart finishing edit" rules A1-A9). Uploadery has no cart upload, so
     a FLAG card whose Image-1 / Image-2 is an Uploadery link gets a "Change artwork" link (artScan) to the flag's own product
     page in change mode: ?ff_art=<slot>&ff_line=<line key>&ff_i=<the line's index in /cart.js>. There (artModeStart) the
     customer uploads in that slot's own Uploadery box only (every other Uploadery box is hidden) and every add / buy path is
     blocked: buttons disabled and hidden, form submit and Enter cancelled, form.submit() refused, and a fetch / XHR guard
     refuses any /cart/add request, so no second flag can be added. Nothing changes until "Use this artwork" (artUse): a fresh
     /cart.js must still show that line at that index with that key, then ONE /cart/change.js sends every property of the line
     back byte for byte with only the slot replaced (the Notes-edit method; the property NAMES never change, the Order Brief
     Flow reads them), then a fresh /cart.js must prove the line (same index, new key), every other line (key, quantity,
     properties, index) and the discounts unchanged. Anything else: the old properties go back on the line's new key (only if
     the line count and order are unchanged) and the message says only what a fresh read proves. Success returns to the page
     the customer came from with the drawer open and "Artwork updated" on that card (artReturn). Without ff_art= in the URL the
     product-page part is one string check and nothing else; the cart side adds no request (it reuses edScanNow's /cart.js). */
  var ART_PREFIX = 'https://uploadery.s3.theshoppad.net/festflags/';
  var ART_SLOTS = ['Image-1', 'Image-2'];
  var ART_ON = true;          /* A7 (i): false = the control is hidden on every card. OFF 2026-10-08 (Todd: "publish without artwork"; the product-page detour felt like starting over); ON again with the focused Change artwork screen (handoff "Change artwork screen", S1) */
  var ART_MULTI_OK = true;    /* A7 (ii): false = hidden on a line with quantity above 1 or a line discount */
  var ART_DONE = 'ff-art-done';
  var ART_MSG_CHANGED = 'Your cart changed. Please open it and try again.';
  var ART_MSG_NOTHING = "Couldn't change the artwork. Nothing was changed.";
  var ART_MSG_CHECK = 'Please check this flag in your cart.';
  var ART_MSG_CANT = "This flag's artwork can't be changed here. Please email it to info@festflags.com.";
  var ART_MSG_AGAIN = 'Please upload the file again.';
  var ART_MSG_AGAIN_START = "The last file didn't finish uploading. Please start again.";
  var ART_MSG_READ = "Couldn't open your cart. Please go back to your cart and try again.";
  var ART_BUY = 'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button, [name="add"], .product-form__submit, '
    + '.product-form__buttons, .shopify-payment-button, shopify-accelerated-checkout, .dynamic-checkout__content, .kaching-bundles, '
    + '[class*="kaching"], [id*="kaching"], [class*="sticky-atc"], [class*="sticky-add"], [id*="sticky-atc"]';
  /* Uploadery keeps its config inside its own script (window.ShoppadUploaderyConfig is undefined on the page, F1b smoke
     2026-10-08), so this is a copy of the two upload sets that write Image-1 / Image-2 on flags, read from Uploadery's config
     2026-10-07: "Upload Set 1" (custom-flags and most custom products; both uploads share ONE id) and "utahoffroadcustom".
     If Uploadery's ids or order change, nothing matches and the page says to email the artwork (fail closed). Golf's sets are
     left out on purpose (golf = no Change artwork in this build). */
  var ART_UPLOAD_SETS = [
    { uploads: [{ id: '5ef259fb8f7a7d4501780f72', name: 'Image-1' }, { id: '5ef259fb8f7a7d4501780f72', name: 'Image-2' }] },
    { uploads: [{ id: '67855b492a79206aea0084aa', name: 'Image-1' }] }
  ];
  /* Fix build (c), Todd 2026-10-09: "if you don't add artwork, then there's no way to upload it from the cart." A flag card with
     NO artwork gets "Add artwork": the same Change artwork screen in add mode (ff_add=1), which puts the new file in Image-1
     only. The card shows it only when Uploadery itself would show that product an Image-1 box: the product's tags match one of
     the two sets above (Uploadery's own rule = any one of these whole tags, case ignored; copied from Uploadery's config
     2026-10-07, same as the ids) and none of Uploadery's other sets (golf, hats, license plates: other boxes, other names).
     Golf stays out (no Change artwork there either). The product page re-checks the box itself (artFind) and fails closed. */
  var ART_ADD_ON = true;
  var ART_SET_TAGS = [
    ['custom', 'custom masks', 'stickers', 'whipflags', 'customproducts', 'advertising', 'pennant', 'domestic platypus', 'private', 'gw', 'customer', 'lakegeorge', 'magyar'],
    ['utahoffroadcustom']
  ];
  var ART_OTHER_TAGS = ['golf', 'hat', 'license plates'];
  var ART_MSG_CANT_ADD = "Artwork can't be added here. Please email it to info@festflags.com.";
  var artDone = null;
  var artMode = false;
  var artBusy = false;
  var artState = null;

  function artPreview(url) {
    var match = /[?&]preview_theme_id=(\d+)/.exec(window.location.search);
    if (!match || /[?&]preview_theme_id=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + match[1];
  }
  function artName(link) {
    var file = String(link || '').split('?')[0].split('/').pop();
    try { file = decodeURIComponent(file); } catch (error) { /* keep it as it is */ }
    return /^[0-9a-f]{8}-./i.test(file) ? file.slice(9) : file;
  }
  /* A1: a FLAG line (never an add-on) and only the slots that already hold an Uploadery link */
  function artSlots(item) {
    var props = item && item.properties;
    if (!props || props._io_parent_order_group != null) return [];
    return ART_SLOTS.filter(function (slot) { return typeof props[slot] === 'string' && props[slot].indexOf(ART_PREFIX) === 0; });
  }
  function artAllowed(item) {
    if (!ART_ON) return false;
    if (ART_MULTI_OK) return true;
    return item.quantity === 1 && !(item.line_level_total_discount > 0) && !(item.line_level_discount_allocations || []).length;
  }
  /* (c) a FLAG line (never an add-on) with nothing at all in Image-1 / Image-2 */
  function artNone(item) {
    var props = item && item.properties;
    if (!props || props._io_parent_order_group != null) return false;
    return ART_SLOTS.every(function (slot) { return props[slot] == null || String(props[slot]).trim() === ''; });
  }
  /* (c) Uploadery would give this product exactly one of the two known Image-1 boxes (tags as Uploadery matches them).
     (e) Returns that set's upload names (Upload Set 1: Image-1 + Image-2; utahoffroadcustom: Image-1 only), else null. */
  function artAddSet(item) {
    var product = edTags[item.handle];
    if (!product || product.id !== item.product_id) return null;
    var tags = (product.tags || []).join(',').toLowerCase().split(',');
    var hits = [];
    ART_SET_TAGS.forEach(function (list, i) { if (list.some(function (tag) { return tags.indexOf(tag) !== -1; })) hits.push(i); });
    if (hits.length !== 1 || ART_OTHER_TAGS.some(function (tag) { return tags.indexOf(tag) !== -1; })) return null;
    return ART_UPLOAD_SETS[hits[0]].uploads.map(function (upload) { return upload.name; });
  }
  function artAddOk(item) { return !!artAddSet(item); }
  /* (e) Todd 2026-10-11: "in the cart, it looks like you can only add artwork once. There's not a second spot to add the
     artwork." The empty slot to offer: none uploaded = Image-1 ("Add artwork"); one uploaded = the other one ("Add side 2" on a
     double-sided flag, else "Add another file"), only when the product's Uploadery set has that upload. Every slot that is
     filled must hold an Uploadery link (anything typed by hand = no button). */
  function artBlank(props, slot) { return props[slot] == null || String(props[slot]).trim() === ''; }
  function artEmptySlot(item) {
    var props = item && item.properties;
    if (!props || props._io_parent_order_group != null) return null;
    var filled = ART_SLOTS.filter(function (slot) { return !artBlank(props, slot); });
    if (filled.length >= ART_SLOTS.length || filled.some(function (slot) { return String(props[slot]).indexOf(ART_PREFIX) !== 0; })) return null;
    return ART_SLOTS.filter(function (slot) { return artBlank(props, slot); })[0];
  }
  function artDouble(item) {
    var text = ((item.options_with_values || []).map(function (o) { return o && o.value; }).join(' ') + ' ' + ((item.properties || {})['# of Sides Printed'] || '')).toLowerCase();
    return text.indexOf('double sided') !== -1;
  }
  function artAddSlot(card, item, index) {
    var slot = artEmptySlot(item);
    if (!ART_ADD_ON || !slot || !item.handle || !artAllowed(item) || card.querySelector('.ffc-art-add')) return;
    var fold = card.querySelector('.ffc-fold-art');
    var none = artNone(item);
    /* no art: the fold has no list yet; one file: its list is there */
    if (!fold || (none ? fold.querySelector('.ffc-art') : !fold.querySelector('.ffc-art'))) return;
    var tok = card._ffTok;
    edLoadTags(item.handle).then(function () {
      /* (d) a newer scan of this card started meanwhile (another cart): it draws its own */
      if (card._ffTok !== tok) return;
      var names = artAddSet(item);
      if (!card.isConnected || card.querySelector('.ffc-art-add') || !names || names.indexOf(slot) === -1) return;
      var ref = edRef(card);
      var num = /^flag (\d{1,2})$/.exec(ref);
      var text = none ? 'Add artwork' : artDouble(item) ? 'Add side ' + slot.slice(-1) : 'Add another file';
      var link = document.createElement('a');
      link.className = 'ffc-art-add' + (none ? '' : ' ffc-art-add--more');
      link.href = artPreview('/products/' + encodeURIComponent(item.handle) + '?ff_art=' + slot + '&ff_add=1&ff_line=' + encodeURIComponent(item.key) + '&ff_i=' + index + (num ? '&ff_n=' + num[1] : ''));
      link.textContent = text;
      link.setAttribute('aria-label', text + ' for ' + ref);
      fold.appendChild(link);
    }).catch(function (error) { console.warn('[ff-cart] Add artwork not shown (fail closed): ' + error.message); });
  }

  /* ---------- cart side: the control on each card ---------- */
  function artScan(cards, cart) {
    var items = (cart && cart.items) || [];
    cards.forEach(function (card) {
      if (!card.isConnected) return;
      artNotice(card);
      if (card.querySelector('.ffc-art-chg') || card.querySelector('.ffc-art-add') || card._ffArt) return;
      var flagKey = card.getAttribute('data-ff-keys').split(',')[0];
      var index = -1;
      items.forEach(function (item, i) { if (index === -1 && item.key === flagKey) index = i; });
      if (index === -1) return;
      var item = items[index];
      var slots = artSlots(item);
      if (!slots.length) { artAddSlot(card, item, index); return; }
      if (!item.handle || !artAllowed(item)) return;
      var ref = edRef(card);
      /* the card's own "FLAG N" number, shown on the Change artwork screen only (label text; the swap never uses it) */
      var num = /^flag (\d{1,2})$/.exec(ref);
      slots.forEach(function (slot) {
        var value = item.properties[slot];
        var view = null;
        /* the first file row with this link that has no Change yet (two slots holding the same link get one each) */
        card.querySelectorAll('.ffc-art-v').forEach(function (link) {
          var own = link.closest('.ffc-art-c');
          if (!view && link.getAttribute('href') === value && own && !own.querySelector('.ffc-art-x')) view = link;
        });
        var cell = view && view.closest('.ffc-art-c');
        if (!cell) return;
        var label = slots.length === 2 ? 'Change image ' + slot.slice(-1) : 'Change artwork';
        var href = artPreview('/products/' + encodeURIComponent(item.handle) + '?ff_art=' + slot + '&ff_line=' + encodeURIComponent(item.key) + '&ff_i=' + index + (num ? '&ff_n=' + num[1] : ''));
        /* S1c (Todd 2026-10-08: "maybe we should have a separate area or a separate button to edit the images ... Put on your
           customer hat"): "Change" sits right next to View / Download under each artwork thumbnail on EVERY flag card, always
           tappable; it is no longer inside "Edit this flag" (that panel is design help, stitching and finishing only) */
        var wrap = document.createElement('span');
        wrap.className = 'ffc-art-x';
        var dot = document.createElement('span');
        dot.className = 'ffc-art-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '·';
        var link = document.createElement('a');
        link.className = 'ffc-link ffc-art-chg';
        link.href = href;
        link.textContent = 'Change';
        link.setAttribute('aria-label', label + ' for ' + ref);
        wrap.appendChild(dot);
        wrap.appendChild(link);
        /* code audit 4: the cell clips with an ellipsis; with Change in it, it wraps instead, so on narrow three-across cells
           "· Change" drops under View / Download as one piece and is never cut off */
        cell.classList.add('ffc-art-has-chg');
        cell.appendChild(wrap);
      });
      /* (e) one file uploaded: offer the second spot */
      if (slots.length === 1) artAddSlot(card, item, index);
    });
  }
  function artNotice(card) {
    if (!artDone) return;
    if (Date.now() > artDone.until) { artDone = null; return; }
    if (card.getAttribute('data-ff-keys').split(',')[0] !== artDone.key || card.querySelector('.ffc-art-msg')) return;
    var msg = document.createElement('p');
    msg.className = 'ffc-art-msg';
    msg.textContent = artDone.added ? 'Artwork added' : 'Artwork updated';
    var line = card.querySelector('[data-ff-artline]');
    if (line) { line.appendChild(msg); return; }
    var spot = card.querySelector('.ffc-art-v');
    var list = spot && spot.closest('ul');
    if (list) list.parentNode.insertBefore(msg, list.nextSibling);
    else card.appendChild(msg);
  }
  /* back from a successful change: the drawer opens and the card says so (the page that sent us here is the referrer) */
  function artReturn() {
    if (!ART_ON || document.referrer.indexOf('ff_art=') === -1) return;
    var saved = null;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(ART_DONE) || 'null');
      window.sessionStorage.removeItem(ART_DONE);
    } catch (error) { saved = null; }
    if (!saved || !saved.at || Date.now() - saved.at > 120000) return;
    /* "Back to cart" on the Change artwork screen saves { back: true }: the drawer opens, nothing is announced */
    var back = saved.back === true;
    if (!back && typeof saved.key !== 'string') return;
    if (!back) artDone = { key: saved.key, until: Date.now() + 15000, added: saved.added === true };
    /* Cart K2 (Todd's phone 2026-10-21: "When you edit something, like adding another photo, it brings you right back to the cart.
       It needs to keep you in that area, and then you need to be able to press Done, which then brings you back to the cart."):
       every artwork link lives in the flag's Edit screen, so coming back (Use this artwork = the line's new key; Back to cart = its
       unchanged key) opens that flag's Edit screen again, found by its line key (crReopen want.keys). */
    if (typeof saved.key === 'string' && saved.key) {
      crOpen = { page: !!document.getElementById('main-cart-items'), keys: [saved.key] };
      var reopenTries = 0;
      (function reopenSoon() {
        window.setTimeout(function () {
          try { crReopen(); } catch (error) { console.error('[ff-cart] could not open the Edit screen again after the artwork screen: ' + error.message); }
          /* the drawer may still be opening (its cards render with it): try a few times, then give up quietly */
          if (crOpen && crOpen.keys && ++reopenTries < 8) reopenSoon();
        }, 400);
      })();
    }
    /* cart-drawer.js loads after this file (both defer), so the drawer can only open once its element is defined
       (A9 test 2026-10-08: calling it here at once left the drawer closed) */
    function openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (document.getElementById('main-cart-items') || !drawer || typeof drawer.open !== 'function') return;
      try { drawer.open(); } catch (error) { console.warn('[ff-cart] change artwork: the drawer did not open: ' + error.message); }
    }
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(function () { window.setTimeout(openDrawer, 0); }, function () {});
    } else {
      openDrawer();
    }
    if (back) return;
    announce(artDone.added ? 'Artwork added.' : 'Artwork updated.');
    edScan();
  }

  /* ---------- product page in change mode ---------- */
  function artParams() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (error) { return null; }
    var slot = params.get('ff_art');
    var key = params.get('ff_line') || '';
    var index = params.get('ff_i') || '';
    if (ART_SLOTS.indexOf(slot) === -1 || !/^\d+:[0-9A-Za-z]+$/.test(key) || !/^\d{1,4}$/.test(index)) return null;
    var num = params.get('ff_n') || '';
    /* (c) add mode: an EMPTY slot of the flag ((e): Image-1 when it has none, the other slot when it has one) */
    var add = params.get('ff_add');
    if (add !== null && (add !== '1' || !ART_ADD_ON)) return null;
    return { slot: slot, key: key, index: Number(index), num: /^[1-9]\d?$/.test(num) ? num : '', add: add === '1' };
  }
  function artCant() { return (artState && artState.add) || /[?&]ff_add=/.test(window.location.search) ? ART_MSG_CANT_ADD : ART_MSG_CANT; }
  function artIsAdd(url) { return /\/cart\/add/i.test(String(url == null ? '' : url)); }
  function artRefuse(what) {
    console.warn('[ff-cart] change artwork: ' + what + ' refused (adding to cart is off while artwork is being changed)');
  }
  /* A4: no second flag, ever. Installed before anything else on the page can use it (this script runs before DOMContentLoaded). */
  function artGuard() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
        if (artMode && artIsAdd(url)) {
          artRefuse('an add to cart (fetch)');
          return Promise.reject(new Error('Adding to cart is turned off while you change artwork.'));
        }
        return nativeFetch.apply(window, arguments);
      };
    }
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ffArtAdd = artIsAdd(url);
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (artMode && this.__ffArtAdd) {
        artRefuse('an add to cart (XHR)');
        throw new Error('Adding to cart is turned off while you change artwork.');
      }
      return xhrSend.apply(this, arguments);
    };
    var formSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (artMode && artIsAdd(this.getAttribute('action'))) { artRefuse('a product form submit'); return; }
      return formSubmit.apply(this, arguments);
    };
    if (HTMLFormElement.prototype.requestSubmit) {
      var formRequest = HTMLFormElement.prototype.requestSubmit;
      HTMLFormElement.prototype.requestSubmit = function () {
        if (artMode && artIsAdd(this.getAttribute('action'))) { artRefuse('a product form submit'); return; }
        return formRequest.apply(this, arguments);
      };
    }
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!artMode || !form || !form.getAttribute || !artIsAdd(form.getAttribute('action'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      artRefuse('a product form submit');
    }, true);
    window.addEventListener('keydown', function (event) {
      if (!artMode || event.key !== 'Enter') return;
      var target = event.target;
      if (target && target.closest && target.closest('.ff-artmode')) return;
      var form = target && (target.form || (target.closest && target.closest('form')));
      if ((form && artIsAdd(form.getAttribute('action'))) || (target && target.closest && target.closest(ART_BUY))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        artRefuse('Enter in the product form');
      }
    }, true);
    ['click', 'pointerdown', 'touchstart'].forEach(function (type) {
      window.addEventListener(type, function (event) {
        var target = event.target;
        if (!artMode || !target || !target.closest || target.closest('.ff-artmode') || !target.closest(ART_BUY)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (type === 'click') artRefuse('a click on an add / buy control');
      }, { capture: true, passive: false });
    });
    window.addEventListener('beforeunload', function (event) {
      if (!artBusy) return;
      event.preventDefault();
      event.returnValue = '';
    });
  }
  function artDisable() {
    document.querySelectorAll(ART_BUY).forEach(function (node) {
      if (node.closest('.ff-artmode')) return;
      if ('disabled' in node) node.disabled = true;
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('inert', '');
      node.style.setProperty('display', 'none', 'important');
    });
  }
  function artStyle() {
    var style = document.createElement('style');
    style.textContent = ART_BUY + '{display:none!important;pointer-events:none!important}';
    document.head.appendChild(style);
  }
  function artSay(text) {
    if (!artState || !artState.status) return;
    artState.status.textContent = text;
    artState.status.hidden = !text;
  }
  /* ---------- the preview of an uploaded picture (S3: every product page; the Change artwork screen uses it too) ----------
     Uploadery itself makes a 250 px wide copy of a picture upload (jpg jpeg png gif bmp webp) named
     https://uploadery.s3.theshoppad.net/festflags/preview_<the whole last part of the file link>, and fires "previewSuccess"
     on that upload box with detail.preview = its link (Uploadery's own doc "Add an image preview to the product page"; its
     code fires it with bubbles). The file upload and the preview upload run side by side, so either event can come first and
     a late preview of an EARLIER upload can arrive after the next file: each box keeps every preview it was given (a set) and
     shows one only when it equals previewOf(<that box's LATEST uploadSuccess link>). Picking a new file in a box (its file
     input's change) forgets that box's file and previews and removes its preview, so a PDF after a picture, or a failed
     upload, never leaves the old picture showing. Product pages only, three listeners, no request: the picture loads only
     after the customer uploads it (plan audit 1, C1-C2). */
  var ART_RASTER = /\.(jpe?g|png|gif|bmp|webp)$/i;
  function artPreviewOf(link) {
    if (typeof link !== 'string' || link.indexOf(ART_PREFIX) !== 0) return '';
    var clean = link.split('?')[0].split('#')[0];
    var file = clean.slice(clean.lastIndexOf('/') + 1);
    if (!file || file.indexOf('preview_') === 0 || !ART_RASTER.test(file)) return '';
    return clean.slice(0, clean.length - file.length) + 'preview_' + file;
  }
  function upBox(node) { return node && node.matches && node.matches('form[data-uploadery]') ? node : null; }
  function upForget(box) {
    box._ffUpFile = '';
    box._ffUpPrevs = {};
    upDraw(box);
  }
  /* the "got it" bar under an upload box (Todd 2026-10-08: "not showing the preview on the vector art is a little weird";
     "Please watch for your mockup in the next few hours and approve it or ask for changes"; "PDF, AI, EPS, SVG, and pictures.
     Keep the preview"; "the same colored bar with the black-to-purple gradient and the teal or white accent"). Pictures: the
     bar at once, then Uploadery's small preview above it when it arrives. Design files (PDF, AI, EPS, SVG): the bar with a
     file-type tile. Any other file type: the same bar saying "Uploaded" + its name, no mock-up line. */
  var ART_DESIGN = /\.(pdf|ai|eps|svg)$/i;
  var UP_TITLE = '✓ Got your design file!';
  var UP_LINE = 'Please watch for your mock-up in the next few hours — approve it or ask for changes.';
  function upDraw(box) {
    var file = box._ffUpFile || '';
    var ours = file.indexOf(ART_PREFIX) === 0;
    var want = ours ? artPreviewOf(file) : '';
    var have = want && box._ffUpPrevs && box._ffUpPrevs[want] ? want : '';
    var name = ours ? artName(file) : '';
    var kind = !ours ? '' : (want ? 'picture' : (ART_DESIGN.test(name) ? 'design' : 'file'));
    var key = kind ? kind + ':' + file + ':' + have : '';
    var old = box._ffUpView;
    if (!key) {
      if (old && old.parentNode) old.parentNode.removeChild(old);
      box._ffUpView = null;
      if (box._ffUpHook) box._ffUpHook(null);
      return;
    }
    if (old && old.isConnected && old.getAttribute('data-ff-prev') === key) return;
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var view = document.createElement('div');
    view.className = 'ff-up-view';
    view.setAttribute('data-ff-prev', key);
    if (have) {
      var boxes = Array.prototype.slice.call(document.querySelectorAll('form[data-uploadery]'));
      var shot = document.createElement('div');
      shot.className = 'ff-up-prev';
      var img = document.createElement('img');
      img.alt = 'Preview of your uploaded artwork' + (boxes.length > 1 ? ', upload ' + (boxes.indexOf(box) + 1) : '');
      img.decoding = 'async';
      img.onerror = function () { if (shot.parentNode) shot.parentNode.removeChild(shot); };
      img.src = have;
      shot.appendChild(img);
      view.appendChild(shot);
    }
    var bar = document.createElement('div');
    bar.className = 'ff-up-note';
    bar.setAttribute('role', 'status');
    var badge = document.createElement('span');
    badge.setAttribute('aria-hidden', 'true');
    if (kind === 'picture') {
      badge.className = 'ff-up-check';
      badge.textContent = '✓';
    } else {
      badge.className = 'ff-up-tile';
      badge.textContent = name.lastIndexOf('.') > 0 ? name.slice(name.lastIndexOf('.') + 1).slice(0, 4).toUpperCase() : 'FILE';
    }
    var text = document.createElement('div');
    var title = document.createElement('b');
    var line = document.createElement('span');
    if (kind === 'file') {
      title.textContent = '✓ Uploaded';
      line.className = 'ff-up-name';
      line.textContent = name;
    } else {
      /* the round teal check already says it for pictures; the tile ones keep the check in the title */
      title.textContent = kind === 'picture' ? UP_TITLE.replace(/^✓ /, '') : UP_TITLE;
      line.className = 'ff-up-line';
      line.textContent = UP_LINE;
    }
    text.appendChild(title);
    text.appendChild(line);
    bar.appendChild(badge);
    bar.appendChild(text);
    view.appendChild(bar);
    box._ffUpView = view;
    if (box._ffUpHook) { box._ffUpHook(view); return; }
    if (box.parentNode) box.parentNode.insertBefore(view, box.nextSibling);
  }
  /* S1e (Todd 2026-10-08: "Image 2 is first, and image 1 is second ... Can we correct that and make sure that all products are
     producing the correct sequence"): Uploadery PREPENDS each new hidden properties[Image-N] field to the product form, so a
     second upload lands above the first and the cart line / order list Image-2 before Image-1. Right after each upload the
     fields are put back in number order (Image-1, Image-2, ...) in the same place. Only when they all share one parent;
     names and values never change. */
  function upOrder() {
    var fields = Array.prototype.slice.call(document.querySelectorAll('input[name^="properties[Image-"]')).filter(function (field) {
      return /^properties\[Image-\d+\]$/.test(field.name);
    });
    if (fields.length < 2) return;
    var parent = fields[0].parentNode;
    if (!parent || fields.some(function (field) { return field.parentNode !== parent; })) return;
    var num = function (field) { return Number(/(\d+)\]$/.exec(field.name)[1]); };
    var sorted = fields.slice().sort(function (a, b) { return num(a) - num(b); });
    if (sorted.every(function (field, i) { return field === fields[i]; })) return;
    var mark = document.createComment('ff-image-order');
    parent.insertBefore(mark, fields[0]);
    sorted.forEach(function (field) { parent.insertBefore(field, mark); });
    parent.removeChild(mark);
  }
  function upPreviewInit() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    function safe(fn) { try { fn(); } catch (error) { console.warn('[ff-cart] upload preview: ' + error.message); } }
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'file' || !input.closest) return;
      var box = input.closest('form[data-uploadery]');
      if (box) safe(function () { upForget(box); });
    }, true);
    document.addEventListener('uploadSuccess', function (event) {
      var box = upBox(event.target);
      var file = event.detail && event.detail.file;
      if (!box || typeof file !== 'string') return;
      box._ffUpFile = file;
      safe(upOrder);
      safe(function () { upDraw(box); });
    }, true);
    document.addEventListener('previewSuccess', function (event) {
      var box = upBox(event.target);
      var link = event.detail && event.detail.preview;
      if (!box || typeof link !== 'string' || link.indexOf(ART_PREFIX) !== 0) return;
      box._ffUpPrevs = box._ffUpPrevs || {};
      box._ffUpPrevs[link] = true;
      safe(function () { upDraw(box); });
    }, true);
  }

  /* ---------- the Change artwork screen (S1): the product page in change mode shows only these panels and the slot's box ---------- */
  function artThumb(link, alt) {
    /* the current file: Uploadery's small preview copy first, then the file itself (pictures only), then a file-type tile */
    var box = document.createElement('div');
    box.className = 'ff-artmode__thumb';
    var name = artName(link);
    var ext = name.lastIndexOf('.') > 0 ? name.slice(name.lastIndexOf('.') + 1).slice(0, 4).toUpperCase() : '';
    var tile = document.createElement('span');
    tile.className = 'ff-artmode__tile';
    tile.setAttribute('aria-hidden', 'true');
    tile.textContent = ext || 'FILE';
    box.appendChild(tile);
    if (ART_RASTER.test(name) && artPreviewOf(link)) {
      var img = document.createElement('img');
      img.alt = alt;
      img.decoding = 'async';
      var tries = [artPreviewOf(link)].filter(Boolean);   /* the small copy only: never the full print file on a phone */
      img.onload = function () { tile.hidden = true; };
      img.onerror = function () {
        tries.shift();
        if (tries.length) img.src = tries[0];
        else if (img.parentNode) img.parentNode.removeChild(img);
      };
      img.src = tries[0];
      box.appendChild(img);
    }
    return box;
  }
  function artBanner(state, up) {
    var top = document.createElement('div');
    top.className = 'ff-artmode ff-artmode--top ff-art-keep';
    top.setAttribute('role', 'region');
    top.setAttribute('aria-labelledby', 'FFArtTitle');
    var title = document.createElement('h2');
    title.id = 'FFArtTitle';
    title.className = 'ff-artmode__title';
    title.textContent = state.add ? 'Add artwork' : 'Change artwork';
    var flag = document.createElement('p');
    flag.className = 'ff-artmode__flag';
    flag.textContent = state.num ? 'Flag ' + state.num : '';
    flag.hidden = !state.num;
    var now = document.createElement('div');
    now.className = 'ff-artmode__now';
    now.hidden = true;
    var lead = document.createElement('p');
    lead.className = 'ff-artmode__lead';
    lead.textContent = (state.add ? 'Upload your file below.' : 'Upload your new file below.') + ' Nothing in your cart changes until you tap Use this artwork.';
    top.appendChild(title);
    top.appendChild(flag);
    top.appendChild(now);
    top.appendChild(lead);

    var bottom = document.createElement('div');
    bottom.className = 'ff-artmode ff-artmode--bottom ff-art-keep';
    var status = document.createElement('p');
    status.className = 'ff-artmode__msg';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    var pick = document.createElement('div');
    pick.className = 'ff-artmode__pick';
    pick.hidden = true;
    var pickLabel = document.createElement('small');
    pickLabel.textContent = 'New artwork';
    var shot = document.createElement('div');
    shot.className = 'ff-artmode__shot';
    var file = document.createElement('p');
    file.className = 'ff-artmode__file';
    pick.appendChild(pickLabel);
    pick.appendChild(shot);
    pick.appendChild(file);
    var bar = document.createElement('div');
    bar.className = 'ff-artmode__bar';
    var use = document.createElement('button');
    use.type = 'button';
    use.className = 'button ff-artmode__use';
    use.textContent = 'Use this artwork';
    use.disabled = true;
    var back = document.createElement('a');
    back.className = 'button button--secondary ff-artmode__back';
    back.href = artBack();
    back.textContent = 'Back to cart';
    var again = document.createElement('button');
    again.type = 'button';
    again.className = 'button ff-artmode__again';
    again.textContent = 'Start again';
    again.hidden = true;
    again.addEventListener('click', function () { if (!artBusy) window.location.reload(); });
    bar.appendChild(use);
    bar.appendChild(again);
    bar.appendChild(back);
    bottom.appendChild(status);
    bottom.appendChild(pick);
    bottom.appendChild(bar);

    state.top = top;
    state.box = bottom;
    state.status = status;
    state.pick = pick;
    state.shot = shot;
    state.file = file;
    state.use = use;
    state.again = again;
    state.flag = flag;
    state.now = now;
    state.lead = lead;
    use.addEventListener('click', function () {
      if (!state.link || state.closed || state.stuck || artBusy) return;
      /* Uploadery has no "file removed" event: the form must still hold exactly the accepted link */
      var fields = document.getElementsByName('properties[' + state.slot + ']');
      if (fields.length !== 1 || fields[0].value !== state.link) {
        artClear(state);
        artSay(ART_MSG_AGAIN);
        return;
      }
      artUse(state, state.link);
    });
    back.addEventListener('click', function (event) {
      if (artBusy) { event.preventDefault(); return; }
      /* Cart K2: the flag's line key too, so its Edit screen opens again on the way back (artReturn) */
      try { window.sessionStorage.setItem(ART_DONE, JSON.stringify({ back: true, at: Date.now(), key: (state && state.key) || null })); } catch (error) { /* the drawer just won't open by itself */ }
    });
    /* around the slot's upload box, never inside a product form (its buttons would be hidden with the form's) */
    if (up && up.parentNode && !up.closest('form')) {
      up.parentNode.insertBefore(top, up);
      up.parentNode.insertBefore(bottom, up.nextSibling);
      return;
    }
    var anchor = up || document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
    if (anchor && anchor.closest('form')) anchor = anchor.closest('form');
    var host = anchor && anchor.parentNode ? anchor.parentNode : (document.querySelector('main') || document.body);
    var before = anchor && anchor.parentNode ? anchor : host.firstChild;
    host.insertBefore(top, before);
    host.insertBefore(bottom, before);
  }
  function artClear(state) {
    state.link = null;
    if (state.use) state.use.disabled = true;
    if (state.pick) state.pick.hidden = true;
    if (state.file) state.file.textContent = '';
  }
  /* only the panels and the slot's box: marks the product section, the info column and the Uploadery block; CSS
     (html.ff-art-focus) hides the rest of the page's main part. Another layout = no focus: the page stays as F1b drew it
     (panels shown, every add / buy control hidden), never a blank page. */
  function artLayout(up) {
    var info = up && up.closest('.product__info-container');
    var section = info && info.closest('main > *');
    if (!info || !section || up.closest('form')) return false;
    var keep = up;
    while (keep.parentNode && keep.parentNode !== info) keep = keep.parentNode;
    if (keep.parentNode !== info) return false;
    section.classList.add('ff-art-sec');
    info.classList.add('ff-art-info');
    keep.classList.add('ff-art-keep');
    document.documentElement.classList.add('ff-art-focus');
    return true;
  }
  /* the slot's own Uploadery box: the boxes on the page, in order, must be exactly one Uploadery option set's uploads (by id,
     in order), so box N is that set's upload N. (custom-flags' "Upload Set 1" gives Image-1 and Image-2 the SAME id, so the id
     alone cannot tell them apart.) Anything ambiguous = not found. */
  function artFind(slot) {
    var config = window.ShoppadUploaderyConfig && window.ShoppadUploaderyConfig.optionSets ? window.ShoppadUploaderyConfig : { optionSets: ART_UPLOAD_SETS };
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('form[data-uploadery]')).filter(function (node) {
      return !!node.querySelector('input[type="file"]');
    });
    if (!config || !config.optionSets || !wrappers.length) return null;
    var ids = wrappers.map(function (node) { return node.getAttribute('data-uploadery-input-id') || ''; });
    var names = null;
    var clash = false;
    (config.optionSets || []).forEach(function (set) {
      var uploads = (set && set.uploads) || [];
      var setIds = uploads.map(function (upload) { return typeof upload.id === 'string' ? upload.id : (upload.id && upload.id.$oid) || ''; });
      if (setIds.length !== ids.length || setIds.some(function (id, i) { return !id || id !== ids[i]; })) return;
      var these = uploads.map(function (upload) { return upload.name; });
      if (names && names.join('|') !== these.join('|')) clash = true;
      names = these;
    });
    if (!names || clash) return null;
    var at = names.indexOf(slot);
    if (at === -1 || names.lastIndexOf(slot) !== at) return null;
    return { wrapper: wrappers[at], wrappers: wrappers };
  }
  function artLock(state, on) {
    if (!state.wrapper) return;
    state.wrapper.style.pointerEvents = on ? 'none' : '';
    state.wrapper.querySelectorAll('input[type="file"]').forEach(function (input) { input.disabled = on; });
  }
  function artLineOk(line, state) {
    return !!line && line.key === state.key && (state.add ? artEmptySlot(line) === state.slot : artSlots(line).indexOf(state.slot) !== -1) && artAllowed(line)
      && line.handle === handleOf(window.location.pathname);
  }
  function artModeStart() {
    var state = artParams();
    var root = document.documentElement;
    artMode = true;
    artGuard();
    root.classList.add('ff-art-on');
    /* (e) audit E fix: ff-art-js = this script really started change mode; without it the snippet's early ff-art-on is undone */
    root.classList.add('ff-art-js');
    /* the page's main part stays hidden until the screen is drawn (no flash of the full product page). (e) Todd 2026-10-11:
       "the Change Artwork page comes up, and then the uploadery ... kind of flickers also": it now stays hidden (a small
       "Loading" note shows) until the slot's own upload box is found and on screen, or a message replaces it; never longer
       than 9 s (the box search gives up at 8 s with the email message) */
    var waiting = false;
    var parts = {};
    /* shown once the slot's box is on screen AND the cart read has drawn the panel (flag line + current artwork) */
    function reveal(part) {
      parts[part] = true;
      if (parts.box && parts.cart) root.classList.add('ff-art-ready');
    }
    window.setTimeout(function () { root.classList.add('ff-art-ready'); }, 9000);
    function ready() {
      try {
        artStyle();
        artDisable();
        /* the slot's box must STAY on screen (another app could hide it later): re-checked with every artDisable pass */
        function seen() {
          if (!state || state.closed || !state.wrapper) return;
          if (!state.wrapper.getClientRects().length) { state.wrapper = null; cannot(artCant()); }
        }
        [1000, 3000, 8000, 12000].forEach(function (wait) { window.setTimeout(function () { artDisable(); seen(); }, wait); });
        artState = state || {};
        var up = document.getElementById('uploadery-container');
        artBanner(artState, up);
        function cannot(message) {
          artState.closed = true;
          root.classList.add('ff-art-ready');
          root.classList.add('ff-art-closed');
          artClear(artState);
          if (artState.lead) artState.lead.hidden = true;
          if (artState.use) artState.use.hidden = true;
          document.querySelectorAll('form[data-uploadery]').forEach(function (node) { node.hidden = true; node.style.setProperty('display', 'none', 'important'); });
          artSay(message);
        }
        if (!state) { cannot(artCant()); return; }
        artLayout(up);
        /* the one cart read of this screen: the line must still be there as the cart showed it */
        edCart().then(function (cart) {
          var line = (cart.items || [])[state.index];
          if (!artLineOk(line, state)) { cannot(ART_MSG_CHANGED); return; }
          var values = (line.options_with_values || []).map(function (one) { return one && one.value; })
            .filter(function (value) { return value && value !== 'Default Title'; });
          state.flag.textContent = [state.num ? 'Flag ' + state.num : ''].concat(values).filter(Boolean).join(' · ');
          state.flag.hidden = !state.flag.textContent;
          reveal('cart');
          if (state.add) return;   /* (c) nothing to show as "Current artwork" */
          var label = document.createElement('small');
          label.textContent = 'Current artwork';
          state.now.appendChild(label);
          state.now.appendChild(artThumb(line.properties[state.slot], 'Your current artwork'));
          state.now.hidden = false;
        }, function () { cannot(ART_MSG_READ); });
        var started = Date.now();
        waiting = true;
        (function look() {
          if (state.closed) return;
          var found;
          try { found = artFind(state.slot); } catch (error) {
            console.warn('[ff-cart] change artwork: ' + error.message);
            cannot(artCant());
            return;
          }
          if (!found) {
            if (Date.now() - started < 8000) { window.setTimeout(look, 250); return; }
            cannot(artCant());
            return;
          }
          state.wrapper = found.wrapper;
          /* (e) CSS shows only this box in change mode (no flash of the other one) */
          state.wrapper.classList.add('ff-art-slot');
          /* Cart K2 (Todd 2026-10-21: the Change artwork upload "doesn't have that custom meter that the normal product has"): the
             box gets the product page's card look (assets/ff-cart.css); its title, the way the product page names the boxes */
          state.wrapper.setAttribute('data-ff-side', state.slot === 'Image-2' ? 'Back artwork' : 'Front artwork');
          var sideLabel = state.wrapper.querySelector('label');
          if (sideLabel) sideLabel.setAttribute('data-ff-side', state.wrapper.getAttribute('data-ff-side'));
          found.wrappers.forEach(function (node) {
            if (node !== found.wrapper) { node.hidden = true; node.style.setProperty('display', 'none', 'important'); }
          });
          /* C3: the slot's box must really be on screen once the layout is applied, never a screen with no box and no word */
          if (!state.wrapper.getClientRects().length) {
            root.classList.remove('ff-art-focus');
            if (!state.wrapper.getClientRects().length) { state.wrapper = null; cannot(artCant()); return; }
          }
          reveal('box');
          /* the new file's preview goes into the "New artwork" part of the screen, not under the box */
          state.wrapper._ffUpHook = function (view) {
            while (state.shot.firstChild) state.shot.removeChild(state.shot.firstChild);
            if (view) state.shot.appendChild(view);
          };
        })();
        /* a new file was picked in the slot's box: the last accepted one no longer counts until this upload finishes.
           C1b (plan audit 2): Uploadery never cancels an upload, so a SECOND pick while the first is still uploading would let
           the first one finish later, put ITS link back in the form and fire uploadSuccess for it. So a pick while another is
           still on its way = this screen accepts nothing more and asks for a fresh start (one reload of this screen). */
        document.addEventListener('change', function (event) {
          if (!state.wrapper || artBusy || state.closed) return;
          var input = event.target;
          if (!input || input.type !== 'file' || !state.wrapper.contains(input)) return;
          artClear(state);
          /* plan audit 3 F1: a file window closed without a pick starts no upload, but Uploadery drops the form's art field,
             so the last accepted file is forgotten (Use off) without counting as an upload on its way */
          /* code audit 1: once stuck, every later pick keeps the start-again message (nothing more is ever accepted) */
          if (state.stuck) { artSay(ART_MSG_AGAIN_START); return; }
          if (!input.files || !input.files.length) { artSay(''); return; }
          if (state.pending) {
            state.stuck = true;
            artSay(ART_MSG_AGAIN_START);
            if (state.again) state.again.hidden = false;
            if (state.use) state.use.hidden = true;
            return;
          }
          state.pending = true;
          artSay('Uploading your file...');
        }, true);
        /* A4: accept a file only when uploadSuccess fired on THIS slot's box AND the form's properties[<slot>] now holds exactly
           that link (Infinite Options' fieldChange is ignored) */
        document.addEventListener('uploadSuccess', function (event) {
          if (!state.wrapper || artBusy || state.closed) return;
          if (event.target !== state.wrapper) return;
          state.pending = false;
          if (state.stuck) return;
          var link = event.detail && event.detail.file;
          var fields = document.getElementsByName('properties[' + state.slot + ']');
          /* C2b: an upload this screen cannot prove (another link, no field, two fields) says so, never a silent dead button */
          if (typeof link !== 'string' || link.indexOf(ART_PREFIX) !== 0 || fields.length !== 1 || fields[0].value !== link) {
            cannot(artCant());
            return;
          }
          state.link = link;
          state.file.textContent = artName(link);
          state.pick.hidden = false;
          state.use.disabled = false;
          artSay('');
          /* Cart K2 (Todd's phone 2026-10-21: "After changing image it should move screen here so U can click yes easier with out
             scroll"): once the new file is in, "Use this artwork" is brought to the middle of the screen (display only) */
          window.setTimeout(function () {
            try { state.use.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (error) { /* stays where it is */ }
          }, 350);
        }, true);
      } finally {
        /* (e) still looking for the box = it reveals the screen itself; anything else (a message, an error) = show now */
        if (!waiting || (artState && artState.closed)) root.classList.add('ff-art-ready');
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
    else ready();
  }
  function artBack() {
    try {
      var from = new URL(document.referrer);
      if (from.origin === window.location.origin && from.search.indexOf('ff_art=') === -1) return artPreview(from.pathname + from.search);
    } catch (error) { /* no usable referrer */ }
    return artPreview('/cart');
  }
  function artLine(item) { return item.key + '|' + item.quantity + '|' + JSON.stringify(item.properties || {}); }
  /* every other line identical at its same index; the changed line at the same index: same variant, quantity, line discount,
     properties exactly `want`; the cart's discount total unchanged */
  function artProve(snap, cart, index, want) {
    var before = snap.items || [];
    var after = (cart && cart.items) || [];
    if (before.length !== after.length) return false;
    for (var i = 0; i < before.length; i++) {
      if (i !== index && artLine(before[i]) !== artLine(after[i])) return false;
    }
    var was = before[index];
    var now = after[index];
    return !!now && now.variant_id === was.variant_id && now.quantity === was.quantity
      && JSON.stringify(now.properties || {}) === JSON.stringify(want)
      && now.line_level_total_discount === was.line_level_total_discount && cart.total_discount === snap.total_discount;
  }
  function artOrderSame(snap, cart, index) {
    var before = snap.items || [];
    var after = (cart && cart.items) || [];
    if (before.length !== after.length || !after[index] || after[index].variant_id !== before[index].variant_id) return false;
    return before.every(function (item, i) { return i === index || item.key === after[i].key; });
  }
  function artUse(state, link) {
    if (artBusy) return;
    if (typeof link !== 'string' || link.indexOf(ART_PREFIX) !== 0) { artSay(artCant()); return; }
    artBusy = true;
    state.box.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
    artLock(state, true);
    artSay('Changing your artwork...');
    var snap = null;
    var oldProps = null;
    var newProps = null;
    edCart()
      .then(function (cart) {
        snap = cart;
        var line = (cart.items || [])[state.index];
        if (!artLineOk(line, state)) throw { msg: ART_MSG_CHANGED };
        oldProps = line.properties;
        newProps = {};
        Object.keys(oldProps).forEach(function (key) { newProps[key] = key === state.slot ? link : oldProps[key]; });
        /* (c) add mode: the line had no Image-1 key at all, so it is added at the end (readers find it by name) */
        if (!Object.prototype.hasOwnProperty.call(newProps, state.slot)) newProps[state.slot] = link;
        return edPost('/cart/change.js', { id: line.key, quantity: line.quantity, properties: newProps })
          .catch(function (error) { console.warn('[ff-cart] change artwork: change.js said ' + error.message + '; checking the cart'); });
      }, function () { throw { msg: ART_MSG_NOTHING }; })
      .then(function () { return edCart().catch(function () { return edCart(); }); })
      .then(function (cart) {
        if (artProve(snap, cart, state.index, newProps)) return { ok: true, key: cart.items[state.index].key };
        if (artProve(snap, cart, state.index, oldProps)) return { msg: ART_MSG_NOTHING };
        if (!artOrderSame(snap, cart, state.index)) return { msg: ART_MSG_CHECK };
        /* put the old properties back on the line's NEW key, then say only what a fresh read proves */
        return edPost('/cart/change.js', { id: cart.items[state.index].key, quantity: snap.items[state.index].quantity, properties: oldProps })
          .catch(function () { return null; })
          .then(function () { return edCart(); })
          .then(function (after) { return { msg: artProve(snap, after, state.index, oldProps) ? ART_MSG_NOTHING : ART_MSG_CHECK }; }, function () { return { msg: ART_MSG_CHECK }; });
      })
      .catch(function (error) { return { msg: (error && error.msg) || ART_MSG_CHECK }; })
      .then(function (result) {
        artBusy = false;
        if (result.ok) {
          try { window.sessionStorage.setItem(ART_DONE, JSON.stringify({ key: result.key, at: Date.now(), added: !!state.add })); } catch (error) { /* the card just won't say it */ }
          artSay((state.add ? 'Artwork added.' : 'Artwork updated.') + ' Taking you back to your cart...');
          window.location.assign(artBack());
          return;
        }
        state.box.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
        artLock(state, false);
        artClear(state);
        artSay(result.msg);
      });
  }
  upPreviewInit();
  if (ART_ON && window.location.search.indexOf('ff_art=') !== -1 && window.location.pathname.indexOf('/products/') !== -1) artModeStart();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ff-act]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('data-ff-act') === 'cr-close') {
      crCloseSheet(button);
      return;
    }

    var holder = button.closest('[data-ff-keys]');
    var root = button.closest('[data-ff-cart]');
    if (!holder || !root || root.classList.contains('ffc-busy')) return;

    var act = button.getAttribute('data-ff-act');
    /* the control used, for focus after the redraw (Safari does not focus a button on a mouse click, so not only focusin) */
    lastFocus = controlIntent(button);
    if (act === 'note-more') {
      toggleNote(button);
      return;
    }
    if (act === 'note-edit' || act === 'note-save' || act === 'note-cancel') {
      noteAction(act, button, holder, root);
      return;
    }
    if (act === 'date-edit' || act === 'date-save' || act === 'date-cancel') {
      dateAction(act, button, holder, root);
      return;
    }
    if (act === 'delete-ask' || act === 'delete-keep') {
      deleteAsk(act, button);
      return;
    }
    if (act === 'cr-toggle') {
      crToggle(button);
      return;
    }
    /* a FLAG card deletes only from its open confirm; plain product rows (.ffc-other) keep their one-click Remove */
    if (act === 'delete' && holder.classList.contains('ffc-card') && !deleteConfirmed(button)) return;
    if (act === 'delete') crOpen = null;
    var keys = holder.getAttribute('data-ff-keys').split(',').filter(Boolean);
    var current = parseInt(holder.getAttribute('data-ff-qty'), 10);
    var isDesignHelp = act === 'dh-minus' || act === 'dh-plus';
    if (!isDesignHelp && act !== 'delete' && act !== 'plus' && act !== 'minus') return;
    var next = act === 'delete' ? 0 : act === 'plus' ? current + 1 : current - 1;
    if (!keys.length || isNaN(current) || (act === 'minus' && next < 1)) return;

    /* keys[0] is the flag line, the rest are its add-on lines; data-ff-qtys holds each line's OWN quantity.
       An add-on line follows the flag only while its quantity equals the flag's. One the customer lowered
       (design help 1 on 5 flags) keeps its own number, capped at the new flag quantity. Delete sets all to 0. */
    var updates = {};
    if (act === 'delete') {
      keys.forEach(function (key) { updates[key] = 0; });
    } else {
      var qtys = (holder.getAttribute('data-ff-qtys') || '').split(',').map(function (n) { return parseInt(n, 10); });
      var bad = qtys.length !== keys.length || qtys[0] !== current || qtys.some(function (n) { return isNaN(n) || n < 1; });
      if (bad) {
        showError(root, 'Sorry, we could not read the quantities for this flag. Please refresh and try again.');
        return;
      }
      if (isDesignHelp) {
        /* "Design help quantity": ONE add-on line moves one step. Floor 1 (never 0, never removed here),
           ceiling = the flag quantity. The line must be one of THIS card's add-on lines (never the flag line). */
        var lineIndex = keys.indexOf(button.getAttribute('data-ff-line'));
        if (lineIndex < 1) {
          showError(root, 'Sorry, we could not find that design help line. Please refresh and try again.');
          return;
        }
        var nextOwn = qtys[lineIndex] + (act === 'dh-plus' ? 1 : -1);
        if (nextOwn < 1 || nextOwn > current) return;
        updates[keys[lineIndex]] = nextOwn;
      } else {
        keys.forEach(function (key, index) {
          var own = qtys[index];
          updates[key] = index === 0 || own === current ? next : Math.min(own, next);
        });
      }
    }

    if (QTY_ACTS.test(act)) armAnchor(button, act);
    if (act === 'delete') {
      /* (e) the cart is read first (busy meanwhile, so a second tap does nothing) for the Shipping Protection check below */
      var intent = controlIntent(button);
      root.classList.add('ffc-busy');
      delProtection(updates).then(function (fresh) {
        /* audit E / E2 fix: this card's lines are not all in the cart any more (the page is out of date): show the cart as it is */
        if (fresh === 'stale') {
          staleRedraw(root);
          return;
        }
        commit(root, '/cart/update.js', { updates: updates }, intent, delRetry(root, keys, intent));
      });
      return;
    }
    /* (b) + / - / design help: the cart is read first (busy meanwhile). A card is out of date when a line it would send is gone
       OR holds a different quantity than the card shows: Shopify does not refuse an old key whose line was only re-keyed, it
       applies it to ANOTHER line of the same product (proven 2026-10-12: + on flag A's old card added 1 to flag B), and a
       quantity changed elsewhere would be overwritten. Out of date = nothing sent, the real cart is shown. A failed or slow
       read (8 s) = sent as before, with the refusal check behind it. */
    var qtyIntent = controlIntent(button);
    var shown = {};
    keys.forEach(function (key, index) { shown[key] = qtys[index]; });
    root.classList.add('ffc-busy');
    freshCart().then(function (cart) {
      var real = {};
      ((cart && cart.items) || []).forEach(function (item) { real[item.key] = item.quantity; });
      /* audit 1: EVERY line on the card, not only the ones sent: design help + sends only its own line, but its ceiling is the
         flag quantity the card shows (flag lowered elsewhere = design help above the flag = overcharge) */
      var outOfDate = keys.some(function (key) { return !(key in real) || real[key] !== shown[key]; });
      if (outOfDate) {
        console.warn('[ff-cart] ' + act + ': this card was out of date; showing the real cart, nothing sent');
        staleRedraw(root, cart);
        return;
      }
      commit(root, '/cart/update.js', { updates: updates }, qtyIntent, refusedStale(root, Object.keys(updates)));
    }, function (error) {
      console.warn('[ff-cart] ' + act + ': could not read the cart first (' + error.message + '); sending it as it is');
      commit(root, '/cart/update.js', { updates: updates }, qtyIntent, refusedStale(root, Object.keys(updates)));
    });
  });

  /* Cart follow-ups 2026-10-12 (BACKLOG 2026-10-12, audit E3 finding 6). The cards carry their line keys from the last
     redraw; Shopify refuses (422) an update.js that names a key that is gone, and the customer saw "Sorry, we could not update
     your cart" (or, worse, Shopify applied the tap to another flag of the same product; see the click handler).
     (b) +/- and design help: the cart is read before the write (click handler). If Shopify still REFUSES the write (the cart
         changed between that read and the write) and any key the tap sent is gone: "Your cart changed. Showing it again..."
         and the cart is redrawn from the real cart; nothing is re-sent (the tap was meant for the old cart).
         Keys all present = a real refusal (stock, limits): the usual message.
     (c) Delete: Navidium takes its Shipping Protection line out about 1 s after a page loads; a delete sent in that second can
         name the line it just removed. The delete is worked out again from a fresh read and sent ONCE more (a delete is
         safe to repeat: every line goes to 0); a card now out of date redraws as in (b). A second refusal = the usual message. */
  var MSG_CHANGED = 'Your cart changed. Showing it again...';
  function freshCart() {
    /* audit E: a read that hangs must not leave the card busy forever (8 s) */
    var timeout = new Promise(function (resolve, reject) { window.setTimeout(function () { reject(new Error('no answer in 8 s')); }, 8000); });
    return Promise.race([edCart(), timeout]);
  }
  function cartHas(cart) {
    var have = {};
    ((cart && cart.items) || []).forEach(function (item) { have[item.key] = true; });
    return have;
  }
  function staleRedraw(root, cart) {
    showError(root, MSG_CHANGED);
    return (cart ? Promise.resolve(cart) : edCart()).then(edRedraw)
      .then(function () { root.classList.remove('ffc-busy'); }, function () { window.location.reload(); });
  }
  function refusedStale(root, sent) {
    return function () {
      return freshCart().then(function (cart) {
        var have = cartHas(cart);
        if (!sent.some(function (key) { return !have[key]; })) return false;
        console.warn('[ff-cart] cart write refused: the card was out of date; showing the real cart');
        return staleRedraw(root, cart).then(function () { return true; });
      }, function () { return false; });
    };
  }
  function delRetry(root, keys, intent) {
    return function () {
      var again = {};
      keys.forEach(function (key) { again[key] = 0; });
      return delProtection(again).then(function (fresh) {
        if (fresh === 'stale') return staleRedraw(root).then(function () { return true; });
        console.warn('[ff-cart] delete refused once; sending it again from a fresh read of the cart');
        return commit(root, '/cart/update.js', { updates: again }, intent).then(function () { return true; });
      });
    };
  }

  /* Fix build (e), Todd 2026-10-11: "When I go to checkout, then I go back, and I am not able to delete the entire flag"
     ("Sorry, we could not update your cart (Your cart is not valid)"). Check out makes Navidium add its hidden Shipping
     Protection line (product navidium-shipping-protection); it normally takes it out again when the shopper comes back, but
     not always (Todd's screenshot). Deleting the last flag then leaves a cart holding only that line, which Shopify refuses
     with 422 "Your cart is not valid" (reproduced 2026-10-11, both protection variants). So a delete that would leave only
     protection lines removes them in the same update. A failed read changes nothing (the delete is sent as before). */
  var NVD_HANDLE = 'navidium-shipping-protection';
  function delProtection(updates) {
    /* audit E: a read that hangs must not leave the card busy forever (8 s, then the delete is sent as before) */
    return freshCart().then(function (cart) {
      var have = cartHas(cart);
      var mine = Object.keys(updates);
      /* audit E2: ANY of the card's lines missing (re-keyed or removed elsewhere) = the card is out of date; Shopify refuses an
         update.js naming a key that is gone (422), so nothing is sent: the cart is shown again and the next tap deletes */
      if (mine.length && mine.some(function (key) { return !have[key]; })) return 'stale';
      var left = (cart.items || []).filter(function (item) { return !(item.key in updates); });
      if (left.length && left.every(function (item) { return item.handle === NVD_HANDLE; })) {
        left.forEach(function (item) { updates[item.key] = 0; });
      }
    }, function (error) {
      console.warn('[ff-cart] delete: could not read the cart first (' + error.message + '); sending the delete as it is');
    });
  }

  /* Check out on phones, Todd 2026-10-17: "That checkout button is still glitchy … It never works on mobile. It always flickers
     and requires a 2nd tap". Measured on the live theme (tests/checkout-diag/, phone size, real touch tap): Navidium's
     one-time handler on [name="checkout"] cancels the tap, posts its Shipping Protection line (/cart/add.js) and only THEN
     sends the page to /checkout (0.6 s on fast Wi-Fi; seconds on a phone network) while the button shows nothing. The
     shopper taps again; Navidium's handler is used up, so that tap submits the cart form and RESTARTS the page change (the
     flicker); checkout then opens, so it looks like the second tap did it. If Navidium's add fails, the first tap does
     nothing at all. Now: the first tap at once turns the button into "Going to checkout…" (spinner); later taps are swallowed
     while the page is on its way (nothing restarts); if nothing has moved the page 8 s after the tap (audit 5; was 5 s), it goes to
     /checkout itself. The first tap itself is left alone (Navidium and the form run exactly as before). Coming back (Back button,
     page restored) puts the button back. Runs after the Save lock above (registered later), so a locked Check out stays locked. */
  /* Audit 5 (REJECT, one corrective pass): the label and the fallback start only from a listener at the very END of the tap
     (window, bubble phase), so a tap that anything stopped on the way (crHoldTaps after the "Change or remove" panel moves,
     the Save lock, any later checkout gate that stops the click) gets neither. Navidium's cancel (preventDefault) does not stop
     the click from getting here (measured), so the real first tap still gets the label. Only the second-tap swallow stays at
     the START of the tap. The fallback waits 8 s (was 5: a slow Navidium add, or an iPhone that only reports leaving when the
     checkout page arrives) and never fires while a Save runs or once the page has started leaving, whoever started it. */
  var goCheckout = null;
  var pageLeaving = false;
  function goReset() {
    if (!goCheckout) return;
    clearTimeout(goCheckout.fallback);
    clearTimeout(goCheckout.giveUp);
    goCheckout.button.classList.remove('ff-going');
    goCheckout.button.removeAttribute('aria-busy');
    goCheckout.button.querySelectorAll('.ff-going-txt').forEach(function (node) { node.remove(); });
    goCheckout = null;
  }
  function goButton(event) {
    var target = event.target;
    return target && target.closest ? target.closest('[name="checkout"]') : null;
  }
  /* START of the tap: while on its way, a second tap must not restart it */
  window.addEventListener('click', function (event) {
    if (!goCheckout || !goButton(event)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, { capture: true, passive: false });
  /* END of the tap: only a tap that reached here counts */
  window.addEventListener('click', function (event) {
    var button = goButton(event);
    if (!button || button.disabled || edSaving || goCheckout) return;
    goCheckout = { button: button, fallback: 0, giveUp: 0 };
    button.classList.add('ff-going');
    button.setAttribute('aria-busy', 'true');
    var label = document.createElement('span');
    label.className = 'ff-going-txt';
    label.setAttribute('aria-hidden', 'true');
    var ring = document.createElement('span');
    ring.className = 'ff-going-sp';
    label.appendChild(ring);
    label.appendChild(document.createTextNode('Going to checkout…'));
    button.appendChild(label);
    announce('Going to checkout');
    goCheckout.fallback = setTimeout(function () {
      if (!goCheckout || pageLeaving || edSaving) return;
      console.warn('[ff-cart] Check out: the page had not moved 8 s after the tap; going to checkout directly');
      window.location.href = '/checkout';
    }, 8000);
    /* a page change that never completes (network gone, the shopper stopped it) must not leave the button stuck */
    goCheckout.giveUp = setTimeout(goReset, 20000);
  }, false);
  window.addEventListener('beforeunload', function () { pageLeaving = true; });
  window.addEventListener('pagehide', function () { pageLeaving = true; });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { pageLeaving = false; goReset(); } });
})();